// Code generated by balancegen from data/locale/<tag>/*.toml and
// data/contracts/languages.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// One language part of the SOURCE language: some of its tables
// (i18n.md §1.1, R3123). gen/strings.ts imports every part statically
// and joins them, so every page has the English tables with no load.
// The parts keep each build chunk under Vite's limit (deployment.md
// §2.2).
//
// The module imports gen/strings.ts for its types alone. A runtime
// import would make the two chunks import each other.

import type * as S from './strings';

const pluralRules = new Intl.PluralRules('en');

/**
 * Picks the plural variant for a count. The category comes from the
 * platform's CLDR rule for the language of this file, so the file has
 * no rule of its own. `other` is the fallback: it is the one category every language
 * has, and a language that needs no `few` simply has none written.
 */
function plural(n: number, forms: Record<string, string | undefined> & { other: string }): string {
  return forms[pluralRules.select(n)] ?? forms.other;
}

const effects_en: S.Effects = {
  anchor_rings_desc: 'Two rings stand round the Bulwark and take the breath in turn.',
  anchor_rings_how: 'Granted by the operators for a special occasion.',
  anchor_rings_name: 'ANCHOR RINGS',
  aurora_desc: 'Three faint bands drift above the hold, and each band drifts toward white and back.',
  aurora_how: 'Granted by the operators for a special occasion.',
  aurora_name: 'AURORA',
  basilisk_gaze_desc: 'A narrow faint cone stands ahead of the bow of the Basilisk and breathes every nine seconds.',
  basilisk_gaze_how: 'Granted by the operators for a special occasion.',
  basilisk_gaze_name: 'BASILISK GAZE',
  beacon_crown_desc: 'Six pips stand round the Beacon and light in turn, twelve seconds to the round.',
  beacon_crown_how: 'Granted by the operators for a special occasion.',
  beacon_crown_name: 'BEACON CROWN',
  beacon_lantern_desc: 'A soft glow lies over the hold and breathes one time every eight seconds.',
  beacon_lantern_how: 'Granted by the operators for a special occasion.',
  beacon_lantern_name: 'BEACON LANTERN',
  bow_arcs_desc: 'Two small arcs stand ahead of the nose and pulse every two seconds.',
  bow_arcs_how: 'Granted by the operators for a special occasion.',
  bow_arcs_name: 'BOW ARCS',
  bow_shimmer_desc: 'Two lines of grains open astern in a V, the way a lit bow wave opens.',
  bow_shimmer_how: 'Granted by the operators for a special occasion.',
  bow_shimmer_name: 'BOW SHIMMER',
  bubble_breath_desc: 'Small white bubbles leave the hull a few at a time and rise off the track.',
  bubble_breath_how: 'Granted by the operators for a special occasion.',
  bubble_breath_name: 'BUBBLE BREATH',
  bubble_column_desc: 'White bubbles leave the hold a few at a time and rise off the cartouche.',
  bubble_column_how: 'Granted by the operators for a special occasion.',
  bubble_column_name: 'BUBBLE COLUMN',
  bubble_ring_desc: 'A ring of eight bubbles stands round the round and turns slowly.',
  bubble_ring_how: 'Granted by the operators for a special occasion.',
  bubble_ring_name: 'BUBBLE RING',
  bulwark_lattice_desc: 'A hex lattice turns round the Bulwark, one revolution in sixteen seconds.',
  bulwark_lattice_how: 'Granted by the operators for a special occasion.',
  bulwark_lattice_name: 'BULWARK LATTICE',
  cavitation_cloud_desc: 'Three neutral fog blobs leave the round astern, drift wide, and thin away.',
  cavitation_cloud_how: 'Granted by the operators for a special occasion.',
  cavitation_cloud_name: 'CAVITATION CLOUD',
  chase_flare_desc: 'A bright white core runs on the Interceptor with a short tail of four pips.',
  chase_flare_how: 'Granted by the operators for a special occasion.',
  chase_flare_name: 'CHASE FLARE',
  comet_tail_desc: 'A long tail of grains follows the round and thins to nothing behind it.',
  comet_tail_how: 'Granted by the operators for a special occasion.',
  comet_tail_name: 'COMET TAIL',
  compass_rose_desc: 'A faint four-point star lies under the hull and turns one revolution in sixty seconds.',
  compass_rose_how: 'Granted by the operators for a special occasion.',
  compass_rose_name: 'COMPASS ROSE',
  corsair_blaze_desc: 'A soft flare sits at the bow of the Corsair and breathes every six seconds.',
  corsair_blaze_how: 'Granted by the operators for a special occasion.',
  corsair_blaze_name: 'CORSAIR BLAZE',
  crown_desc: 'Six pips sit on the coverage ring of the hold and light in turn, eighteen seconds to the round.',
  crown_how: 'Granted by the operators for a special occasion.',
  crown_name: 'CROWN',
  cutlass_glint_desc: 'A white glint runs along the blade edge of the Cutlass, from the shoulder to the tip.',
  cutlass_glint_how: 'Granted by the operators for a special occasion.',
  cutlass_glint_name: 'CUTLASS GLINT',
  echo_lines_desc: 'Three arcs leave one side of the hold every nine seconds and fade out over the claim.',
  echo_lines_how: 'Granted by the operators for a special occasion.',
  echo_lines_name: 'ECHO LINES',
  ember_bed_desc: 'Small embers glow on the ground at the base of the hold and fade out.',
  ember_bed_how: 'Granted by the operators for a special occasion.',
  ember_bed_name: 'EMBER BED',
  ember_rim_desc: 'The rim of the silhouette drifts from the faction colour toward white and back.',
  ember_rim_how: 'Granted by the operators for a special occasion.',
  ember_rim_name: 'EMBER RIM',
  ember_trail_desc: 'The round sheds dull glow grains astern, and every grain swells and goes out.',
  ember_trail_how: 'Granted by the operators for a special occasion.',
  ember_trail_name: 'EMBER TRAIL',
  falconet_feathers_desc: 'Two feather streaks leave the fins of the Falconet astern and fade slowly.',
  falconet_feathers_how: 'Granted by the operators for a special occasion.',
  falconet_feathers_name: 'FALCONET FEATHERS',
  frost_desc: 'White glints twinkle on the outline of the hull alone, and they scatter slowly.',
  frost_how: 'Granted by the operators for a special occasion.',
  frost_name: 'FROST',
  guardian_rays_desc: 'Six pale spokes stand out of the hold and turn one revolution in sixty seconds.',
  guardian_rays_how: 'Granted by the operators for a special occasion.',
  guardian_rays_name: 'GUARDIAN RAYS',
  halo_desc: 'One soft disc rests under the mark and breathes over six seconds.',
  halo_how: 'Awarded to the season\'s first commander for one season.',
  halo_name: 'HALO',
  halo_round_desc: 'One soft disc lies under the round and breathes one time every four seconds.',
  halo_round_how: 'Granted by the operators for a special occasion.',
  halo_round_name: 'HALO ROUND',
  heartbeat_desc: 'The anchor ring swells with a double beat every eight seconds and then rests.',
  heartbeat_how: 'Granted by the operators for a special occasion.',
  heartbeat_name: 'HEARTBEAT',
  heavy_wake_desc: 'A wide neutral fog wake lies astern of the Heavy and widens behind it.',
  heavy_wake_how: 'Granted by the operators for a special occasion.',
  heavy_wake_name: 'HEAVY WAKE',
  hold_compass_desc: 'A faint four-point star lies under the hold and turns one revolution in ninety seconds.',
  hold_compass_how: 'Granted by the operators for a special occasion.',
  hold_compass_name: 'HOLD COMPASS',
  hold_halo_desc: 'One wide soft disc lies under the whole claim and breathes every eight seconds.',
  hold_halo_how: 'Granted by the operators for a special occasion.',
  hold_halo_name: 'HOLD HALO',
  interceptor_thread_desc: 'A fine dashed thread runs behind the Interceptor, and the dashes walk astern.',
  interceptor_thread_how: 'Granted by the operators for a special occasion.',
  interceptor_thread_name: 'INTERCEPTOR THREAD',
  kelp_drift_desc: 'Two thin strands trail astern of the hull and sway in a slow current.',
  kelp_drift_how: 'Granted by the operators for a special occasion.',
  kelp_drift_name: 'KELP DRIFT',
  kelp_garden_desc: 'Four strands stand round the hold and sway, twenty-four seconds to the sway.',
  kelp_garden_how: 'Granted by the operators for a special occasion.',
  kelp_garden_name: 'KELP GARDEN',
  kraken_ink_desc: 'Five neutral fog rolls turn slowly round the hold at a low alpha.',
  kraken_ink_how: 'Granted by the operators for a special occasion.',
  kraken_ink_name: 'KRAKEN INK',
  lancer_spearhead_desc: 'One pip runs from the stern of the Lancer to the tip every six seconds.',
  lancer_spearhead_how: 'Granted by the operators for a special occasion.',
  lancer_spearhead_name: 'LANCER SPEARHEAD',
  lantern_chain_desc: 'Three white pips trail astern in a line, and every pip is dimmer than the pip in front of it.',
  lantern_chain_how: 'Granted by the operators for a special occasion.',
  lantern_chain_name: 'LANTERN CHAIN',
  lantern_desc: 'A warm glow hangs under the Tender on a short cable and breathes every ten seconds.',
  lantern_how: 'Granted by the operators for a special occasion.',
  lantern_name: 'LANTERN',
  light_lantern_desc: 'A small lamp sits on the nose of the Light and breathes every two seconds.',
  light_lantern_how: 'Granted by the operators for a special occasion.',
  light_lantern_name: 'LIGHT LANTERN',
  lighthouse_desc: 'One pale beam stands out of the hold and turns one revolution in thirty seconds.',
  lighthouse_how: 'Awarded to the best commander of the winning faction for one season.',
  lighthouse_name: 'LIGHTHOUSE',
  moonlight_desc: 'One very faint wide pale disc drifts across the hold, thirty seconds to the pass.',
  moonlight_how: 'Granted by the operators for a special occasion.',
  moonlight_name: 'MOONLIGHT',
  orbiting_sentries_desc: 'Three pips circle the hold on one faint track, thirty seconds to the orbit.',
  orbiting_sentries_how: 'Granted by the operators for a special occasion.',
  orbiting_sentries_name: 'ORBITING SENTRIES',
  pearl_chain_desc: 'Twelve white pips lie on the anchor ring and light in turn.',
  pearl_chain_how: 'Granted by the operators for a special occasion.',
  pearl_chain_name: 'PEARL CHAIN',
  pulse_core_desc: 'The glow of the round breathes one time every three seconds and never goes out.',
  pulse_core_how: 'Granted by the operators for a special occasion.',
  pulse_core_name: 'PULSE CORE',
  ring_chain_desc: 'The round drops small pale rings, and each ring holds its place in the water and fades.',
  ring_chain_how: 'Granted by the operators for a special occasion.',
  ring_chain_name: 'RING CHAIN',
  ring_wake_desc: 'A ring leaves the track of the round every two seconds, spreads, and fades.',
  ring_wake_how: 'Granted by the operators for a special occasion.',
  ring_wake_name: 'RING WAKE',
  sea_glitter_desc: 'Grains twinkle inside the coverage ring of the hold, each one time.',
  sea_glitter_how: 'Granted by the operators for a special occasion.',
  sea_glitter_name: 'SEA GLITTER',
  searchlight_desc: 'A faint pale cone stands ahead of the nose and sways across the track.',
  searchlight_how: 'Granted by the operators for a special occasion.',
  searchlight_name: 'SEARCHLIGHT',
  seeker_eye_desc: 'A faint arc sweeps ahead of the Seeker, the way a search beam sweeps.',
  seeker_eye_how: 'Granted by the operators for a special occasion.',
  seeker_eye_name: 'SEEKER EYE',
  seeker_pulse_desc: 'A ping ring leaves the nose of the Seeker and holds its place while the round runs on.',
  seeker_pulse_how: 'Granted by the operators for a special occasion.',
  seeker_pulse_name: 'SEEKER PULSE',
  sentinel_watch_desc: 'A short accent arc circles the Sentinel one time in twenty seconds.',
  sentinel_watch_how: 'Granted by the operators for a special occasion.',
  sentinel_watch_name: 'SENTINEL WATCH',
  silt_plume_desc: 'Three silt clouds leave the Dredger astern, grow, and thin away.',
  silt_plume_how: 'Granted by the operators for a special occasion.',
  silt_plume_name: 'SILT PLUME',
  spiral_desc: 'White grains twist round the track of the round and thin away astern.',
  spiral_how: 'Granted by the operators for a special occasion.',
  spiral_name: 'SPIRAL',
  spokes_desc: 'Eight dashed spokes run out of the hold and turn one revolution in sixty seconds.',
  spokes_how: 'Granted by the operators for a special occasion.',
  spokes_name: 'SPOKES',
  star_field_desc: 'Grains twinkle over the whole claim and scatter slowly outward.',
  star_field_how: 'Granted by the operators for a special occasion.',
  star_field_name: 'STAR FIELD',
  stardust_wake_desc: 'The hull sheds faint grains astern, and each grain twinkles one time and goes out.',
  stardust_wake_how: 'Granted by the operators for a special occasion.',
  stardust_wake_name: 'STARDUST WAKE',
  third_eye_desc: 'One thin ring stands round the needle of the Oracle and breathes every eight seconds.',
  third_eye_how: 'Granted by the operators for a special occasion.',
  third_eye_name: 'THIRD EYE',
  tidal_pull_desc: 'Grains drift in from the claim toward the hold and go out at the cartouche.',
  tidal_pull_how: 'Granted by the operators for a special occasion.',
  tidal_pull_name: 'TIDAL PULL',
  twin_sprites_desc: 'Two small pips orbit the hull, twenty seconds to the orbit.',
  twin_sprites_how: 'Granted by the operators for a special occasion.',
  twin_sprites_name: 'TWIN SPRITES',
  twin_tails_desc: 'Two short tails of grains open astern in a V, one off each fin.',
  twin_tails_how: 'Granted by the operators for a special occasion.',
  twin_tails_name: 'TWIN TAILS',
};

const fast_en: S.Fast = {
  no_webgl2: 'THIS BROWSER GAVE NO WEBGL2 CONTEXT. THE CLIENT NEEDS ONE.',
  replay_link_silent: 'NO REPLAY CAME FOR THAT LINK. THE FIGHT MAY BE GONE FROM THE COMBAT LOG.',
  signin_already_linked: 'Your account already holds a sign-in method from that provider.',
  signin_identity_taken: 'Another account already signs in with that identity. Sign in as that account, or use a different one.',
  signin_method_off: 'This server does not offer a sign-in with that provider.',
  signin_name_taken: 'Another player already holds that name. Press the button one more time.',
  signin_reauth: 'This change needs a recent sign-in. Press SIGN IN AGAIN on the ACCOUNT page, then link the method once more.',
  signin_refused: 'The sign-in provider did not complete the sign-in. Nothing on your account changed.',
  signin_state: 'The sign-in took too long, or it started in another window. Press the button one more time.',
  signin_unknown: (p: { code: string | number }) => `The sign-in did not finish (${p.code}).`,
};

const format_en: S.Format = {
  anchor_idle: 'ANCHOR',
  anchor_setting: (p: { left: string | number }) => `ANCHORING ${p.left}`,
  anchor_weigh: 'WEIGH ANCHOR',
  anchor_weighing: (p: { left: string | number }) => `WEIGHING ${p.left}`,
  benefit_archive: (p: { pct: string | number }) => `+${p.pct}% research speed`,
  benefit_battery: 'a heavy torpedo tube defends the object',
  benefit_drydock: (p: { repair: string | number; hull: string | number }) => `+${p.repair}% repair speed and +${p.hull}% maximum hull`,
  benefit_forge: (p: { pct: string | number }) => `+${p.pct}% mine income`,
  benefit_kelp: (p: { pct: string | number }) => `+${p.pct}% gather rate`,
  benefit_marshal: (p: { pct: string | number }) => `+${p.pct}% build-queue speed`,
  benefit_short_archive: (p: { pct: string | number }) => `+${p.pct}% research speed`,
  benefit_short_battery: 'heavy torpedo tube',
  benefit_short_drydock: (p: { repair: string | number }) => `+${p.repair}% repair speed`,
  benefit_short_forge: (p: { pct: string | number }) => `+${p.pct}% mine income`,
  benefit_short_kelp: (p: { pct: string | number }) => `+${p.pct}% gather rate`,
  benefit_short_marshal: (p: { pct: string | number }) => `+${p.pct}% build speed`,
  benefit_short_spire: (p: { px: string | number }) => `sonar, ${p.px} px`,
  benefit_short_throne: (p: { pts: string | number }) => `+${p.pts} points an hour`,
  benefit_short_ward: (p: { px: string | number }) => `mends hulls, ${p.px} px`,
  benefit_spire: (p: { px: string | number }) => `a sonar source of ${p.px} px for the holding faction`,
  benefit_throne: (p: { pts: string | number; resist: string | number }) => `${p.pts} season points an hour to every commander, and each gauge hit on it is ${p.resist} lower`,
  benefit_ward: (p: { px: string | number }) => `mends the hulls of the holding faction within ${p.px} px`,
  hold_empty: (p: { cap: string | number }) => `empty (${p.cap})`,
  hold_parts: (p: { parts: string | number; total: string | number; cap: string | number }) => `${p.parts} · ${p.total}/${p.cap}`,
  link_lost: 'CONNECTION LOST',
  link_not_retrying: 'not retrying — reload to reconnect',
  link_reconnecting: 'reconnecting…',
  link_retry_in: (p: { sec: string | number }) => `retrying in ${p.sec}s`,
  quake_tab_floor_moved: (p: { left: string | number }) => `FLOOR SHIFT · ${p.left}`,
  quake_tab_has_won: (p: { left: string | number }) => `SETTLEMENT · ${p.left}`,
  quake_tab_season_over: (p: { left: string | number }) => `NEW SEASON · ${p.left}`,
  quake_tab_war_economy: (p: { left: string | number }) => `WAR ECONOMY · ${p.left}`,
  types_untyped: 'untyped systems',
  unit_approx: (p: { n: string | number }) => `≈ ${p.n}`,
  unit_change: (p: { now: string | number; after: string | number }) => `${p.now} → ${p.after}`,
  unit_held: (p: { n: string | number }) => `×${p.n}`,
  unit_px: (p: { n: string | number }) => `${p.n} px`,
  unit_rate: (p: { n: string | number }) => `${p.n}/h`,
};

const glossary_en: S.Glossary = {
  advisor: 'advisor',
  advisor_def: 'The line above the build queue that names one next step and its reason. A press opens the right row, and you give the order: the advisor gives none.',
  alloy: 'Alloy',
  alloy_def: 'A mined resource that most buildings and hulls cost. The Alloy Mine produces it, and a Dredger gathers it from a deposit.',
  autopilot: 'autopilot',
  autopilot_def: 'The engine that drives every empire nobody sits at. It stops for the season when a player takes command.',
  beacon: 'Beacon',
  beacon_def: 'The support hull class that moves territory. From its own water it beams the cells round it to your faction, one cell at a time.',
  biomass: 'Biomass',
  biomass_def: 'A mined resource that research costs. The Biomass Farm produces it, and a Dredger gathers it from a deposit.',
  build_queue: 'build queue',
  build_queue_def: 'The one line of jobs that your empire works through: buildings, research, ships, torpedoes, repairs and the preparation of a dive.',
  cadet: 'cadet',
  cadet_def: 'A captain that the recruiter offers. A cadet commands nothing until you recruit it.',
  captain: 'captain',
  captain_def: 'An officer with six attributes and a career, who commands a combat fleet. Your captains cross to the next season with you.',
  career_phase: 'career phase',
  career_phase_def: 'The stage of a captain\'s career by age: rise, then peak, then decline. A captain trains in the rise and the peak. In the decline training stops and the captain loses points.',
  cataclysm: 'Cataclysm',
  cataclysm_def: 'The finale of a season. At its end the game awards Honour, frees every prisoner and founds the world again.',
  cell: 'cell',
  cell_def: 'One hexagon of the map. A cell has an owner, a gauge and a kind of terrain.',
  clan: 'clan',
  clan_def: 'Your social home across the seasons. A clan has one faction, and its members deploy by squad.',
  commander: 'commander',
  commander_def: 'Whoever runs one empire: a player, or the autopilot while no player sits at it.',
  contact: 'contact',
  contact_def: 'An enemy fleet that you hear now, through sonar or through a scan.',
  credits: 'Credits',
  credits_def: 'The currency. An idle build queue mints it, and it pays for a rush, the auction and a ransom. The game never sells it for real money.',
  data_core: 'Data Core',
  data_core_def: 'A rare find of an expedition. One core completes research work on the active node at once.',
  deposit: 'deposit',
  deposit_def: 'A field of Alloy, Biomass or Volatiles on the seabed. A Dredger gathers from it, and stage 2 of the seaquake kills it.',
  draft: 'draft',
  draft_def: 'One invention: a hull class and one module of each family you researched. The roll decides the grade of each module, and the draft files a master.',
  dredger: 'Dredger',
  dredger_def: 'The support hull class that gathers resources from a deposit and carries them home.',
  empire: 'empire',
  empire_def: 'Your private half of a world: your resources, buildings, build queue, research, designs, torpedoes, captains and fleets.',
  expedition: 'expedition',
  expedition_def: 'A dive of one captain to one depth. On its return the captain can bring back Isotopes and, by chance, a Data Core.',
  faction: 'faction',
  faction_def: 'The banner that your empire serves. A faction owns territory, and your faction changes only between two seasons.',
  faction_installation: 'faction installation',
  faction_installation_def: 'A structure that a whole faction owns, not one commander. Like a hold, it anchors supply for its faction.',
  fleet: 'fleet',
  fleet_def: 'The unit you command on the map: exactly one hull of one class, with one design. A combat fleet needs a captain to put to sea.',
  frontier: 'frontier',
  frontier_def: 'The boundary between the territory of two factions. It moves as the two factions contest the cells on it.',
  hold: 'hold',
  hold_def: 'Your own base on the seabed. It anchors your supply, guards the water round it and carries your sonar ring.',
  honour: 'Honour',
  honour_def: 'Your lifetime prestige. The season score feeds it at the Cataclysm, and it never decays. It sets your rank title and never a stronger stat.',
  hull: 'hull',
  hull_def: 'The vessel of one fleet. Each hull has a class, for example a Corsair or a Dredger, and the class sets what it can do.',
  isotopes: 'Isotopes',
  isotopes_def: 'A rare resource with no mine. An expedition brings it back, and an invention costs it.',
  keystone: 'keystone',
  keystone_def: 'The top node of a branch of the tech tree. You hold one keystone a season, and the choice is final.',
  map_marker: 'map marker',
  map_marker_def: 'A mark that a commander puts on a cell for the squad or the faction: attack, hold, gather or danger.',
  master: 'master',
  master_def: 'The design that an invention files. A master prints copies, but it never builds a hull and never trades.',
  mission: 'mission',
  mission_def: 'The standing order that a fleet carries out on the map, for example a patrol, a hunt, an escort or a gather.',
  module_family: 'module family',
  module_family_def: 'One of the five systems a design can fit: Weapon, Shields, Propulsion, Dampening and Sonar. Research opens each of its three tiers.',
  print: 'print',
  print_def: 'A copy of a master that builds hulls. A queue job cuts it with a number of runs, and each hull that it builds uses one run.',
  research: 'research',
  research_def: 'A queue job that opens one node of the tech tree. A node gives an effect, or it opens a hull, a module or a building.',
  seaquake: 'seaquake',
  seaquake_def: 'The collapse that ends a season, in three stages. Stage 1 docks every fleet, stage 2 kills the deposits and stage 3 locks the scores.',
  season: 'season',
  season_def: 'One run of a world. It ends in the seaquake, and the next season starts on a new map. Only your captains, your Honour and your identity cross to the next season.',
  siege: 'siege',
  siege_def: 'The fight for a strategic object when its siege window opens. Each side pledges fleets, and a window battle decides who holds the object.',
  sonar: 'sonar',
  sonar_def: 'The hearing of your fleets and your hold. A source hears an enemy fleet when the fleet is nearer than its range times the noise of the fleet.',
  sov: 'sov',
  sov_def: 'The short name of sovereignty. It says which faction owns a cell, and how much work a change of owner needs.',
  squad: 'squad',
  squad_def: 'The clan members who deploy together. A squad starts in one pocket of water, and its members share their sonar.',
  talent: 'talent',
  talent_def: 'One of the two attributes that a captain is born strong in. A talent trains faster than the other attributes.',
  territory: 'territory',
  territory_def: 'The cells that a faction owns. A Beacon moves it cell by cell, and a hold or a captured strategic object keeps the ground round it.',
  torpedo: 'torpedo',
  torpedo_def: 'A round that runs through the water to its target, and a target can dodge it. The build queue builds torpedoes, and your hold stocks them.',
  volatiles: 'Volatiles',
  volatiles_def: 'A mined resource. The Volatiles Extractor produces it, and a Dredger gathers it from a deposit.',
  wardroom: 'wardroom',
  wardroom_def: 'The captains of your empire. Your account carries them from one season to the next.',
  world: 'world',
  world_def: 'One map with its own season and its own commanders. Nothing passes between two worlds but your account.',
};

const guestWarn_en: S.GuestWarn = {
  body: 'The seaquake has started. At the season roll, the game deletes this guest account with its captains and its Honour. Register the account to keep it.',
  head: 'GUEST ACCOUNT',
  hub_lede: (p: { left: string | number }) => `The season rolls in ${p.left}. At the roll, the game deletes this guest account with its captains and its Honour. Register the account to keep it.`,
  later: 'LATER',
  register: 'REGISTER',
  summary: 'At the season roll, the game deletes this guest account with its captains and its Honour. Register the account to keep it.',
};

const howPlays_en: S.HowPlays = {
  arcade_goal: 'Each map states one win: for example, sink the enemy fleets, hold a share of the sea or hold the objectives. The board states the win of each category before you join. When the clock runs out, the team that leads on that win takes the match. A tie is a draw.',
  arcade_loop: 'Credits come in every second. Buy hulls at your base: they go to sea at once, and you command them as in conquest. Find the enemy with sonar, then fight for the win. A match has no build queue, no research and no captains.',
  arcade_stays: 'Your arcade rating and your arcade achievements. A match of the public queue moves the arcade ladder. A match pays no Honour and no captain, and your conquest empire does not change.',
  arcade_together: 'On a team map, your team shares its sonar, its ground and its win. A bot takes an empty seat.',
  clanwar_goal: 'A Clan War is a scheduled war between clans. The clans meet in one world, one clan under each war banner, and the war banners fight for the ground and the strategic objects. The clan that wins the war is the War Champion.',
  clanwar_loop: 'An owner or an officer of your clan registers the members for the next Clan War. The registration closes before the window opens. In the window, each registered member presses MUSTER and joins the world of the clan. The rules of conquest apply.',
  clanwar_stays: 'Clan Honour, in two halves: your own, and the sum of your clan. A Clan War pays it apart from your Core Honour, and your conquest empire does not change.',
  clanwar_together: 'Factions do not apply in a Clan War world. Every seat of a war banner is a seat of its clan. A seat that no registered member holds is a reserve empire, and a late member of the clan takes one. A war banner that no clan fills is an NPC house.',
  close: 'Close',
  core_goal: (p: { days: string | number }) => `Take ground for your faction and fight for it. Each cell your Beacons take, each hostile fleet you sink and each siege you win adds to your season score. Buildings, research, gathering and captains add points too, and a loss takes no point away. When the ${p.days}-day season ends, your score becomes Honour.`,
  core_loop: 'Your fleets fight tactical battles on a live map. Beacons move the border one cell at a time, and a siege takes a strategic object in its siege window. The economy, research and your captains support the front: they pay for the fleets and make them stronger.',
  core_stays: 'Your captains, your Honour and your name. The map, your empire, the fleets and the tech end at the seaquake, and the next season starts on a fresh map.',
  core_together: (p: { squad: string | number; members: string | number }) => `Conquest is team play. Your faction shares the ground and the fight for the strategic objects. You sail in a squad of up to ${p.squad} commanders: it starts in one pocket of water, it shares a chat, and through the Signal Station it shares its sonar. A clan holds up to ${p.members} commanders and outlives the season. With no clan, you sail in a pickup squad.`,
  drill_go: '▸ THE DRILLS',
  drill_line: 'New here? The drills teach the controls and the rules of a fight, one drill step at a time. Fleets, orders, sonar, torpedoes, Beacons and Sentinels work the same in conquest and in the arcade. A drill uses no arcade run and puts nothing at risk.',
  drill_title: 'Opens the drill board of the arcade',
  event_goal: 'An event is a short season on a map of its own, in a scheduled window. Take ground for your faction and fight for the strategic objects, as in conquest. When the event season ends, your score becomes event Honour.',
  event_loop: 'The rules of conquest apply, at a faster combat pace. An event world has no season plan: while the window is open, you join first come, first served, and you take a free seat of your own faction.',
  event_stays: 'Your event Honour, your event captains and your event achievements. An event keeps a ladder and a roster of its own, so your conquest empire, your captains and your Core Honour do not change.',
  event_together: 'Clan and squad do not count in an event world. You sail beside every commander of your faction, and the faction shares the ground and the fight for the strategic objects.',
  head_goal: 'THE GOAL',
  head_loop: 'THE LOOP',
  head_stays: 'WHAT STAYS',
  head_together: 'TOGETHER',
  open_label: (p: { mode: string | number }) => `How ${p.mode} plays`,
  switch_label: 'Mode',
  title: 'HOW IT PLAYS',
  trials_line: 'In your first conquest season, the sea trials teach the economy.',
};

const hub_en: S.Hub = {
  busy_join: 'OPENING A SEAT',
  busy_line: (p: { label: string | number }) => `${p.label} …`,
  busy_signout: 'SIGNING OUT',
  cancel: 'CANCEL',
  dock_names: ['PLAY', 'RANKS', 'RECORD', 'CLAN', 'WARDROOM'],
  end_guest_seat: 'END GUEST SEAT',
  end_guest_seat_armed: 'LOSE CAPTAINS\nAND HONOUR?',
  foot_names: ['IMPRINT', 'PRIVACY NOTICE', 'TERMS OF SERVICE', 'ABOUT THIS PROJECT', 'CONTACT'],
  foot_names_short: ['IMPRINT', 'PRIVACY', 'TERMS', 'ABOUT', 'CONTACT'],
  go_back: 'GO BACK',
  nav_dock: 'MAIN SECTIONS',
  nav_strip: 'MORE SECTIONS',
  notice_dismiss: 'DISMISS',
  notice_more: 'FROM THE OPERATOR',
  rename_card: 'CHANGE YOUR NAME',
  rename_confirm_card: 'CONFIRM THE NAME',
  rename_confirm_join: 'A world reads the name at the next join.',
  rename_confirm_lede: 'This is your one free name change. It is spent the moment you confirm it, and after that only a person of the team makes another one.',
  rename_lede: 'You get one free name change. After it is spent, only a person of the team makes a second one.',
  rename_more: 'ONE FREE CHANGE',
  rename_placeholder: 'NEW NAME',
  rename_said: (p: { name: string | number }) => `YOUR NAME IS NOW ${p.name}.`,
  rename_title: 'ONE FREE NAME CHANGE',
  row_name_new: 'YOUR NEW NAME',
  row_name_now: 'YOUR NAME NOW',
  save: 'SAVE',
  saving: 'SAVING …',
  sign_out: 'SIGN OUT',
  sign_out_armed: 'SIGN OUT?',
  strip_names: ['NEWS', 'SHOP', 'MODDING', 'HELP', 'SETTINGS'],
  use_this_name: 'YES, USE THIS NAME',
  wordmark: 'AQUAPHOBIA',
};

const hubAlerts_en: S.HubAlerts = {
  buzz_foot: (p: { sec: string | number }) => `At most one buzz in ${p.sec} s: when two events meet, the longer pattern plays. The quiet hours mute PUSH alone.`,
  buzz_try: '▶',
  buzz_try_title: 'buzz this pattern once',
  checking: 'CHECKING',
  class_cup: 'CUP',
  class_cup_desc: 'The check-in of the clan cup opens soon, for a member of a drawn cup team.',
  class_economy: 'ECONOMY',
  class_economy_desc: 'The build queue or the laboratory finished and waits.',
  class_fleet: 'FLEET',
  class_fleet_desc: 'A hull of yours sank.',
  class_hold: 'HOLD',
  class_hold_desc: 'Enemy fire near your hold.',
  class_pirates: 'PIRATES',
  class_pirates_desc: 'A pirate group or a monster takes a hull of yours as its target.',
  class_sea_mines: 'SEA MINES',
  class_sea_mines_desc: 'A hull of yours sets off a sea mine, a sea mine of yours goes off, or a sea object of yours leaves the map.',
  class_siege: 'SIEGE',
  class_siege_desc: 'A siege was pledged at an object your faction holds or attacks, the siege windows of the day open soon, or a squad mate calls a rally.',
  col_buzz: 'BUZZ',
  col_event: 'EVENT',
  col_push: 'PUSH',
  ev_cup: 'Clan cup check-in',
  ev_economy: 'A build or research done',
  ev_hit: 'A hit on your fleet',
  ev_hit_desc: (p: { sec: string | number }) => `The first hit of a fight, then one buzz in ${p.sec} s for each fleet.`,
  ev_hold: 'Your hold under fire',
  ev_lost: 'A fleet lost',
  ev_pirates: 'Pirates or a monster on your fleet',
  ev_sea_mines: 'A sea mine goes off',
  ev_siege: 'Siege warning',
  head_push: 'PUSH',
  head_push_buzz: 'PUSH AND BUZZ',
  ios_step: (p: { share: string | number }) => `On an iPhone or an iPad, push notifications reach only the web app on the home screen. Press ${p.share} Share, then Add to Home Screen, and open Aquaphobia from there.`,
  lede: 'A push notification reaches this device when no game tab is open. Every class is off until you turn it on. The first switch asks the browser for its permission.',
  lede_buzz: 'BUZZ shakes the telephone while the game is open. Every BUZZ switch is on until you turn it off.',
  lede_no_buzz: 'This device gives a web page no vibration, so BUZZ stays off. An iPhone is such a device.',
  night: 'siege at night',
  night_desc: 'On, the siege class sends in the quiet hours too.',
  none: '—',
  privacy: 'The push service of your browser vendor carries each push notification. The text names no position and no other player.',
  privacy_app: 'The push service of Apple carries each push notification. The text names no position and no other player.',
  quiet: 'quiet hours',
  quiet_desc: (p: { zone: string | number }) => `No push notification in these hours, in your local time (${p.zone}).`,
  quiet_from: 'FROM',
  quiet_to: 'TO',
  refused: 'The browser refused push notifications for this site. Allow them in the site settings of the browser, then turn a switch on again.',
  refused_app: 'iOS refused push notifications for Aquaphobia. Allow them in the iOS Settings under Aquaphobia, then turn a switch on again.',
  unavailable: 'Push notifications are not available yet.',
  unsupported: 'This browser cannot receive push notifications.',
};

const hubBlocks_en: S.HubBlocks = {
  checking: 'CHECKING',
  count: (p: { have: string | number; cap: string | number }) => `${p.have} OF ${p.cap}`,
  empty: 'NOBODY IS BLOCKED',
  empty_why: 'A block hides the chat lines of one account from you.',
  head: 'BLOCKED ACCOUNTS',
  lede: 'Every chat hides the lines of every account on this list, for you alone: the clan chat, and the WORLD, FACTION and SQUAD channels of a world. BLOCK under a chat line adds an account, on the CLAN page and in the game. A lift reaches a world at your next join.',
  lift: 'LIFT',
};

const hubChatRelay_en: S.HubChatRelay = {
  busy_remove: 'REMOVING THE RELAY',
  busy_save: 'SAVING THE RELAY',
  busy_test: 'SENDING A TEST POST',
  lang: 'LANGUAGE',
  lang_desc: 'The language of the words of the relay: its name in Discord and its lines in the chat.',
  lede: 'The relay copies each new line of the clan chat to one Discord channel. Use a webhook of its own, or the webhook of the DISCORD card. No line goes from Discord into the game.',
  notice_removed: 'The relay is removed.',
  notice_saved: 'The relay is saved.',
  off_line: (p: { count: string | number }) => `Discord refused the webhook ${p.count} times in a row, so the relay stopped. A person probably deleted the webhook. Paste the URL of a new webhook and press SAVE.`,
  privacy: 'Each member sees the → DISCORD mark in the clan chat while the relay is on. Discord keeps each line that it got: a line that moderation removes later stays there. The URL is a secret, and the card shows it masked.',
  refusal_none: 'YOUR CLAN HOLDS NO CHAT RELAY. SAVE ONE FIRST.',
  remove: 'REMOVE',
  remove_armed: 'REMOVE?',
  save: 'SAVE',
  save_hint: 'Press SAVE to keep a change of the URL, the language or the switch.',
  state_none: 'NOT SET',
  state_off: 'OFF',
  state_on: 'ON',
  switch: 'RELAY',
  switch_desc: 'OFF keeps the URL and copies nothing.',
  test: 'TEST',
  url: 'WEBHOOK URL',
  url_label: 'WEBHOOK URL',
  url_placeholder: 'https://discord.com/api/webhooks/…',
  url_stored: (p: { url: string | number }) => `Stored: ${p.url}. Leave the box empty to keep it.`,
};

const hubClan_en: S.HubClan = {
  apply_cancel: 'CANCEL',
  apply_send: 'SEND',
  apps_approve: 'APPROVE',
  apps_more: (p: { count: string | number }) => `${p.count} WAITING`,
  apps_none: 'NOBODY HAS APPLIED',
  apps_none_closed: 'THIS CLAN TURNS EVERY APPLICATION AWAY.',
  apps_none_invite: 'AN APPLICATION FROM THE BROWSE LIST SHOWS UP HERE.',
  apps_none_open: 'AN APPLICANT JOINS AT ONCE AND WAITS FOR NOBODY.',
  apps_refuse: 'REFUSE',
  browse_again: '▸ BROWSE AGAIN',
  browse_button: 'BROWSE',
  browse_faction_all: 'ALL',
  browse_faction_label: 'FACTION',
  browse_first_page: 'THE FIRST PAGE',
  browse_label: 'CLAN NAME OR TAG',
  browse_matching: (p: { query: string | number }) => `MATCHING ${p.query}`,
  browse_none_listed: 'NO CLAN IS LISTED YET',
  browse_none_match: 'NO CLAN MATCHES THAT',
  browse_none_press: '▸ START ONE',
  browse_none_why: 'THE FIRST PLAYER WHO FOUNDS ONE OWNS IT.',
  busy_applying: 'APPLYING',
  busy_approve: 'TAKING THEM IN',
  busy_assign: 'MOVING THEM',
  busy_create: 'FOUNDING THE CLAN',
  busy_leave: 'LEAVING THE CLAN',
  busy_line: (p: { label: string | number }) => `${p.label} …`,
  busy_policy: 'SETTING THE POLICY',
  busy_refuse: 'TURNING THEM AWAY',
  busy_register: 'REGISTERING',
  busy_remove: 'REMOVING THE MEMBER',
  busy_role: 'CHANGING THE ROLE',
  busy_withdraw: 'WITHDRAWING',
  card_applications: 'APPLICATIONS',
  card_clan_chat: 'CLAN CHAT',
  card_clans: 'CLANS',
  card_hours: 'CLANS OF YOUR HOURS',
  card_roster: 'ROSTER',
  chat_actions: '⋯',
  chat_block: 'BLOCK',
  chat_blocked: 'The chat hides the lines of that account now. SETTINGS lifts the block.',
  chat_dialling: 'THE SOCKET IS DIALLING.',
  chat_empty: 'NOTHING HAS BEEN SAID YET',
  chat_gap: (p: { missed: string | number }) => `${p.missed} MESSAGES WERE NOT KEPT`,
  chat_line: (p: { sender: string | number; body: string | number }) => `${p.sender}: ${p.body}`,
  chat_more: 'GLOBAL · ALL WORLDS',
  chat_no_clan: 'THE CHAT IS NOT OPEN',
  chat_no_clan_why: 'JOIN OR FOUND A CLAN TO OPEN ITS CHAT.',
  chat_not_connected: 'THE CHAT IS NOT CONNECTED YET',
  chat_not_open: 'THE CHAT IS NOT OPEN YET',
  chat_not_open_why: 'THE SECTION OPENS IT.',
  chat_placeholder: 'SAY SOMETHING TO THE CLAN',
  chat_refused: 'THE CHAT REFUSED THIS SESSION',
  chat_refused_why: 'SIGN IN AGAIN. A RECONNECT DOES NOT MEND THIS ONE.',
  chat_retrying: (p: { n: string | number }) => `THE SOCKET RETRIES BY ITSELF. ATTEMPT ${p.n}.`,
  chat_send: 'SEND',
  chat_unavailable: 'CLAN CHAT IS NOT AVAILABLE NOW',
  chat_unavailable_why: 'THE REST OF THE SECTION WORKS WITHOUT IT.',
  count_of: (p: { have: string | number; cap: string | number }) => `${p.have} OF ${p.cap}`,
  create_button: 'FOUND IT',
  create_lede_banner: 'Pick the faction the clan flies. The banner is fixed at the moment you found the clan. You take it, every member takes it, and nothing changes it.',
  create_lede_free: 'Founding a clan is free.',
  create_name_label: 'CLAN NAME',
  create_pick_faction: 'PICK A FACTION BEFORE YOU FOUND THE CLAN.',
  create_tag_label: 'TAG',
  cw_closed: 'THE REGISTRATION IS CLOSED.',
  cw_honour_value: (p: { n: string | number }) => `${p.n} HONOUR`,
  cw_no_run: 'NO CLAN WAR ON THE CALENDAR',
  cw_no_run_why: 'THE REGISTRATION OPENS WHEN A CLAN WAR RUN IS SCHEDULED.',
  cw_not_registered: 'THE CLAN IS NOT REGISTERED.',
  cw_officer_only: 'AN OFFICER OR THE OWNER REGISTERS THE CLAN.',
  cw_outcome_no_opponent: 'NO OPPONENT THIS RUN. EVERY REGISTERED MEMBER RECEIVES A SMALL CLAN HONOUR CONSOLATION.',
  cw_outcome_no_world: 'THE DIVISION HAS NO WORLD WITH ROOM THIS RUN.',
  cw_outcome_placed: (p: { division: string | number; banner: string | number }) => `THE CLAN FIGHTS IN DIVISION ${p.division} UNDER BANNER ${p.banner}.`,
  cw_outcome_waiting: 'THE BATCH READS THE LIST AT THE CUT-OFF.',
  cw_pick: 'PICK THE MEMBERS WHO FIGHT. THE COUNT SETS THE DIVISION: THE BANNER SIZE.',
  cw_pick_all: 'ALL',
  cw_pick_count: (p: { count: string | number; division: string | number }) => `${p.count} PICKED · DIVISION ${p.division}`,
  cw_pick_none: 'NONE',
  cw_register: 'REGISTER',
  cw_row_cutoff: 'REGISTRATION CLOSES IN',
  cw_row_division: 'DIVISION',
  cw_row_honour: 'CLAN HONOUR',
  cw_row_opens: 'OPENS IN',
  cw_row_registered: 'REGISTERED',
  cw_row_run: 'RUN',
  cw_update: 'UPDATE THE LIST',
  cw_withdraw: 'WITHDRAW',
  cw_withdraw_armed: 'WITHDRAW?',
  edit_open: '▾ EDIT',
  edit_shut: '▸ EDIT',
  find_lede_faction: 'A clan flies one faction, and every member carries it.',
  find_lede_size: (p: { max_members: string | number }) => `A clan holds up to ${p.max_members} commanders. It is the only way into a Clan War.`,
  find_lede_squads: 'The squads play different worlds. The chat follows you between them.',
  found_cards_label: 'THE BANNER OF THE CLAN',
  found_chart_alt: (p: { name: string | number }) => `${p.name} on the sea chart: the tint and the border of the territory, and the charge beside a hold.`,
  found_chart_alt_none: 'A sea chart with no banner on it.',
  found_chart_head: 'ON THE MAP',
  found_chart_line: 'The territory of the clan takes this tint and this border. Other factions see this charge beside the hold of each member.',
  found_chart_none: 'Pick a banner, and this chart shows it.',
  found_form_head: 'NAME THE CLAN',
  found_players: (p: { n: number }) => plural(p.n, {
    one: `${p.n} PLAYER LAST SEASON`,
    other: `${p.n} PLAYERS LAST SEASON`,
  }),
  hand_over: 'HAND THE CLAN OVER',
  hand_over_armed: 'HAND OVER?',
  head_discord: 'POSTS TO DISCORD',
  head_members: (p: { have: string | number; cap: string | number }) => `${p.have} OF ${p.cap} MEMBERS`,
  hours_ask: 'STATE YOUR HOURS, AND THIS PAGE LISTS THE CLANS WHOSE MEMBERS PLAY WHEN YOU PLAY.',
  hours_ask_press: '▸ STATE YOUR HOURS',
  hours_lede: (p: { min: string | number }) => `In each of these clans, ${p.min} or more members state the same hours as you. The clan with the most of them stands first.`,
  hours_more: (p: { n: number }) => plural(p.n, {
    one: `${p.n} MORE CLAN MATCHES. THE LIST BELOW SHOWS MORE CLANS.`,
    other: `${p.n} MORE CLANS MATCH. THE LIST BELOW SHOWS MORE CLANS.`,
  }),
  hours_none: 'NO CLAN MATCHES YOUR HOURS YET',
  hours_none_why: (p: { min: string | number }) => `A CLAN MATCHES WHEN ${p.min} OR MORE OF ITS MEMBERS STATE YOUR HOURS. THE LIST BELOW SHOWS MORE CLANS.`,
  hours_sub: (p: { band: string | number }) => `YOUR HOURS · ${p.band}`,
  leave_clan: 'LEAVE THE CLAN',
  leave_clan_armed: 'LEAVE CLAN?',
  make_member: 'MAKE MEMBER',
  make_officer: 'MAKE OFFICER',
  no_banner_on_record: 'NO BANNER ON RECORD',
  no_squad: 'NO SQUAD',
  nobody_yet: 'NOBODY YET',
  note_label: 'A SHORT WORD TO THE OFFICERS (OPTIONAL)',
  notice_applied: 'THE APPLICATION IS IN. AN OFFICER OF THAT CLAN ANSWERS IT.',
  pill_apply: 'APPLY',
  pill_closed: 'CLOSED',
  pill_full: 'FULL',
  pill_join: 'JOIN',
  policy_label_closed: 'CLOSED',
  policy_label_invite: 'INVITE',
  policy_label_open: 'OPEN',
  refusal_already_applied: 'THIS ACCOUNT HAS ALREADY APPLIED TO THAT CLAN. AN OFFICER ANSWERS IT.',
  refusal_already_in_clan: 'THIS ACCOUNT IS ALREADY IN A CLAN. LEAVE THAT ONE FIRST.',
  refusal_bad_request: (p: { factions: string | number; name_max: string | number; name_min: string | number; squads: number; tag_max: string | number; tag_min: string | number }) => plural(p.squads, {
    one: `THE SERVER REFUSED THAT. A CLAN NAME IS ${p.name_min} TO ${p.name_max} CHARACTERS, A TAG IS ${p.tag_min} TO ${p.tag_max} LETTERS OR DIGITS, A FACTION IS 1 TO ${p.factions}, AND THE SQUAD IS NUMBER ${p.squads}.`,
    other: `THE SERVER REFUSED THAT. A CLAN NAME IS ${p.name_min} TO ${p.name_max} CHARACTERS, A TAG IS ${p.tag_min} TO ${p.tag_max} LETTERS OR DIGITS, A FACTION IS 1 TO ${p.factions}, AND A SQUAD IS NUMBERED 1 TO ${p.squads}.`,
  }),
  refusal_clan_closed: 'THAT CLAN IS CLOSED. IT TAKES NOBODY IN, AND IT MAY STILL HAVE ROOM.',
  refusal_clan_full: 'THAT CLAN HAS NO ROOM LEFT.',
  refusal_clan_taken: 'ANOTHER CLAN HOLDS THAT NAME OR THAT TAG. PICK A DIFFERENT ONE.',
  refusal_forbidden: 'YOUR ROLE DOES NOT ALLOW THAT.',
  refusal_owner_must_hand_over: 'HAND THE CLAN OVER TO ANOTHER MEMBER BEFORE YOU LEAVE.',
  remove: 'REMOVE',
  remove_armed: 'REMOVE?',
  role_member: 'MEMBER',
  role_officer: 'OFFICER',
  role_owner: 'OWNER',
  roster_more: (p: { count: string | number }) => `${p.count} MEMBERS`,
  row_honour: 'HONOUR',
  row_self_suffix: ' · YOU',
  sec_chat: 'CHAT',
  sec_cup: 'CLAN CUP',
  sec_discord: 'DISCORD',
  sec_find: 'FIND A CLAN',
  sec_invites: 'INVITES',
  sec_members: 'MEMBERS',
  sec_relay: 'CHAT RELAY',
  sec_start: 'START ONE',
  sec_war: 'CLAN WAR',
  squad_n: (p: { idx: string | number }) => `SQUAD ${p.idx}`,
  squad_not_seated: 'NOT SEATED YET',
  squad_single: 'SQUAD',
  squads_plan: 'Squads changes apply at next season start. Existing worlds keep their original squads.',
  sum_chat_new: (p: { n: string | number; line: string | number }) => `${p.n} NEW · ${p.line}`,
  sum_find_hours: (p: { n: number }) => plural(p.n, {
    one: `${p.n} MATCHES YOUR HOURS`,
    other: `${p.n} MATCH YOUR HOURS`,
  }),
  sum_invites: (p: { n: string | number }) => `${p.n} OPEN`,
  sum_members_apply: (p: { have: string | number; cap: string | number; n: string | number }) => `${p.have} OF ${p.cap} · ${p.n} APPLY`,
  sum_war_none: 'NO RUN',
  sum_war_open: 'NOT REGISTERED',
  sum_war_registered: (p: { division: string | number }) => `REGISTERED · DIVISION ${p.division}`,
  title: 'CLAN',
  title_sub_no_clan: 'YOU ARE IN NONE',
};

const hubCup_en: S.HubCup = {
  after: 'AFTER',
  best_of: (p: { n: string | number }) => `BEST OF ${p.n}`,
  bracket_cancelled: 'NO CUP BRACKET THIS MONTH.',
  bracket_cancelled_why: (p: { cup: string | number }) => `THE ${p.cup} IS CANCELLED.`,
  bracket_none: 'NO CLAN HAS REGISTERED YET.',
  bracket_now: (p: { time: string | number }) => `NOW · ${p.time}`,
  bracket_preview: 'THE DRAW AS IT STANDS NOW',
  bracket_title: 'THE CUP BRACKET',
  btn_bracket: 'THE CUP BRACKET',
  btn_checkin: 'CHECK IN',
  btn_play: 'PLAY YOUR MATCH',
  btn_watch: 'WATCH THE MATCH',
  btn_watch_short: 'WATCH',
  busy_checkin: 'CHECKING IN',
  busy_register: 'REGISTERING THE TEAM',
  busy_withdraw: 'WITHDRAWING THE TEAM',
  cancel_note: 'Every registered clan gets one line in its clan chat when a cup is cancelled.',
  cancelled_few: (p: { min: string | number; n: string | number }) => `A CUP NEEDS ${p.min} CLANS, AND ${p.n} REGISTERED. NO MATCH IS PLAYED, AND NO CLAN LOSES ANYTHING.`,
  cancelled_head: (p: { cup: string | number }) => `THE ${p.cup} IS CANCELLED.`,
  cancelled_ops: 'THE GAME TEAM CANCELLED IT. NO MATCH IS PLAYED, AND NO CLAN LOSES ANYTHING.',
  card_title: 'CLAN CUP',
  cat_capture_sov: 'CAPTURE THE CELL',
  cat_ffa: 'FREE FOR ALL',
  cat_sovereignty: 'SOVEREIGNTY',
  checkin_done: (p: { time: string | number }) => `DONE AT ${p.time}`,
  checkin_missed: 'MISSED',
  checkin_open: (p: { time: string | number }) => `OPEN UNTIL ${p.time}`,
  checkin_opens: (p: { time: string | number }) => `OPENS AT ${p.time}`,
  clans: (p: { n: number }) => plural(p.n, {
    one: `${p.n} CLAN`,
    other: `${p.n} CLANS`,
  }),
  col_cup: 'THE CUP',
  col_final: 'FINAL',
  col_quarter: 'QUARTER-FINALS',
  col_semi: 'SEMI-FINALS',
  cup_name: (p: { month: string | number }) => `${p.month} CUP`,
  cup_name_year: (p: { month: string | number; year: string | number }) => `${p.month} CUP ${p.year}`,
  cutoff_line: (p: { date: string | number; time: string | number; left: string | number }) => `${p.date} · ${p.time} · IN ${p.left}`,
  cutoff_passed: 'THE REGISTRATION IS CLOSED. THE DRAW RUNS NOW.',
  cutoff_past: (p: { date: string | number; time: string | number }) => `${p.date} · ${p.time}`,
  date: (p: { day: string | number; n: string | number; month: string | number }) => `${p.day} ${p.n} ${p.month}`,
  day_cancelled: 'NO CUP DAY THIS MONTH.',
  day_more: (p: { date: string | number }) => `${p.date}`,
  day_note: (p: { min: string | number }) => `A push notice ${p.min} minutes before the check-in, in the CUP class of ALERTS.`,
  day_title: 'THE CUP DAY',
  days_short: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  done_winner: (p: { tag: string | number; wins: string | number; losses: string | number; runner: string | number }) => `[${p.tag}] · ${p.wins} TO ${p.losses} [${p.runner}]`,
  drawn_no_team: 'THE CUP IS DRAWN. YOUR CLAN HAS NO TEAM IN IT.',
  ev_checkin_closes: 'CHECK-IN CLOSES',
  ev_checkin_closes_y: 'a team that is not in loses its match',
  ev_checkin_opens: 'CHECK-IN OPENS',
  ev_checkin_opens_y: 'one member of each team presses CHECK IN on the CLAN CUP card',
  ev_final_y: (p: { n: string | number }) => `the best of ${p.n} · the cup page shows it live`,
  ev_mine: 'your match',
  ev_title: 'THE CUP TITLE',
  ev_title_y: 'the winner gets the title and the cup mark until the next cup day',
  live: 'LIVE',
  maps_line: (p: { category: string | number; n: string | number }) => `${p.category} · ${p.n} AGAINST ${p.n}`,
  mark_label: (p: { cup: string | number }) => `cup mark · ${p.cup}`,
  months: ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'],
  months_short: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  more_cancelled: 'CANCELLED',
  more_cup_day: 'CUP DAY',
  more_done: 'DONE',
  more_registration: 'REGISTRATION',
  next_cancelled: (p: { cup: string | number; date: string | number }) => `No match this month. The ${p.cup} is on ${p.date}.`,
  next_done: (p: { cup: string | number }) => `The ${p.cup} is over.`,
  next_no_clan: 'You are in no clan. A clan registers its cup team on the CLAN CUP card.',
  next_none: 'Your clan has no team in this cup.',
  next_now: 'NOW',
  next_open_lede: 'The draw at the cut-off sets the first match. As the draw stands now:',
  next_out: (p: { time: string | number }) => `Your clan is out of the cup. The final starts at ${p.time}.`,
  next_title: 'YOUR NEXT MATCH',
  none: '—',
  officer_changes: 'AN OFFICER OR THE OWNER CHANGES THE TEAM UNTIL THE CUT-OFF.',
  officer_only: 'AN OFFICER OR THE OWNER REGISTERS THE TEAM.',
  page_sub: (p: { date: string | number; clans: string | number; maps: string | number }) => `${p.date} · ${p.clans} · ${p.maps}`,
  pick_lede: (p: { players: string | number; reserves: string | number }) => `PICK ${p.players} MEMBERS WHO PLAY AND UP TO ${p.reserves} RESERVES. AN OFFICER OR THE OWNER REGISTERS.`,
  picked: (p: { players: string | number; reserves: number }) => plural(p.reserves, {
    one: `${p.players} PICKED · ${p.reserves} RESERVE`,
    other: `${p.players} PICKED · ${p.reserves} RESERVES`,
  }),
  place_against: (p: { round: string | number; time: string | number; tag: string | number }) => `${p.round} · ${p.time} · AGAINST [${p.tag}]`,
  place_bye: (p: { round: string | number }) => `A BYE IN THE ${p.round}`,
  place_live: (p: { round: string | number; tag: string | number }) => `IN THE ${p.round} · NOW · AGAINST [${p.tag}]`,
  place_out: (p: { round: string | number }) => `OUT IN THE ${p.round}`,
  place_seed: (p: { seed: string | number }) => `SEED ${p.seed}`,
  place_waiting: (p: { round: string | number }) => `WAITS FOR THE ${p.round}`,
  place_winner: 'WINNER OF THE CUP',
  prize_value: 'TITLE · CUP MARK · NO HONOUR',
  record_cancelled: 'CANCELLED · NO CUP',
  record_in: 'IN THE CUP · NOW',
  record_in_round: (p: { round: string | number }) => `IN THE ${p.round} · NOW`,
  record_month: (p: { month: string | number; year: string | number }) => `${p.month} ${p.year}`,
  record_more: (p: { n: number }) => plural(p.n, {
    one: `${p.n} CUP TITLE`,
    other: `${p.n} CUP TITLES`,
  }),
  record_note: 'A cup gives no Honour. The record keeps every title; the cup mark stands until the next cup day.',
  record_registered: (p: { date: string | number }) => `REGISTERED · ${p.date}`,
  record_title: 'CUP RECORD',
  record_winner: (p: { wins: string | number; losses: string | number; tag: string | number }) => `WINNER · ${p.wins} TO ${p.losses} [${p.tag}]`,
  reg_not_open: (p: { date: string | number }) => `THE REGISTRATION OPENS ON ${p.date}.`,
  register: 'REGISTER',
  registered_full: (p: { n: string | number; max: string | number }) => `${p.n} OF ${p.max} · FULL`,
  registered_line: (p: { n: string | number; min: string | number }) => `${p.n} · THE CUP NEEDS ${p.min}`,
  reserve_suffix: ' · RESERVE',
  round_at: (p: { round: string | number; time: string | number }) => `${p.round} · ${p.time}`,
  round_final: 'FINAL',
  round_n: (p: { n: string | number }) => `ROUND ${p.n}`,
  round_quarter: 'QUARTER-FINAL',
  round_semi: 'SEMI-FINAL',
  row_against: 'AGAINST',
  row_checkin: 'CHECK-IN',
  row_cup: 'CUP',
  row_cutoff: 'CUT-OFF',
  row_maps: 'MAPS',
  row_next: 'NEXT',
  row_prize: 'PRIZE',
  row_reg_opens: 'REGISTRATION OPENS',
  row_registered: 'CLANS REGISTERED',
  row_reserve: 'RESERVE',
  row_round: 'ROUND',
  row_team: 'TEAM',
  row_winner: 'WINNER',
  row_your_clan: 'YOUR CLAN',
  side_absent: 'NO CHECK-IN',
  side_bye: 'BYE',
  side_empty: 'NO TEAM',
  side_tbd: 'the winner above',
  strip_cancelled: 'CANCELLED',
  strip_head: 'THE CUPS · THE FIRST SATURDAY OF EACH MONTH',
  strip_next: 'NEXT',
  strip_none: 'NO HOLDER',
  strip_today: 'TODAY',
  strip_won: (p: { tag: string | number }) => `WON BY [${p.tag}]`,
  sum_line: (p: { cup: string | number; state: string | number }) => `${p.cup} · ${p.state}`,
  sum_no_team: 'NO TEAM',
  sum_registered: 'REGISTERED',
  time_pair: (p: { local: string | number; utc: string | number }) => `${p.local} · ${p.utc}`,
  title_line: (p: { cup: string | number; date: string | number }) => `HOLDER OF THE ${p.cup} · UNTIL ${p.date}`,
  today: 'TODAY',
  update: 'CHANGE THE TEAM',
  was_registered: 'WAS REGISTERED · NOTHING TO DO',
  when_line: (p: { cup: string | number; date: string | number; time: string | number }) => `${p.cup} · ${p.date} · ${p.time}`,
  withdraw: 'WITHDRAW',
  withdraw_armed: 'WITHDRAW?',
};

const hubCustom_en: S.HubCustom = {
  advanced: 'ADVANCED',
  any_faction: 'ANY FACTION',
  auto: 'AUTO',
  autostart: (p: { left: string | number }) => `STARTS BY ITSELF IN ${p.left}`,
  back: 'PLAY',
  bots: (p: { n: number }) => plural(p.n, {
    one: `${p.n} BOT`,
    other: `${p.n} BOTS`,
  }),
  budget_back: 'YOUR HOSTING BUDGET IS BACK',
  cancel: 'CANCEL',
  cancel_armed: 'CANCEL?',
  code: 'CODE',
  code_bad: 'THAT IS NOT A CODE: THREE SYMBOLS',
  code_label: 'A LOBBY CODE OR A GAME CODE',
  code_ph: 'CODE',
  combat_pace: 'COMBAT PACE',
  copy: 'COPY',
  draft_ends: (p: { left: string | number }) => `OPEN IT WITHIN ${p.left}, OR IT CLOSES`,
  faction_count: (p: { total: string | number; humans: string | number; bots: string | number }) => `${p.total} · ${p.humans} + ${p.bots}`,
  faction_held: 'A MEMBER PLAYS IN THIS FACTION',
  faction_pick: (p: { name: string | number }) => `FACTION OF ${p.name}`,
  factions: 'FACTIONS',
  factions_min: (p: { n: string | number }) => `AT LEAST ${p.n} FACTIONS PLAY.`,
  fill: 'FILL WITH BOTS',
  fill_desc: 'Bots take the seats no player takes, up to the commanders below.',
  fill_off_desc: 'The world holds the players who joined, and no bot.',
  flags: 'FEATURES',
  flags_desc: 'A feature that is off stays off for the whole world.',
  gone_cancelled: 'THE HOST CANCELLED THIS LOBBY.',
  gone_dissolved: 'THIS LOBBY IS CLOSED.',
  gone_failed: 'THE WORLD COULD NOT START',
  gone_released: 'THE WORLD HAS ENDED',
  gone_run_cancelled: 'THE WORLD WAS CANCELLED',
  host: 'HOST',
  host_mark: 'HOST',
  host_name: 'HOST A PRIVATE WORLD',
  host_premium: 'HOSTING A PRIVATE WORLD IS PREMIUM',
  host_return: 'RETURN TO LOBBY',
  humans: (p: { n: number }) => plural(p.n, {
    one: `${p.n} PLAYER`,
    other: `${p.n} PLAYERS`,
  }),
  join: 'JOIN',
  join_name: 'JOIN BY CODE',
  join_world: 'JOIN WORLD',
  kick: 'KICK',
  kick_armed: 'KICK?',
  leave: 'LEAVE',
  leave_armed: 'CLOSE IT?',
  link: 'LINK',
  loading: 'READING THE LOBBY',
  locked: 'FIXED WHILE THE LOBBY IS OPEN',
  map: 'MAP',
  map_note: 'THE TERRITORY AT THE START. A FACTION THAT IS OFF HOLDS NONE.',
  members: 'MEMBERS',
  name: 'WORLD NAME',
  next_run: (p: { label: string | number; at: string | number }) => `IT ENDS BEFORE ${p.label} OPENS, ${p.at}`,
  nobody: 'NO PLAYER YET',
  open: 'OPEN',
  population: 'COMMANDERS',
  season_days: 'SEASON DAYS',
  seats: 'SEATS',
  seed: 'SEED',
  settings: 'SETTINGS',
  share: 'SHARE',
  squad_n: (p: { n: string | number }) => `SQUAD ${p.n}`,
  squad_pick: (p: { name: string | number }) => `SQUAD OF ${p.name}`,
  stage1: 'QUAKE STAGE 1',
  stage2: 'QUAKE STAGE 2',
  start: 'START',
  start_armed: 'START?',
  state_cancelled: 'CANCELLED',
  state_dissolved: 'CLOSED',
  state_draft: 'DRAFT',
  state_ended: 'ENDED',
  state_live: 'LIVE',
  state_open: 'OPEN',
  state_starting: 'STARTING',
  tactical_scale: 'MAP CLOCK',
  timescale: 'WORLD CLOCK',
  title: 'CUSTOM WORLD',
  truce_hours: 'TRUCE HOURS',
  wall: (p: { length: string | number }) => `THE WORLD RUNS ${p.length}`,
  world_closes: (p: { left: string | number }) => `THE WORLD CLOSES IN ${p.left}`,
  world_open: 'THE WORLD IS OPEN',
  world_opening: 'THE WORLD IS OPENING',
  world_opens: (p: { left: string | number }) => `THE WORLD OPENS IN ${p.left}`,
  you: 'YOU',
};

const hubDailyPlan_en: S.HubDailyPlan = {
  at_desc: (p: { hour: string | number }) => `Every day at ${p.hour}.`,
  checking: 'CHECKING',
  head: 'DAILY PLAN',
  hour: 'hour',
  hour_desc: (p: { zone: string | number }) => `The hour of the push, in your local time (${p.zone}).`,
  lede: 'Once a day at the hour you pick, a push notification lists the siege windows of the next world day that your faction defends or attacks. It needs the SIEGE switch, and it keeps your quiet hours. Nothing goes out on a day with no window.',
  off: 'OFF',
  off_desc: 'No daily plan.',
};

const hubDiscord_en: S.HubDiscord = {
  busy_remove: 'REMOVING THE WEBHOOK',
  busy_save: 'SAVING THE WEBHOOK',
  busy_test: 'SENDING A TEST POST',
  class_clanwar: 'CLAN WAR',
  class_clanwar_desc: 'The clan finishes a Clan War season, wins a division, or a trench takes the name of the clan. In the world of the clan\'s war banner: the founding truce and seaquake stages 1 and 2, an hour before and when they start.',
  class_members: 'MEMBERS',
  class_members_desc: 'A member joins or leaves the clan, a commander applies, an officer is named or removed, or the clan has a new owner.',
  class_milestones: 'MILESTONES',
  class_milestones_desc: 'A clan cup match is decided, the clan holds the cup title or is the runner-up, the Clan Honour passes a step, or a member reaches a higher arcade ladder tier.',
  class_registration: 'REGISTRATION',
  class_registration_desc: 'The registration of a Clan War or a clan cup opens, closes soon and closes, with the place of the clan; and the event starts soon and starts.',
  class_season: 'SEASON',
  class_season_desc: 'In a Conquest world where a member plays: seaquake stages 1 and 2, an hour before and when they start, and the season result with the place of the clan and of its faction.',
  class_siege: 'SIEGE',
  class_siege_desc: 'A siege was pledged at an object of the faction, the siege windows of the day open soon, or a siege window closed: an object fell, held or was mauled.',
  lang: 'LANGUAGE',
  lang_desc: 'The language of the posts. Each language shows its own name.',
  lede: 'The clan posts its game events to one Discord channel. In Discord, open the settings of the channel, then Integrations, then Webhooks. Make a webhook and copy its URL into the box.',
  notice_removed: 'The webhook is removed.',
  notice_saved: 'The webhook is saved.',
  notice_test_failed: (p: { status: string | number }) => `Discord answered ${p.status}. Check the URL of the webhook.`,
  notice_test_ok: 'The test post reached Discord.',
  notice_test_silent: 'Discord did not answer. Try again later.',
  off_line: (p: { count: string | number }) => `Discord refused the webhook ${p.count} times in a row, so the posts stopped. A person probably deleted the webhook. Paste the URL of a new webhook and press SAVE.`,
  privacy: 'The URL is a secret. The card shows it masked, and the server records each change. A post names no position and no enemy.',
  refusal_none: 'YOUR CLAN HOLDS NO WEBHOOK. SAVE ONE FIRST.',
  refusal_role: 'THE SERVER REFUSED A ROLE ID. COPY THE ROLE ID FROM DISCORD: IT IS DIGITS ONLY.',
  refusal_url: 'THE SERVER REFUSED THE WEBHOOK. A WEBHOOK URL STARTS WITH https://discord.com/api/webhooks/',
  remove: 'REMOVE',
  remove_armed: 'REMOVE?',
  role_hint: 'A post of a class with a role ID pings that role. To copy a role ID, switch on Developer Mode in Discord (User Settings, then Advanced). Then open the server settings, then Roles, open the menu of the role and press Copy Role ID. An empty box pings no role. The card offers no @everyone and no @here: make a role for them.',
  role_label: 'ROLE ID TO PING (OPTIONAL)',
  save: 'SAVE',
  save_hint: 'Press SAVE to keep a change of the URL, the language, a switch or a role ID.',
  state_none: 'NOT SET',
  state_off: 'OFF',
  state_on: 'ON',
  switch: 'POSTS',
  switch_desc: 'OFF keeps the webhook and its settings and sends no clan post.',
  test: 'TEST',
  url: 'WEBHOOK URL',
  url_label: 'WEBHOOK URL',
  url_placeholder: 'https://discord.com/api/webhooks/…',
  url_stored: (p: { url: string | number }) => `Stored: ${p.url}. Leave the box empty to keep it.`,
};

const hubHours_en: S.HubHours = {
  band_afternoon: 'AFTERNOON',
  band_afternoon_desc: '12:00 to 18:00',
  band_evening: 'EVENING',
  band_evening_desc: '18:00 to 24:00',
  band_morning: 'MORNING',
  band_morning_desc: '06:00 to 12:00',
  band_night: 'NIGHT',
  band_night_desc: '00:00 to 06:00',
  band_none: 'NONE',
  band_none_desc: 'You state no hours. The finder puts you after the players who state them.',
  checking: 'CHECKING',
  head: 'STATED HOURS',
  hours: 'your hours',
  hours_desc: (p: { zone: string | number }) => `The part of the day you play most, in your local time (${p.zone}).`,
  lede: 'Say when you play. At the next season roll, the world puts the players of your banner with the same hours into one squad. This is the squad finder, and it acts only while you have no clan. FIND A CLAN also lists the clans whose members state the same hours.',
};

const hubMods_en: S.HubMods = {
  axis_louder: 'LOUDER ▸',
  axis_quieter: '◂ QUIETER',
  cat_chart: 'CHART',
  cat_marks: 'MARKS',
  cat_music: 'MUSIC',
  cat_sfx: 'SFX',
  cat_ui: 'UI',
  cat_world: 'WORLD',
  change_code: 'CHANGE THE CODE',
  code_busy: 'LOOKING UP THE CODE',
  code_lede: (p: { len: string | number }) => `Type the code of a custom theme: ${p.len} symbols. Upper case and lower case are the same.`,
  code_placeholder: 'CODE',
  code_submit: 'USE THIS CODE',
  custom_line: 'Enter the code of a theme. Make your own in WORKSHOP.',
  desc_chart: 'The pieces of the sea chart',
  desc_marks: 'The icons on the map',
  desc_music: 'The playlist of the game',
  desc_sfx: 'The sound effects and the voice lines',
  desc_ui: 'The colours of the menus and the panels',
  desc_world: 'The map and combat',
  designer_lede: 'The map designer is a page in the browser that draws an Arcade map. It puts down the grid, the ridges and the trenches, the bases, the fields, the fleets, the sov claims and the markers, and it edits every setting of a map file.',
  designer_limit: 'A map file is an Arcade map, never a season map. A Premium account publishes its maps from the designer as community maps. Every account can download a map to keep it or to share it.',
  designer_step_1: '1 · Open the designer in a new tab.',
  designer_step_2: '2 · Pick a size preset, or set the size of the grid yourself.',
  designer_step_3: '3 · Paint with the eleven tools. A digit picks a brush, and the i key inspects one cell.',
  designer_step_4: '4 · The designer validates every setting while you edit. It then downloads the map as a JSON file.',
  effects_failed: (p: { message: string | number }) => `The pick did not save. The server said: ${p.message}`,
  effects_lede: 'An effect is a slow animation on your fleets, your torpedoes and your hold. It changes no rule and no figure. A new pick shows in the world after your next join.',
  err_entitlement: 'A custom theme needs the Supporter key.',
  err_failed: (p: { message: string | number }) => `The lookup failed. The server said: ${p.message}`,
  err_malformed: (p: { len: string | number; alphabet: string | number }) => `A code is ${p.len} symbols from ${p.alphabet}.`,
  err_not_found: 'This code has no theme of this category.',
  err_rate_limited: 'Too many lookups. Wait one minute, then try again.',
  err_unavailable: 'The server does not answer now. Try again later.',
  expires_note: (p: { date: string | number }) => `This grant ends on ${p.date}.`,
  fits_count: (p: { held: string | number; locked: string | number }) => `${p.held} HELD · ${p.locked} LOCKED`,
  fits_fewer: 'SHOW FEWER',
  fits_head: (p: { slot: string | number }) => `WHAT FITS ${p.slot}`,
  fits_lede_child: (p: { slot: string | number; parent: string | number }) => `${p.slot} wears the pick of ${p.parent} until you give it its own pick. Each slot wears one effect.`,
  fits_lede_fleet: 'ALL HULLS is the pick of every hull with no pick of its own. Each slot wears one effect.',
  fits_lede_hold: 'Your hold wears one effect.',
  fits_lede_torpedo: 'ALL KINDS is the pick of every kind with no pick of its own. Each slot wears one effect.',
  fits_more: (p: { count: number }) => plural(p.count, {
    one: `+ ${p.count} MORE`,
    other: `+ ${p.count} MORE`,
  }),
  follow_row: (p: { parent: string | number }) => `FOLLOW ${p.parent}`,
  follow_wears: (p: { name: string | number }) => `It wears ${p.name} now.`,
  follow_wears_none: 'It wears nothing now.',
  grant_ends: (p: { date: string | number }) => `ENDS ${p.date}`,
  grant_keeps: 'KEEPS',
  group_fleet: (p: { count: number }) => plural(p.count, {
    one: `FLEETS · ${p.count} HULL`,
    other: `FLEETS · ${p.count} HULLS`,
  }),
  group_hold: 'HOLD',
  group_torpedo: (p: { count: number }) => plural(p.count, {
    one: `TORPEDOES · ${p.count} KIND`,
    other: `TORPEDOES · ${p.count} KINDS`,
  }),
  hint_music: 'The pick plays here while this block is selected. The menu music comes back when you select another block.',
  hint_sfx: 'Each press on an option plays one effect of the theme.',
  in_use: '✓ IN USE',
  legend_follow: '↑ FOLLOWS ALL',
  legend_none: '— NOTHING',
  legend_own: '■ ITS OWN PICK',
  level_all: (p: { value: string | number }) => `ALL ${p.value}`,
  level_auto: 'STANDARD',
  level_flashy: 'LOUD',
  level_minimal: 'QUIET',
  locked_note: (p: { pick: string | number }) => `This value needs Supporter. Your pick did not change: it stays ${p.pick}.`,
  locked_tag: 'LOCKED',
  make_code: 'YOUR CODE',
  make_empty: 'YOU MADE NO THEME YET',
  make_empty_why: 'Open the theme workshop to make the first one.',
  make_lede: 'Make one custom theme in each category in the theme workshop. All your themes share one code. Another player types your code in a category to use your theme of that category.',
  make_links: (p: { n: number }) => plural(p.n, {
    one: `${p.n} ACCOUNT USES THIS THEME`,
    other: `${p.n} ACCOUNTS USE THIS THEME`,
  }),
  make_no_key: 'THIS NEEDS PREMIUM',
  make_no_key_why: 'A Premium account makes custom themes in the theme workshop. Every account uses a theme through its code.',
  make_version: (p: { version: string | number }) => `VERSION ${p.version}`,
  mix_fold: 'MIX BY CATEGORY',
  mix_lede: 'Pick one look for each part of the game.',
  no_audio: 'No theme sound is available yet, so this row has AUTO and CUSTOM only.',
  none_note: 'This slot wears no effect.',
  not_held_head: 'NOT HELD · HOW TO GET ONE',
  nothing_line: 'No effect on this slot.',
  nothing_row: 'NOTHING',
  open_designer: 'OPEN THE MAP DESIGNER',
  open_workshop: 'OPEN THE WORKSHOP',
  ov_code: 'CODE',
  ov_creator: 'CREATOR',
  ov_effects: 'EFFECTS CHANGED',
  ov_nobody: '—',
  ov_none: 'NONE',
  ov_off: 'OFF',
  ov_on: 'ON',
  ov_piece: (p: { piece: string | number; reading: string | number }) => `${p.piece} · ${p.reading}`,
  ov_pieces: 'PIECES CHANGED',
  ov_shuffle: 'SHUFFLE',
  ov_tracks: 'TRACKS',
  ov_version: 'VERSION',
  ov_voices: 'VOICE LINES CHANGED',
  preview_close: 'THE MAP, CLOSE UP',
  preview_hint: 'Press an option. The preview shows what it changes.',
  preview_hint_effects: 'Press a slot. The preview shows it on the fleet, the round or the hold.',
  preview_label: 'PREVIEW',
  preview_look: 'THE LOOK IN FORCE',
  preview_pick: (p: { what: string | number; value: string | number }) => `${p.what} · ${p.value}`,
  scope_fleet: 'ANY HULL',
  scope_hold: 'THE HOLD',
  scope_only: (p: { name: string | number }) => `${p.name} ONLY`,
  scope_torpedo: 'ANY KIND',
  sec_designer: 'MAP DESIGNER',
  sec_effects: 'EFFECTS',
  sec_themes: 'THEMES',
  sec_workshop: 'WORKSHOP',
  see_the_shop: 'SEE THE SHOP',
  slot_empty: '—',
  slot_fleet: 'ALL HULLS',
  slot_follows: (p: { name: string | number }) => `↑ ${p.name}`,
  slot_hold: 'YOUR HOLD',
  slot_torpedo: 'ALL KINDS',
  sum_designer: 'FREE',
  sum_effects: (p: { worn: string | number; held: string | number }) => `${p.worn} WORN · ${p.held} HELD`,
  sum_themes: (p: { changed: string | number; total: string | number }) => `${p.changed} OF ${p.total} CHANGED`,
  sum_themes_auto: 'ALL AUTO',
  sum_themes_custom: (p: { changed: string | number; total: string | number; custom: string | number }) => `${p.changed} OF ${p.total} CHANGED · ${p.custom} CUSTOM`,
  sum_workshop: (p: { links: number; made: string | number; total: string | number }) => plural(p.links, {
    one: `${p.made} OF ${p.total} MADE · ${p.links} LINK`,
    other: `${p.made} OF ${p.total} MADE · ${p.links} LINKS`,
  }),
  sum_workshop_locked: 'NEEDS PREMIUM',
  sum_workshop_none: 'NO THEME YET',
  suspended_note: 'SUSPENDED: the account does not hold the Supporter key, so this row shows AUTO. The pick stays stored and comes back with the key.',
  title: 'MODDING',
  title_sub: 'USE A THEME, MAKE A THEME',
  unresolved_note: (p: { code: string | number }) => `The server does not find the code ${p.code} now. This row shows AUTO until the code is found again.`,
  unset_code: 'UNSET CODE',
  use: 'USE',
  use_lede: 'Every player can use the bundled themes. A CUSTOM theme needs SUPPORTER or PREMIUM.',
  value_auto: 'AUTO',
  value_custom: 'CUSTOM',
  value_custom_code: (p: { code: string | number }) => `CUSTOM · ${p.code}`,
  value_none: 'NONE',
  wear: 'WEAR',
  whole_lede: 'One press sets WORLD, MARKS and CHART together. MIX BY CATEGORY sets one category alone.',
  whole_look: 'THE WHOLE LOOK',
  whole_mixed: 'MIXED',
  worn: '✓ WORN',
};

const hubNews_en: S.HubNews = {
  body_empty: 'THIS ARTICLE HAS NO BODY',
  body_empty_why: 'ONLY ITS TITLE IS PUBLISHED.',
  card_community_title: 'COMMUNITY',
  card_news_title: 'NEWS',
  community_join: '▸ JOIN THE DISCORD',
  community_lede: 'Join the community on Discord.',
  news_empty: 'NOTHING IS PUBLISHED YET',
  news_empty_why: 'NEWS ABOUT THE GAME SHOWS UP HERE.',
  subtitle: 'AND THE COMMUNITY',
  title: 'NEWS',
};

const hubPanel_en: S.HubPanel = {
  did_not_load: 'THIS DID NOT LOAD',
  dot_said: ', NEW',
  heading_join: ', ',
  included_in: (p: { plan: string | number }) => `INCLUDED IN ${p.plan}`,
  not_held: 'NOT HELD',
  switch_off: 'OFF',
  switch_on: 'ON',
  tier_free: 'FREE',
  tier_granted: 'GRANTED',
  tier_line: (p: { tier: string | number; state: string | number }) => `${p.tier} · ${p.state}`,
  tier_not_in_plan: 'NOT IN YOUR PLAN',
  tier_premium: 'PREMIUM',
  tier_supporter: 'SUPPORTER',
};

const hubPickup_en: S.HubPickup = {
  accept: 'ACCEPT',
  busy_accept: 'JOINING THE CLAN',
  busy_decline: 'DECLINING',
  busy_invite: 'SENDING THE INVITE',
  card_squad: 'LAST SEASON\'S SQUAD',
  decline: 'DECLINE',
  decline_armed: 'DECLINE?',
  invite: 'INVITE',
  invite_clan: (p: { name: string | number; tag: string | number }) => `${p.name} [${p.tag}]`,
  invite_from: (p: { name: string | number }) => `from ${p.name}`,
  invite_left: (p: { left: string | number }) => `ends in ${p.left}`,
  invites_lede: 'A clan asks you to join it. ACCEPT joins the clan and gives you its banner.',
  mate_season: (p: { mode: string | number; season: string | number }) => `${p.mode} · SEASON ${p.season}`,
  notice_invited: 'The invite is sent. It waits for an answer.',
  reason_clan_full: 'Your clan has no free place.',
  reason_in_clan: 'In a clan.',
  reason_invite_cap: 'Your clan has the most open invites.',
  reason_invited: 'Invited. The invite waits for an answer.',
  reason_no_clan: 'Found a clan or join one to invite.',
  reason_no_right: 'Only an officer or the owner invites.',
  refusal_already_invited: 'YOUR CLAN HAS ALREADY INVITED THAT PLAYER.',
  refusal_invite_cap: 'YOUR CLAN HAS THE MOST OPEN INVITES.',
  refusal_invite_expired: 'THAT INVITE HAS EXPIRED.',
  refusal_invitee_in_clan: 'THAT PLAYER IS IN A CLAN.',
  refusal_not_pickup_mate: 'YOU DID NOT SAIL IN A PICKUP SQUAD WITH THAT PLAYER.',
  squad_lede: 'You sailed with these players in a pickup squad last season. A pickup squad does not stay together. An officer of a clan can invite each of them to the clan.',
  squad_more: 'PICKUP SQUAD',
};

const hubPlay_en: S.HubPlay = {
  arcade_spent_upsell: (p: { line: string | number }) => `${p.line} · SUPPORTER GETS MORE RUNS A DAY`,
  card_your_seat: (p: { mode: string | number }) => `YOUR SEAT · ${p.mode}`,
  clan_not_registered: 'YOUR CLAN IS NOT IN THIS WAR',
  cta_resume: 'RESUME',
  fix_arcade: 'PLAY ARCADE',
  fix_clan: 'FIND ONE',
  fix_shop: 'SEE THE SHOP',
  mode_arcade_cta: 'PLAY',
  mode_arcade_kick: 'FAST · A SEPARATE LADDER',
  mode_arcade_name: 'ARCADE',
  mode_clanwar_cta: 'MUSTER',
  mode_clanwar_kick: 'SCHEDULED · CLANS ONLY',
  mode_clanwar_name: 'CLAN WAR',
  mode_core_cta: 'PLAY',
  mode_core_kick: 'ALWAYS OPEN · THE FULL GAME',
  mode_core_name: 'CONQUEST',
  mode_custom_name: 'CUSTOM',
  mode_event_cta: 'JOIN',
  mode_event_kick: 'SCHEDULED · A SEPARATE LADDER',
  mode_event_name: 'EVENT',
  no_modes: 'NO MODE IS OPEN NOW',
  no_modes_why: 'LOOK AGAIN LATER.',
  no_open_seat: 'NO SEAT OF YOURS IS OPEN NOW',
  no_open_seat_why: 'THE TILE OF ITS MODE ABOVE SAYS WHY.',
  no_seat: 'YOU HOLD NO SEAT YET',
  no_seat_why: 'PLAY TAKES A SEAT IN ONE WORLD FOR ONE SEASON. YOUR CAPTAINS STAY WHEN IT ENDS.',
  open_sea_view: 'OPEN SEA VIEW',
  push_ask: 'SIEGE ALERTS ARE OFF ON THIS DEVICE',
  push_ask_fix: 'TURN THEM ON',
  resume_seat: 'RESUME THIS SEAT',
  row_away: 'WHILE YOU WERE OUT',
  row_queue: 'QUEUE',
  row_season: 'SEASON',
  row_season_end: 'SEASON ENDS',
  row_standing: 'STANDING',
  row_territory: 'TERRITORY',
  row_window: 'NEXT WINDOW',
  row_world: 'WORLD',
  seat_undescribed: 'NO REPORT FROM THIS WORLD JUST NOW',
  seat_undescribed_why: 'THE FIGURES COME BACK WITH ITS NEXT REPORT. YOU CAN RESUME THE SEAT NOW.',
  state_clan_not_registered: (p: { state: string | number }) => `${p.state} · YOUR CLAN IS NOT IN THIS WAR`,
  state_commitment: (p: { days: string | number }) => `ONE SEASON IS ${p.days} DAYS`,
  state_commitment_with: (p: { n: string | number; days: string | number }) => `${p.n} PLAYING · ONE SEASON IS ${p.days} DAYS`,
  state_your_seat: 'YOUR SEAT',
  state_your_seat_population: (p: { n: string | number }) => `YOUR SEAT · ${p.n} PLAYING`,
  state_your_seat_with: (p: { state: string | number }) => `YOUR SEAT · ${p.state}`,
  title: 'PLAY',
  title_sub: 'FOUR MODES',
};

const hubRanks_en: S.HubRanks = {
  board_clans: 'CLANS',
  board_honour: 'HONOUR',
  board_memorials: 'MEMORIALS',
  board_seasons: 'SEASONS',
  card_history_title: 'HISTORY',
  clan_row: (p: { tag: string | number; name: string | number }) => `[${p.tag}] ${p.name}`,
  clans_empty: 'NO CLAN HOLDS CLAN HONOUR YET',
  clans_empty_press: '▸ CLAN',
  clans_empty_why: 'AT EACH CLAN WAR CLOSE, A CLAN EARNS WHAT ITS MEMBERS EARNED IN THAT WORLD.',
  col_honour: 'HONOUR',
  col_name: 'COMMANDER',
  col_seasons: 'SEASONS',
  col_title: 'TITLE',
  gap_value: (p: { value: string | number }) => `+${p.value}`,
  history_empty: 'NO SEASON HAS CLOSED YET',
  history_empty_why: 'EACH CLOSED SEASON KEEPS ITS FINAL LADDER HERE.',
  honour_value: (p: { honour: string | number }) => `${p.honour} HONOUR`,
  ladder_arcade_press: '▸ PLAY THE ARCADE',
  ladder_empty: 'THIS LADDER IS EMPTY',
  ladder_empty_press: '▸ PLAY A SEASON',
  ladder_empty_why: 'NO ACCOUNT HAS SCORED HONOUR YET.',
  ladder_row: (p: { place: string | number; name: string | number }) => `${p.place} · ${p.name}`,
  memorial_label: (p: { world: string | number; season: string | number }) => `${p.world} · SEASON ${p.season}`,
  memorial_score: (p: { score: string | number }) => `${p.score} PTS`,
  memorial_shown: (p: { n: number }) => plural(p.n, {
    one: `SHOWN ON ${p.n} MAP`,
    other: `SHOWN ON ${p.n} MAPS`,
  }),
  memorials_empty: 'THE MEMORIAL POOL IS EMPTY',
  memorials_empty_why: 'A WORLD ADDS ITS WINNER WHEN A SEASON CLOSES.',
  memorials_lede: 'THE WINNERS OF EVERY WORLD. AT EACH SEASON ROLL, SOME OF THESE NAMES STAND ON THE MAPS OF OTHER WORLDS.',
  season_closed_ago: (p: { ago: string | number }) => `CLOSED ${p.ago}`,
  season_empty: 'THIS TABLE IS EMPTY',
  season_empty_why: 'THE SEASON REPORT LISTS NO COMMANDER.',
  season_label: (p: { world: string | number; season: string | number }) => `${p.world} · SEASON ${p.season}`,
  season_open: 'THIS SEASON HAS NOT CLOSED YET',
  season_open_why: 'A WORLD WRITES ITS SEASON TABLE WHEN THE SEASON CLOSES.',
  show_row: '▸ SHOW MY ROW',
  snapshot_empty: 'THIS LADDER IS EMPTY',
  snapshot_empty_why: 'NO ACCOUNT EARNED HONOUR IN THAT SEASON.',
  snapshot_label: (p: { board: string | number; season: string | number }) => `${p.board} EARNED IN SEASON ${p.season}`,
  snapshot_more: (p: { mode: string | number; ago: string | number }) => `${p.mode} · ${p.ago}`,
  subtitle: 'ALL PLAYERS',
  sum_clan: (p: { tag: string | number; place: string | number }) => `[${p.tag}] ${p.place}`,
  sum_clan_tag: (p: { tag: string | number }) => `[${p.tag}]`,
  sum_ladder: (p: { tier: string | number; place: string | number }) => `${p.tier} · ${p.place}`,
  sum_mode: (p: { mode: string | number; value: string | number }) => `${p.mode} · ${p.value}`,
  sum_no_clan: 'NO CLAN',
  sum_place: (p: { place: string | number; value: string | number }) => `${p.place} · ${p.value}`,
  sum_season: (p: { season: string | number; place: string | number }) => `SEASON ${p.season} · ${p.place}`,
  sum_season_open: (p: { season: string | number }) => `SEASON ${p.season} · OPEN`,
  title: 'RANKS',
  title_clans: 'CLANS · CLAN HONOUR',
  title_clanwar: 'CLAN HONOUR · LIFETIME',
  title_event: 'EVENT LADDER · LIFETIME',
  title_honour: 'HONOUR · LIFETIME',
  to_record: '▸ RECORD',
  toggle_clanwar: 'CLAN WAR',
  toggle_core: 'CORE',
  toggle_event: 'EVENT',
  toggle_label: 'MODE',
  unranked: 'UNRANKED',
  unranked_you: 'YOU',
  you_below: 'THE BOARD SHOWS THE FIRST PLACES. YOUR ROW STANDS BELOW THEM.',
  you_board_empty: 'NOBODY HAS A PLACE ON THIS BOARD YET.',
  you_card: 'YOU',
  you_first: 'YOU HOLD THE FIRST PLACE.',
  you_label: 'YOU ON THIS BOARD',
  you_next: 'NEXT PLACE',
  you_no_clan: 'YOU ARE IN NO CLAN. A CLAN EARNS CLAN HONOUR IN A CLAN WAR.',
  you_off_page: 'THE BOARD SHOWS THE FIRST PLACES, AND YOUR ROW IS NOT AMONG THEM.',
};

const hubRecord_en: S.HubRecord = {
  card_chronicle: 'SEASON CHRONICLE',
  card_last_season: 'LAST SEASON',
  card_newest: 'NEWEST BADGES',
  card_standing: 'STANDING',
  chronicle_lede: 'THE GAME WRITES THE STORY OF YOUR SEASON BY ITSELF: THE BATTLE REPORTS, THE FLIPS AND THE CAPTAIN EVENTS.',
  chronicle_writing: (p: { days: number }) => plural(p.days, {
    one: `YOUR SEASON IS BEING WRITTEN: ${p.days} DAY`,
    other: `YOUR SEASON IS BEING WRITTEN: ${p.days} DAYS`,
  }),
  honour_value: (p: { n: string | number }) => `${p.n} HONOUR`,
  last_captains_lost: (p: { n: string | number; lost: string | number }) => `${p.n} · ${p.lost} LOST`,
  last_chronicle: '▸ CHRONICLE',
  last_honour_value: (p: { n: string | number }) => `+${p.n}`,
  last_place_of: (p: { place: string | number; of: string | number }) => `${p.place} OF ${p.of}`,
  last_row_captains: 'CAPTAINS CARRIED',
  last_row_clan: 'YOUR CLAN',
  last_row_honour: 'HONOUR EARNED',
  last_row_you: 'YOU',
  last_sea: '▸ THE SEA',
  last_share: 'SHARE',
  newest_none: 'NO BADGE YET',
  nothing_recorded: 'NOTHING IS RECORDED YET',
  pick_hint: 'PRESS A ROW OF A CATEGORY TO PICK IT.',
  pick_label: 'YOUR PICK',
  reach_label: 'WITHIN REACH',
  reach_none: 'NO NEXT STEP IS IN SIGHT YET. YOUR NEWEST BADGES:',
  reach_play: '▸ PLAY',
  reach_value: (p: { now: string | number; next: string | number }) => `${p.now} / ${p.next}`,
  row_best_score: 'BEST SEASON SCORE',
  row_fleets_lost: 'FLEETS LOST',
  row_hex_taken: 'CELLS TAKEN',
  row_honour_clanwar: 'HONOUR · CLAN',
  row_honour_core: 'HONOUR · CORE',
  row_honour_event: 'HONOUR · EVENT',
  row_progress: 'PROGRESS',
  row_seasons_played: 'SEASONS PLAYED',
  sec_achievements: 'ACHIEVEMENTS',
  sec_chronicle: 'CHRONICLE',
  sec_overview: 'OVERVIEW',
  sec_statistics: 'STATISTICS',
  see_the_shop: 'SEE THE SHOP',
  stats_empty_press: '▸ PLAY A SEASON',
  stats_empty_why: 'NO SEASON HAS WRITTEN A COUNTER FOR THIS ACCOUNT.',
  stats_more: 'LIFETIME',
  sum_achievements: (p: { held: string | number; total: string | number }) => `${p.held} OF ${p.total}`,
  sum_chronicle: (p: { days: number; season: string | number }) => plural(p.days, {
    one: `S${p.season} · ${p.days} DAY WRITTEN`,
    other: `S${p.season} · ${p.days} DAYS WRITTEN`,
  }),
  sum_chronicle_none: 'NO VOLUME YET',
  sum_overview_honour: (p: { honour: string | number }) => `HONOUR ${p.honour}`,
  sum_statistics: (p: { score: string | number; seasons: number }) => plural(p.seasons, {
    one: `${p.seasons} SEASON · BEST ${p.score}`,
    other: `${p.seasons} SEASONS · BEST ${p.score}`,
  }),
  sum_statistics_none: 'NOTHING RECORDED YET',
  title: 'RECORD',
  title_sub: 'YOU · LIFETIME',
  to_achievements: '▸ ACHIEVEMENTS',
  to_ranks: '▸ RANKS',
  volumes_label: 'VOLUMES',
};

const hubReport_en: S.HubReport = {
  busy: 'SENDING …',
  cancel: 'CANCEL',
  lede: 'Say why this breaks the rules of the terms. An operator reads the report and a copy of the content as it stands now. You get no answer beyond "report received".',
  note_box: 'WHAT IS WRONG (OPTIONAL)',
  pick_reason: 'pick a reason first',
  reason_field: 'REASON',
  reason_harassment: 'HARASSMENT',
  reason_hate: 'HATE',
  reason_illegal: 'ILLEGAL CONTENT',
  reason_impersonation: 'IMPERSONATION',
  reason_other: 'OTHER',
  reason_sexual: 'SEXUAL CONTENT',
  reason_spam: 'SPAM',
  reason_violence: 'VIOLENCE OR THREATS',
  received_pill: 'REPORTED',
  report: 'REPORT',
  send: 'SEND REPORT',
};

const hubSettings_en: S.HubSettings = {
  account_lede: 'One account can hold all sign-in methods at once.',
  account_lede_guest: 'This is a guest seat. Link a sign-in method and the seat becomes an account. It keeps the captains and the Honour it has now.',
  account_what: 'the sign-in methods, the password, the delete and the themes',
  advisor_desc: 'One next good action above the build queue in the game. Your account keeps the switch, and a world takes it at your next join.',
  erase_armed: 'DELETE ACCOUNT?',
  erase_busy: 'DELETING …',
  erase_go: 'DELETE',
  erase_lede: 'The delete removes the account, and nobody can undo it: the captains, the Honour, the clan place and every setting go with it. A clan you own goes to its senior member. A chat line you wrote stays, under a neutral name. A paid plan that still runs must be cancelled first.',
  erase_lede_guest: 'The delete removes the guest seat, and nobody can undo it: the captains, the Honour and every setting go with it. A chat line you wrote stays, under a neutral name.',
  erase_mismatch: 'the box does not hold the account name',
  erase_name_box: (p: { name: string | number }) => `TYPE ${p.name}`,
  erase_password_box: 'PASSWORD',
  erase_section: 'DELETE THE ACCOUNT',
  password_busy: 'CHANGING …',
  password_changed: 'the password is changed, and every other session is signed out',
  password_continue: 'CONTINUE',
  password_current_box: 'CURRENT PASSWORD',
  password_lede: 'The password of the email method. Every other browser you are signed in on is signed out.',
  password_new_box: 'NEW PASSWORD',
  password_section: 'CHANGE PASSWORD',
  reauth_busy: 'SIGNING OUT …',
  reauth_go: 'SIGN IN AGAIN',
  reauth_lede: 'This change needs a recent sign-in. Sign in again, then press the control once more.',
  signin_apple: 'APPLE',
  signin_apple_desc: 'Apple answers for this method.',
  signin_busy: 'LINKING …',
  signin_checking: 'CHECKING',
  signin_continue: 'CONTINUE',
  signin_email: 'EMAIL',
  signin_email_box: 'EMAIL',
  signin_email_desc: 'A mail address and a password.',
  signin_google: 'GOOGLE',
  signin_google_desc: 'Google answers for this method.',
  signin_has_password: 'this account already holds a password',
  signin_link: 'LINK',
  signin_linked: 'LINKED',
  signin_off: 'NOT OFFERED YET',
  signin_password_box: 'PASSWORD',
  signin_section: 'SIGN-IN METHODS',
  sound_absent: 'No sound is available yet, so nothing plays. The rows below stay set, and they take effect when the sound arrives.',
  subtitle: 'ACCOUNT AND GAME',
  title: 'SETTINGS',
};

const hubShop_en: S.HubShop = {
  card_handoff_title: 'THE CHECKOUT HAND-OFF',
  card_plans_title: 'THE PLANS',
  card_rule_title: 'THE RULE',
  entitlement_granted: 'GRANTED',
  free_arcade: 'ARCADE',
  free_arcade_value: 'A RUN A DAY',
  free_core: 'CORE SEASONS',
  free_core_value: 'FULL',
  free_queue: 'BUILD QUEUE',
  free_queue_value: (p: { hours: string | number }) => `${p.hours} H`,
  free_summary: 'SEASON SUMMARY CARD',
  free_summary_value: 'YES',
  free_wardroom: 'WARDROOM',
  free_wardroom_value: 'CORE ROSTER',
  handoff_client_token: 'CLIENT TOKEN',
  handoff_environment: 'ENVIRONMENT',
  handoff_lede: 'The server states which price and which account. It creates nothing at the payment provider, and the webhook is the only thing that grants an entitlement. This build loads no overlay script, so nothing opened: the answer is printed here instead.',
  handoff_on_cancel: 'ON CANCEL',
  handoff_on_success: 'ON SUCCESS',
  handoff_plan: 'PLAN',
  handoff_price_id: 'PRICE ID',
  handoff_token_none: 'NONE',
  handoff_token_sent: 'SENT',
  pill_clear: 'CLEAR',
  plan_choose: (p: { plan: string | number }) => `CHOOSE ${p.plan}`,
  plan_free_note: 'The server lists no free row, because the route lists what a person buys. This column is what an account with no plan already holds.',
  plan_free_price: 'NO CHARGE',
  plan_held_head: 'YOUR PLAN',
  plan_held_pill: 'THE ACCOUNT HOLDS THIS',
  plan_opening: 'OPENING…',
  plan_price_interval: (p: { price: string | number; interval: string | number }) => `${p.price} / ${p.interval}`,
  plans_empty: 'THE SHOP OFFERS NO PLAN YET',
  plans_empty_why: 'Look again later, or ask the team.',
  plans_empty_why_held: (p: { plan: string | number }) => `Your account holds ${p.plan}. Look again later.`,
  refusal_other: 'THE CHECKOUT WAS NOT OPENED',
  refusal_plan_unknown: 'THE SHOP DOES NOT SELL THAT PLAN',
  refusal_registration_required: 'SAVE THIS ACCOUNT WITH A MAIL ADDRESS BEFORE YOU BUY A PLAN',
  rule: 'Money never buys strength. A season is decided by free players and paid players on the same water. Resources, credits, prints and print runs, blueprint slots, captain attributes, Honour and detection range are all on the never-sell list. A plan sells identity, comfort and more places to play to finance server costs.',
  shop_disabled_why: 'The shop sells nothing yet. To get a plan now, ask the team.',
  shop_disabled_why_held: (p: { plan: string | number }) => `Your account holds ${p.plan}. The shop sells nothing yet, and the final prices are not set.`,
  shop_not_connected: 'THE SHOP IS CLOSED FOR NOW',
  subtitle: 'PLANS PAY FOR THE SERVERS',
  title: 'SHOP',
};

const hubState_en: S.HubState = {
  ago: (p: { span: string | number }) => `${p.span} AGO`,
  arcade_left_line: (p: { left: string | number; limit: string | number }) => `${p.left} OF ${p.limit} RUNS LEFT TODAY`,
  arcade_not_loaded: 'THE COUNTER IS NOT LOADED',
  arcade_reset_suffix: (p: { left: string | number }) => ` · RESETS IN ${p.left}`,
  arcade_spent_line: (p: { limit: string | number; when: string | number }) => `ALL ${p.limit} RUNS USED TODAY${p.when}`,
  arcade_unlimited_corner: 'UNLIMITED',
  arcade_unlimited_line: 'UNLIMITED RUNS',
  as_of: (p: { ago: string | number }) => `AS OF ${p.ago}`,
  away_nothing: 'NOTHING',
  away_raids: (p: { n: number }) => plural(p.n, {
    one: ` (${p.n} RAID)`,
    other: ` (${p.n} RAIDS)`,
  }),
  away_unread: (p: { n: number }) => plural(p.n, {
    one: `${p.n} UNREAD MESSAGE`,
    other: `${p.n} UNREAD MESSAGES`,
  }),
  cells_taken: (p: { n: number }) => plural(p.n, {
    one: `${p.n} CELL TAKEN`,
    other: `${p.n} CELLS TAKEN`,
  }),
  corner_clans: 'CLANS',
  corner_closed: 'CLOSED',
  corner_event: 'EVENT',
  corner_open: 'OPEN',
  just_now: 'JUST NOW',
  maintenance_at: (p: { time: string | number; left: string | number }) => `MAINTENANCE AT ${p.time} · IN ${p.left}`,
  never: 'NEVER',
  no_clan_reason: 'YOU ARE IN NO CLAN',
  no_word_yet: 'NO WORD FROM THIS WORLD YET',
  now: 'NOW',
  ordinal_nd: (p: { n: string | number }) => `${p.n}ND`,
  ordinal_rd: (p: { n: string | number }) => `${p.n}RD`,
  ordinal_st: (p: { n: string | number }) => `${p.n}ST`,
  ordinal_th: (p: { n: string | number }) => `${p.n}TH`,
  queue_busy: (p: { n: number }) => plural(p.n, {
    one: `BUSY · ${p.n} JOB`,
    other: `BUSY · ${p.n} JOBS`,
  }),
  queue_idle: (p: { left: string | number }) => `EMPTY · ROOM FOR ${p.left}`,
  queue_left: (p: { busy: string | number; h: string | number }) => `${p.busy} · ${p.h} H`,
  rank_of: (p: { rank: string | number; total: string | number }) => `${p.rank} OF ${p.total}`,
  reason_key_only: (p: { key: string | number }) => `${p.key} ONLY`,
  reason_no_free_seat: 'NO WORLD OF THIS MODE HAS A FREE SEAT',
  reason_no_window: 'NO WINDOW IS SCHEDULED',
  reason_not_open_yet: 'THIS MODE IS NOT OPEN YET',
  reason_starts_in: (p: { left: string | number }) => `STARTS IN ${p.left}`,
  reason_tier_only: (p: { tier: string | number }) => `${p.tier} ONLY`,
  rename_invalid_name: (p: { name_min: string | number; name_max: string | number }) => `THAT NAME IS REFUSED. USE ${p.name_min} TO ${p.name_max} CHARACTERS AND NO CONTROL CHARACTERS.`,
  rename_name_taken: 'ANOTHER ACCOUNT HOLDS THAT NAME. PICK A DIFFERENT ONE.',
  rename_other: 'THE NAME WAS NOT CHANGED.',
  rename_spent: 'THE ONE FREE CHANGE IS SPENT. ASK A PERSON FOR A SECOND ONE.',
  season: (p: { n: string | number }) => `SEASON ${p.n}`,
  season_ends: (p: { time: string | number; left: string | number }) => `${p.time} · IN ${p.left}`,
  span_dh: (p: { d: string | number; h: string | number }) => `${p.d}D ${p.h}H`,
  span_hm: (p: { h: string | number; m: string | number }) => `${p.h}H ${p.m}M`,
  span_ms: (p: { m: string | number; s: string | number }) => `${p.m}M ${p.s}S`,
  state_always_open: 'ALWAYS OPEN',
  state_running: 'RUNNING',
  state_running_ends: (p: { left: string | number }) => `RUNNING · ENDS IN ${p.left}`,
  state_with_population: (p: { state: string | number; n: string | number }) => `${p.state} · ${p.n} PLAYING`,
  tile_siege_in: (p: { site: string | number; left: string | number }) => `SIEGE AT ${p.site} · IN ${p.left}`,
  tile_siege_open: (p: { site: string | number }) => `SIEGE AT ${p.site} · OPEN NOW`,
  tile_window_at: (p: { time: string | number; left: string | number }) => `WINDOW ${p.time} · IN ${p.left}`,
  tile_window_open: (p: { left: string | number }) => `WINDOW OPEN NOW · SHUTS IN ${p.left}`,
  window_at: (p: { time: string | number; left: string | number }) => `${p.time} · IN ${p.left}`,
  window_join: ' · ',
  window_open_now: (p: { left: string | number }) => `OPEN NOW · SHUTS IN ${p.left}`,
  zone_label: (p: { zone: string | number; mark: string | number }) => `${p.zone} · ${p.mark}`,
};

const hubSupport_en: S.HubSupport = {
  a_account_device_1: 'Not on a registered account. Sign in on any device, and the account brings its captains, its Honour, its clan and every setting with no DEVICE mark. A guest account lives in this browser alone. When you press END GUEST SEAT or LOG OUT, or clear the browser, the guest account cannot come back.',
  a_account_device_2: 'To keep a guest account, register it. Open SETTINGS, press the row with your name to open the ACCOUNT page, and press LINK on a row of SIGN-IN METHODS. The account keeps the captains and the Honour it has now. At the end of a Core season, the game deletes a guest account that nobody registered, and the GUEST ACCOUNT card warns you first.',
  a_arcade_runs_1: (p: { free: string | number; guest: string | number }) => `${p.free} runs a day on a registered account with no plan, and ${p.guest} on a guest account, by default. Supporter raises the cap, and Premium removes it. A match takes one run from each human seat when it starts. A queue that never fills takes no run, and a drill takes none.`,
  a_arcade_runs_2: 'The counter belongs to your account and not to the browser. A new browser or a cleared store therefore gives a registered account no new run. The window resets at 00:00 UTC. The ARCADE tile of PLAY shows the runs you have left.',
  a_better_design_1: 'Build a Ship Design office, then open DRAFT · INVENTION. Pick a hull and at most one module of each family that your research opened. The office level sets the number of module slots. Press INVENT DESIGN, and the draft joins the build queue. When it finishes, each module rolls a grade from Flawed to Perfect, and most rolls land low. The draft files a master.',
  a_better_design_2: 'A master never builds a hull. Press PRINT on it to cut a print with a number of runs, then press INSTALL. The Shipyard builds that hull class to the print, and each hull uses one run. An install is one-way. REDRAFT rolls one module of a master again, and only a higher roll stays. The auction sells the prints of other commanders.',
  a_block_report_1: 'Press ⋯ beside a chat line of another player, then BLOCK or REPORT. A block hides the lines of that account from you alone, in the clan chat and in every channel of a world. Nobody learns of a block. To lift one, press LIFT in BLOCKED ACCOUNTS, in the SOCIAL section of SETTINGS or of ☸ OPTIONS.',
  a_block_report_2: (p: { note: string | number }) => `To report a name, press ⚑ beside it, for example in the season table or on the card of a fleet. Pick a REASON, write a note of up to ${p.note} characters if you want, and press SEND REPORT. A person of the team reads every report with a copy of the content. You get no answer beyond "report received".`,
  a_build_first_1: 'Income first, because every other plan waits on it. Your hold already mines a small yield of each resource, and each mine level raises it. Alloy pays for most buildings and hulls, so the Alloy Mine leads. No building can stand above the level of the Command Centre, so raise the Command Centre when its next level is in reach.',
  a_build_first_2: 'Then build a Shipyard, because no hull builds without one. Send your Dredger to gather at a deposit, and build a Beacon to take cells. Add Storage when a store comes near its cap. A Research Lab opens the tiers of research, and a Recruiting Office brings more cadets and roster slots. The advisor line names the next step, and its TRIALS count lists the first acts.',
  a_captain_life_1: (p: { attrs: string | number; cap: string | number; per_point: string | number; peaked: string | number }) => `A captain has ${p.attrs} attributes, 1 to ${p.cap} each. A point of Gunnery or Helmsmanship is worth ${p.per_point}% on the figure it moves, and each other attribute has its own rate. A peaked Gunnery captain is therefore worth about ${p.peaked}% on gun and torpedo damage, by design.`,
  a_captain_life_2: (p: { min: string | number; max: string | number; years: string | number; peak: string | number; decline: string | number; slots: string | number; slots_max: string | number }) => `A cadet joins at ${p.min} to ${p.max} years old, and an older cadet starts stronger. Every captain ages ${p.years} years at each season roll of a season that you play, at sea or in port. In a season that you do not play at all, Cryo Freeze stops the aging, and without it the captains age as usual. The rise runs to age ${p.peak}, the peak to age ${p.decline}, and from ${p.decline} the retirement or death roll starts. A roster opens with ${p.slots} slots, and each Recruiting Office level adds one, up to ${p.slots_max}.`,
  a_clan_free: 'A clan costs nothing to found for now.',
  a_clan_squad_1: (p: { members: string | number; squads: number }) => plural(p.squads, {
    one: `A clan holds up to ${p.members} members in ${p.squads} squad. It belongs to no single world, and it outlives the world it plays in. Its chat is therefore global: every member reads the same room whatever world that member sits in.`,
    other: `A clan holds up to ${p.members} members in up to ${p.squads} squads. It belongs to no single world, and it outlives the world its squads play in. Its chat is therefore global: every squad reads the same room whatever world it sits in.`,
  }),
  a_clan_squad_2: 'The squad plan applies at the next season start. The world you play now keeps the squads it placed, and nothing moves a commander who already plays in a world.',
  a_connection_1: 'When the link to a world drops, the timer line reads CONNECTION LOST and counts down to the next try. The game then reconnects by itself, and your seat waits. If the line reads "not retrying — reload to reconnect", reload the page. The MAINTENANCE cover and the CLIENT / SERVER VERSION MISMATCH screen reload the page by themselves.',
  a_connection_2: 'When the problem stays, run the network check. Press CHECK THE NETWORK on the ASK A PERSON page here, or CHECK on the network check row of ☸ OPTIONS · HELP in the game. Keep the page open and do not lock the screen while the check runs. Then press SEND TO THE TEAM, or press COPY and send the result by mail.',
  a_credits_1: 'Credits pay for a rush, for prints and Isotope lots at the auction, for a ransom and for the casino. They also pay the recruiter: PASS on a cadet and RELEASE on a captain cost Credits. RUSH on a row of the build queue finishes that job at once, and its price grows with the work that remains. No building, hull or node costs Credits.',
  a_credits_2: 'Each empire starts the season with a stock of Credits. After that, an idle build queue is the one source of new Credits: while no job runs, the QUEUE EMPTY line states the rate. A sale at the auction and a ransom for a captain in your Brig pay Credits too. The game never sells Credits for real money, and the season roll resets them.',
  a_drill_1: 'In a drill. A drill is a short arcade match for you alone. Its drill steps teach the controls and the acts of a fight one at a time, and the next step opens when you do the act. Fleets, orders, sonar, torpedoes, Beacons and Sentinels work the same in conquest and in the arcade, so the drills serve both modes. A drill uses no arcade run, and it leaves no record of a match: it awards no Honour and no captains.',
  a_drill_2: 'Open the arcade, open the DRILLS section and press START on a drill. A drill stays open on a day when your runs are spent. You can leave a drill at any time, and START AGAIN starts it again from the first step. The economy of conquest is not in a drill: the sea trials of your first Core seasons teach it.',
  a_enemy_hold_1: 'No. No siege, order or rule lets a player take, capture or siege a hostile hold, and a hold never passes to another commander. A hold is the home of one commander. It anchors the supply of that commander, keeps the water round it with its beam and carries a sonar ring. Its torpedo tubes can also fire at hostile fleets near it.',
  a_enemy_hold_2: 'Contest what can change owner instead. Take cells with your Beacons, sink hostile fleets on the map, and pledge fleets in the siege window of a strategic object. Each of these adds to your season score. The water next to a hostile hold is the hardest ground to take, because the hold works on that ground at full strength.',
  a_expedition_1: 'An expedition is a dive of one captain to one depth, and no hull sails. It is the only source of new Isotopes, and a dive can also bring back a Data Core. Open FLEET · EXPEDITIONS, press START on a depth and send a captain who is ashore and fit. The dive holds a mission slot, and its outfit job waits in the build queue first.',
  a_expedition_2: 'Each depth row states the yield, the chance of a core and the risk for your empire. The shallow depth is open to every commander. A deeper depth needs a higher Dive Control level, lasts longer and brings back more. An injured captain goes to the Sickbay and grows older. Dive Control and the captain\'s Prospecting cut the risk, but nothing removes it.',
  a_fight_1: 'Guns fire by themselves. A gun shoots at the nearest hostile in its reach that you hear, with no rock between them. Most classes fire only into the half ahead of the bow, but the Corsair and the Sentinel fire all round. Shields take damage first, then the hull. Each class has a counter: a Cutlass beats a Corsair, a Corsair beats a Falconet or a Basilisk, and those two beat a Cutlass.',
  a_fight_2: 'The approach decides much of a fight before the first shot. A shot on the beam of a hull deals more damage than a shot on its bow. A shot on its stern deals the most. The first shot of a hull that the target does not hear deals extra damage. Each warship has one signature order with one charge, on its fleet card. While you are away, the game spends it at the trigger of its class.',
  a_fleet_sunk_1: 'The hull is lost, and its cargo goes down with it. The INBOX files a loss message that names what sank it and the damage it took. ⟲ REPLACE in that message queues the same hull again, at the end of the queue and at the full price. A loss takes no point from your season score.',
  a_fleet_sunk_2: 'The captain is never lost to a sinking. When the nearest enemy fleet stands inside the reach of its own Brig, its empire rolls once to take the captain prisoner. Otherwise the captain comes home wounded and rests in the Sickbay before it can board again. PAY RANSOM buys a prisoner back for Credits, and the Cataclysm frees every prisoner.',
  a_fog_of_war_1: 'Because no source that reports to you hears it. The server decides detection. Your map receives an enemy fleet only while such a source hears it, or while the ping of a Vedette holds it. A source hears a fleet when the distance is below its own range multiplied by the noise of that fleet. A slow, quiet hull is therefore heard late, and a fast, loud one early.',
  a_fog_of_war_2: 'Even a contact you do hear arrives with its composition stripped. No setting shows you more, because your game receives more only when a Vedette pings the contact. The sonar layer on the map is a picture only: it hides nothing from anybody, you included.',
  a_give_order_1: 'Select one of your fleets, then point at the target. With a mouse, a right-click gives the order that fits the target. Water moves the fleet, and an enemy contact sends it to attack that hull alone. A friendly fleet starts an escort, a deposit sends a Dredger to gather, and your hold sends the fleet home. On a telephone, a tap or a drag from the fleet gives the same order.',
  a_give_order_2: 'The card of a selected fleet holds the order row: the order of its class, then HUNT, then ⋯ with the other orders. HUNT advances on a point and attacks each hostile the fleet hears on the way. MOVE keeps its course past every contact. PATROL sails between two points, ESCORT follows a friendly fleet, HOLD keeps the water, and RETURN sails home and docks.',
  a_honour_1: 'Standing, and nothing stronger. At the end of each Core season your season score becomes Honour, and Honour never decays. Your lifetime Honour sets your rank title on the Honour ladder, from Drifter up to Legend of the Trench. In the game, the title stands in the top bar beside your place in the season table.',
  a_honour_2: 'A rank title opens no hull, tech, mode or stat, and money never buys Honour. RANKS · HONOUR here lists the lifetime ladder of all players. Event seasons keep a ladder of their own, and a Clan War pays Clan Honour, apart from your Core Honour. An arcade match pays no Honour: the arcade rating is a separate ladder.',
  a_join_1: 'Press PLAY on the CONQUEST tile. Conquest is always open, so you can join a season that runs now. Your first join lands in the world that the game keeps free for new commanders. There you take one empire for the season. The autopilot has played that empire since the season began, and it stands down for the rest of the season when you take command.',
  a_join_2: 'The founding truce protects every empire for the first hours of a season only. A late joiner usually arrives after it, so a hostile fleet can attack at once. You do not pick a faction in a world. A clan gives its members its faction, and its founder picks it in CLAN · START ONE. With no clan, you get the faction with the fewest players. A new faction applies from the next season.',
  a_never_sell_1: 'Resources, Credits, prints and print runs, blueprint slots, captain attributes and talents, Honour, the manipulation of a gauge or of a vulnerability window, detection range and sonar range, and mission caps.',
  a_never_sell_2: 'Payment also buys no earlier and no exclusive war information: window timers and siege alerts reach every player the same way. A plan sells identity, comfort and more places to play.',
  a_next_step_1: 'Read the advisor line. In the game it stands above the build queue, and it names one next step and the reason for it. A press on the line opens the panel on the right row. You then give the order yourself, because the advisor gives no order. In the same seasons the TRIALS count on the line opens the list of the first acts of a commander, and the SHOW button of an act opens its panel.',
  a_next_step_2: (p: { seasons: string | number }) => `The advisor is on by default while your account plays its first ${p.seasons} Core seasons, the running one included, and then it goes off once. The advisor row of PLAY in the ☸ OPTIONS menu switches it for your empire in this world. The advisor row of SETTINGS here switches it for your account. On a telephone the line stays above the tab bar when you put the sheet down.`,
  a_offline_1: 'The world runs on, but nobody commands your empire. Once you take command, the autopilot does not take it back this season. The build queue works its jobs, and each fleet keeps its last order. By default a fleet turns for home when a hit lands on a low hull. A hold with a high enough Torpedo Battery level fires its stocked Caltrop and Bulwark rounds by itself.',
  a_offline_2: (p: { hours: string | number }) => `Before you leave, fill the build queue up to its ceiling: at least ${p.hours} hours of world time per build slot. The INBOX keeps the news, and the WHILE YOU WERE OUT row of your seat card counts it. Siege alerts reach your telephone when you turn them on in SETTINGS · ALERTS. While you hold an Event or Clan War seat, the standing orders row of PLAY lets the autopilot keep your Core empire.`,
  a_phone_play_1: 'Yes. Every screen of the game works on a telephone, and a finger gives every order that a mouse gives. The menus stand on the tab bar at the foot of the screen, with INBOX at its left end and MENU at its right end. A menu opens as a sheet that rises from the foot, and MENU opens ☸ OPTIONS.',
  a_phone_play_2: 'The TOUCH page of HELP lists the gestures of the map: a drag pans, a pinch zooms and a long press pins a peek. In an arcade match, GESTURES under HELP in the match menu opens the gesture card. On an iPhone, push notifications reach only the web app on the Home Screen. Press Share, then Add to Home Screen.',
  a_put_to_sea_1: 'A fleet is one hull. BUILD · SHIPYARD puts the hull in the build queue. It builds to the design in the slot of its class: the default pattern, or a print that you installed. Each class asks for a Shipyard level, some classes ask for research first, and the Dock must have room for the hull. The finished hull waits in the pens.',
  a_put_to_sea_2: 'Open FLEET · MISSIONS. A warship needs a captain aboard, so its row shows CAPTAIN until you pick one. A wounded captain, a prisoner or a captain on a dive cannot board. A support hull sails with no captain. DEPLOY puts the hull to sea at your hold, but not while it is under repair. When every mission slot is in use, raise the Fleet Command.',
  a_queue_ceiling_1: (p: { hours: string | number; extended: string | number }) => `${p.hours} hours of world time per build slot, for every commander. Premium raises that ceiling to ${p.extended} hours per build slot. That perk buys room and nothing else. Until the shop opens, every claimed seat holds the ${p.extended}-hour ceiling. An empire starts with one build slot. The Works Yard at its top level and the Foundry Charter of the Industry branch each add one.`,
  a_queue_ceiling_2: 'The check runs when a job goes in, so a queue under the ceiling can always take one more job, even a long one. A repair job goes to the front of the queue and does not obey the ceiling. Nothing builds faster at either ceiling, nothing costs less, and no yield moves.',
  a_queue_stuck_1: 'A refused order never enters the queue, and the refusal states the cause. A price the stores do not cover names the shortfall. A gate names what it needs, for example a Shipyard, a node or a Research Lab level. No building level can pass the Command Centre level that stands now, and a Command Centre level in the queue does not count. A full queue states when a build slot is free.',
  a_queue_stuck_2: 'A queued job is paid already, so it waits only for a build slot. The QUEUE head states how many jobs run, over your build slots. Jobs take free slots in queue order, a building level waits for the level below it, and a repair goes to the front. The to top and earlier controls move a job, and CANCEL gives its cost back, up to the storage cap.',
  a_rename_1: 'Once, and free, with the pencil beside your name in the header above. After that change the pencil is gone. For a second change, ask a person on the ASK A PERSON page here.',
  a_rename_2: (p: { name_min: string | number; name_max: string | number }) => `A player name is unique, and case does not count: Diver and DIVER are one name. It must be ${p.name_min} to ${p.name_max} characters and carry no control character. A world takes your new name at your next join, not while you sit in it.`,
  a_repair_1: 'Bring the fleet home: RETURN sails it to the pens, and the hull keeps its damage there. In the pens, press REPAIR in ⋯ of its row, or the wrench beside DEPLOY. The repair needs a Shipyard, and its price grows with the damage. The job goes to the front of the build queue, and the queue ceiling does not apply to it. One repair runs at a time.',
  a_repair_2: 'A hull under repair stays in the pens until the job is done or you cancel it. At sea, a shield mends by itself when the hull is out of combat or unheard, but a hull does not. Only a Tender near the hull, a Coral Ward that your faction holds and the Damage Control Doctrine keystone mend a hull at sea. A badly damaged fleet turns for home by itself.',
  a_report_problem_1: (p: { max: string | number }) => `In the game, open ☸ OPTIONS, then HELP, and press REPORT on the report a problem row. On a telephone, MENU at the right end of the tab bar opens ☸ OPTIONS. The match menu of an arcade match holds REPORT too. The REPORT A PROBLEM sheet asks WHAT KIND, and WHAT HAPPENED in up to ${p.max} characters.`,
  a_report_problem_2: 'Your account, the build and the browser always go. Under THE REPORT CARRIES, clear a box to leave out the client log, the world tick, the screenshot or the selected fleets. SEND then shows a report reference that starts with R-. Give it to the team when you write about the problem. When the link is down, the report waits on this device and goes out later.',
  a_research_1: 'Research is a job of the build queue, so it shares the build slots with buildings and hulls. Open BUILD · TECH and press DECRYPT on a node. A node costs Biomass and Volatiles, and the top tiers cost Isotopes too. The Research Lab level opens each tier. A node opens only after its prerequisite is done, not while that node waits in the queue.',
  a_research_2: 'The tree has a trunk of Foundations nodes and four branches. Each Foundations node opens the next tier of every branch and lets the Command Centre rise higher. The top node of a branch is its keystone: you hold one keystone a season, and the choice is final. A Data Core completes the node in progress at once: while you hold one, press the core count in the top bar.',
  a_resources_1: 'There are five. Alloy, Biomass and Volatiles are the mined resources. Your hold mines a small yield of each with no order. Each level of the Alloy Mine, the Biomass Farm and the Volatiles Extractor raises that yield. A Dredger also gathers them from deposits on the seabed, and a deposit in your faction\'s territory yields more. The cargo counts only when the Dredger brings it home.',
  a_resources_2: 'Isotopes have no mine: a captain brings them back from an expedition, and the auction sells lots of them. Credits come from an idle build queue and from sales at the auction. Storage sets the cap of each mined resource, and a full store destroys what does not fit. Isotopes and Credits have no cap.',
  a_screen_size_1: 'Open INTERFACE in ☸ OPTIONS in the game, or in SETTINGS here. The UI scale row makes the text and the panels larger, and the map keeps its size. The mark scale rows draw the fleets and the torpedoes smaller, and the map and every range keep their size.',
  a_screen_size_2: 'To show less on the map, turn off the chart, sonar visuals or ambient fluff in MAP. On a desktop, the desktop chat row of SOCIAL makes the chat box small or docks it in the dock column. On a telephone, the sheet heights row and the tab labels row of INTERFACE change the sheets and the tab bar.',
  a_season_end_1: (p: { days: string | number }) => `The seaquake, then the Cataclysm. A season runs ${p.days} days. Near its end the seaquake breaks the sea in three stages. In the floor shift every fleet docks and every hold moves to the middle third of the map. In the war economy the deposits die, hulls build faster and open water damages every hull at sea. In the settlement the scores lock and the holds fall in.`,
  a_season_end_2: 'When the drain of the settlement ends, the season summary card shows your rank, your score and the Honour the roll pays. The Honour ladder never decays. Then the next season starts on a new map, and your captains and your Honour go with you.',
  a_season_reset_1: 'The captains and the Honour, and the identity that carries them: the clan, the faction, the records, the achievements and the effects you hold. Nothing else.',
  a_season_reset_2: 'The reset takes everything material: the map, the territory, the holds, the fleets, the tech and the resources. The season roll hands a commander exactly what a new commander gets. Captivity does not cross a season either — the Cataclysm frees every prisoner.',
  a_siege_1: 'A strategic object is a site on the map that a faction captures in a siege. A siege never targets a hold. Each object starts neutral. While your faction holds one, it gives your faction one bonus, for example faster research at the Archive Vault. It also anchors supply and beams the water round it. Each object opens one siege window a day on the world clock.',
  a_siege_2: 'In the window, select a combat fleet, then press PLEDGE on the card of the object, or DEFEND when your faction holds it. The fleet sails there, pledges and leaves the map. At the close, a window battle decides. It costs shields only, and no hull sinks. Each attacker win lowers the gauge of the object, and a low enough gauge changes its owner. A neutral object falls to the first won window.',
  a_squad_1: 'Your squad starts in one pocket of water. The squad chip in the top bar names it, and a press on the chip opens the roster. Write to the squad in the SQUAD tab of the chat. For a fast line, hold the VIEW button or the comma key. The quick wheel sends a whole sentence, such as "Siege at H-hour.", in the language of each reader.',
  a_squad_2: (p: { intel: string | number }) => `To point at a place, put a map marker: alt and click on a desktop, or a long press and MARK on a telephone. Pick ATTACK, HOLD, GATHER or DANGER, and the middle of the menu sets SQUAD or FACTION. When a Signal Station of your clan in this world reaches level ${p.intel}, the scans of your squad mates join your WAR · INTEL list.`,
  a_stay_unheard_1: 'Sail slowly, or stop. Speed raises the noise of a hull, so a hull at rest is much quieter than the same hull at full speed. The class sets the base: a Vedette, a Corsair or a Lancer is quiet, and a Basilisk or a Bombard is loud. A Dampening module in the design and a captain with Quiet Hand cut the noise further.',
  a_stay_unheard_2: 'Each gun shot makes a hull loud for a short time, and each torpedo launch makes it loud for longer. With GUNS TIGHT the gun does not fire by itself, so it does not make a still hull loud. A trench makes a hull slower and harder to hear. A hull under way hears less behind its stern, so sail up behind it. A hull that nobody hears mends its shield.',
  a_supply_1: 'Supply is the link from your ground to an anchor. An anchor is a hold, a faction installation or a strategic object that your faction holds. A cell has supply when a path through your own faction\'s water reaches an anchor. Supply is a rule of the ground only: a fleet needs none.',
  a_supply_2: 'Ground with no supply is cut-off ground. The activity of your fleets no longer hardens it. Its rim, the cells that touch water you do not hold, drains by itself, and a drained cell becomes unclaimed sea. The patch thus shrinks from the outside inward. A Beacon that joins it to your line again, or a captured object inside it, stops the drain.',
  a_territory_1: 'Your hold claims the unclaimed water round it by itself. To move your border past that, build a Beacon in BUILD · SHIPYARD, sail it into water your faction owns and press ANCHOR. When its cable is set, the Beacon beams the closest cell it does not own, one cell at a time. A Beacon carries no gun, so keep a warship near it.',
  a_territory_2: 'Each owned cell has a gauge: the work that a change of owner needs. Ground near a hold, and ground where your fleets are active, has a high gauge. At the frontier, where two factions beam one cell, the stronger side pushes, and a tie changes nothing. WAR · SOVEREIGNTY lists the beams at work, and the SOV mode of VIEW · HEAT shows each gauge.',
  a_torpedoes_1: 'BUILD · TORPEDO puts torpedoes in the build queue, and your hold stocks them. Each kind needs its research first. A Lancer loads every kind, and a Falconet or a Basilisk loads the Harpoon only. A hull takes its load from the stock when it deploys. On a Lancer, LOADOUT in the pens sets the mix, and AUTO loads the best round first. At sea, the round pick on the card sets the kind that fires.',
  a_torpedoes_2: 'Select the hull, press FIRE and click the water. The map shows the reach and never the lead, so you aim where the target will be. A Harpoon stops at that point, so a target that turns away can escape it. A click on a contact sends a Remora after it. A launch makes the hull loud for a while. To rearm, RETURN to the pens and DEPLOY again.',
  a_two_clocks_1: 'Because a world runs two clocks. The world clock paces the economy, the build queue, research, deposit respawn, day and night, the siege windows, the seaquake and the season. The map clock paces movement, torpedo flight, detection, gathering, anchor cycles and fatigue. Gun fire and reloads run on the combat pace, which the world takes from the map clock.',
  a_two_clocks_2: 'A map crossing at the designed speeds is longer than anybody watches, and a season’s economy at that speed is over in an afternoon. The two needs are opposite, so each one has its own clock. The rules of a world count time on its own clocks, so a world plays the same way at any pacing. The settlement at the season end runs on the wall clock.',
  a_win_arcade_1: 'Do what the win of the map states before the clock runs out. Each map has one win: for example, sink the enemy fleets, hold a share of the sea or hold the objectives. The board states the win of each category. On a team map, your team shares its sonar and its ground, and it wins and loses together.',
  a_win_arcade_2: 'When the clock runs out, the team that leads on the figure of the win takes the match, and a tie is a draw. A match of the public queue moves your arcade rating. A match pays no Honour and no captain.',
  a_win_core_1: (p: { days: string | number }) => `Grow your season score. Each cell your Beacons take, each hostile fleet you sink and each siege window your fleets win adds points. A siege takes a strategic object. Buildings, research, gathering, expeditions and captains add points too, and a loss takes no point away. When the ${p.days}-day season ends, the score becomes Honour, and the first commander of the season gets half as much again.`,
  a_win_core_2: (p: { squad: string | number; members: string | number }) => `Conquest is team play. Your faction shares the ground and the fight for the strategic objects. Your squad of up to ${p.squad} commanders starts in one pocket of water, shares a chat and, through the Signal Station, its sonar. A clan of up to ${p.members} commanders stays together from season to season: CLAN · FIND A CLAN lists the clans. HOW IT PLAYS at the top of this page states the loop.`,
  ask_lede: 'A person of the team answers on the Discord server or by mail. Name your player name and, for a seat question, the world and the season.',
  card_glossary_count: (p: { count: string | number }) => `${p.count} WORDS`,
  card_glossary_title: 'GLOSSARY',
  card_keys_title: 'KEYS',
  card_qa_count: (p: { count: string | number }) => `${p.count} ANSWERS`,
  gesture_aim_first: 'AIM: FIRST TAP',
  gesture_aim_first_does: 'PLACE THE FIRING SOLUTION',
  gesture_aim_second: 'AIM: SECOND TAP ON IT',
  gesture_aim_second_does: 'FIRE · A TAP ELSEWHERE MOVES THE SOLUTION',
  gesture_drag: 'ONE FINGER, DRAG',
  gesture_drag_does: 'PAN THE MAP',
  gesture_long_press: 'LONG PRESS',
  gesture_long_press_does: 'PEEK: WHAT A MOUSE SHOWS ON HOVER, PINNED',
  gesture_pinch: 'TWO FINGERS, PINCH',
  gesture_pinch_does: 'ZOOM TOWARD THE MIDDLE OF THE TWO',
  gesture_tap_empty: 'TAP, NOTHING SELECTED',
  gesture_tap_empty_does: 'SELECT THE FLEET, DEPOSIT OR SITE UNDER IT',
  gesture_tap_minimap: 'TAP ON THE MINIMAP',
  gesture_tap_minimap_does: 'MOVE THE CAMERA · NEVER AN ORDER',
  gesture_tap_order: 'TAP, YOUR FLEET SELECTED',
  gesture_tap_order_does: 'ORDER THAT FLEET TO THE POINT',
  gesture_tap_other_fleet: 'TAP ON ANOTHER OWN FLEET',
  gesture_tap_other_fleet_does: 'CHANGE THE SELECTION INSTEAD',
  gesture_tap_water: 'TAP ON OPEN WATER',
  gesture_tap_water_does: 'DROP THE SELECTION',
  gestures_lede: 'A drag past a few pixels voids the tap, so a pan never also orders a fleet. A second finger voids the press, so the end of a pinch is never read as a tap. A gesture lands where the finger came down and never where it lifted.',
  glossary_filter: 'FILTER THE WORDS',
  glossary_lede: 'The game words, each in one or two sentences. In the game, a word with a dotted line under it opens the same definition.',
  glossary_none: 'No word matches the filter.',
  group_combat: 'COMBAT AND SONAR',
  group_device: 'DEVICE AND CONNECTION',
  group_empire: 'THE EMPIRE',
  group_fleets: 'FLEETS AND CAPTAINS',
  group_money: 'ACCOUNT AND MONEY',
  group_seasons: 'SEASONS AND CLANS',
  group_start: 'FIRST STEPS',
  group_territory: 'TERRITORY AND SIEGES',
  how_lede: 'HOW IT PLAYS: the goal, the loop, the team and what stays of each mode.',
  keys_lede: 'Every key is a shortcut for a control that is on screen. Nothing in the game is reachable by keyboard alone.',
  pill_contact: 'CONTACT PAGE',
  pill_discord: 'DISCORD',
  pill_nettest: 'CHECK THE NETWORK',
  pill_show_mail: 'SHOW THE MAIL ADDRESS',
  q_account_device: 'Is my progress tied to this device?',
  q_arcade_runs: 'How many arcade runs do I get?',
  q_better_design: 'How do I get a better ship design?',
  q_block_report: 'How do I block or report another player?',
  q_build_first: 'What should I build first?',
  q_captain_life: 'How long does a captain last?',
  q_clan_squad: 'What is a clan, and what is a squad?',
  q_connection: 'The game does not load, or the connection drops. What do I do?',
  q_credits: 'What are Credits for, and how do I earn them?',
  q_drill: 'Where can I learn to fight with no risk?',
  q_enemy_hold: 'Can I attack an enemy hold?',
  q_expedition: 'What is an expedition?',
  q_fight: 'How does a fight work?',
  q_fleet_sunk: 'What happens when my fleet is sunk?',
  q_fog_of_war: 'Why is that enemy fleet not on my map?',
  q_give_order: 'How do I give a fleet an order?',
  q_honour: 'What does Honour give me?',
  q_join: 'How do I join a world, and can I join a season that already runs?',
  q_never_sell: 'What does money never buy?',
  q_next_step: 'What do I do next?',
  q_offline: 'What happens to my empire while I am offline?',
  q_phone_play: 'Can I play on a phone?',
  q_put_to_sea: 'How do I put a fleet to sea?',
  q_queue_ceiling: 'How long may the build queue hold?',
  q_queue_stuck: 'Why does my job not start, or my queue not move?',
  q_rename: 'How do I change my name?',
  q_repair: 'How do I repair a damaged fleet?',
  q_report_problem: 'How do I report a problem with the game?',
  q_research: 'How does research work?',
  q_resources: 'What are the resources, and where do they come from?',
  q_screen_size: 'The screen is too small or too crowded. What can I change?',
  q_season_end: 'What happens at the end of a season?',
  q_season_reset: 'What survives a season?',
  q_siege: 'What is a strategic object, and how does a siege work?',
  q_squad: 'How do I work with my squad?',
  q_stay_unheard: 'How do I stay unheard?',
  q_supply: 'What is supply, and why does it matter?',
  q_territory: 'How do I take territory?',
  q_torpedoes: 'How do torpedoes work?',
  q_two_clocks: 'Why does the map move faster than the economy?',
  q_win_arcade: 'How do I win an arcade match?',
  q_win_core: 'How do I win a conquest season?',
  sec_ask: 'ASK A PERSON',
  sec_questions: 'QUESTIONS',
  sec_touch: 'TOUCH',
  subtitle: 'ANSWERS, KEYS AND A PERSON TO ASK',
  sum_ask_shown: 'ADDRESS SHOWN',
  sum_glossary_filter: (p: { shown: string | number; count: string | number }) => `${p.shown} OF ${p.count} WORDS`,
  sum_keys: (p: { count: string | number }) => `${p.count} KEYS`,
  sum_questions_open: (p: { open: string | number; count: string | number }) => `${p.open} OF ${p.count} OPEN`,
  sum_touch: (p: { count: string | number }) => `${p.count} GESTURES`,
  title: 'HELP',
};

const hubWardroom_en: S.HubWardroom = {
  age: (p: { n: string | number }) => `AGE ${p.n}`,
  card_cryo: 'CRYO FREEZE',
  card_designer: 'CAPTAIN DESIGNER',
  card_fleet_livery: 'FLEET LIVERY',
  card_fleet_names: 'FLEET NAMES',
  clanwar_empty: 'NO CAPTAIN IS ON THE CLAN WAR ROSTER YET',
  clanwar_empty_why: 'YOUR CLAN WAR CAPTAINS COME HERE WHEN A CLAN WAR CLOSES.',
  clanwar_lede: 'A third roster for the Clan War worlds, kept apart from the core one.',
  core_empty: 'NO CAPTAIN IS ON THE CORE ROSTER YET',
  core_empty_press: '▸ PLAY A SEASON',
  core_empty_why: 'YOUR CAPTAINS COME HERE WHEN A SEASON YOU PLAY CLOSES.',
  core_lede: 'A captain ages one season for each season you play.',
  count: (p: { n: string | number; max: string | number }) => `${p.n} / ${p.max}`,
  cryo_lede: 'Cryo Freeze stops the aging of your captains for each season that you do not play at all. A season that you play ages them as usual, so Cryo Freeze never holds a captain at its peak.',
  cryo_unheld: 'THIS ACCOUNT HOLDS NO PREMIUM KEY, SO ITS CAPTAINS ARE NOT IN CRYO FREEZE.',
  designer_close: 'CLOSE',
  designer_lede: 'Change the name, the portrait, the backstory and the voice lines of a captain. The designer is cosmetic only and never changes an attribute.',
  designer_pick: 'NO CAPTAIN IS SELECTED',
  designer_pick_strip: 'TAP A CAPTAIN ABOVE TO CHANGE ITS LOOKS.',
  designer_pick_why: 'TAP A CAPTAIN ON A ROSTER CARD TO CHANGE ITS LOOKS.',
  dg_combat: 'SN',
  dg_draw_faction: 'Your pool is empty, so each new hull takes one name of the faction pool at random. When a hull of this season already has the name, the new hull adds the next Roman numeral.',
  dg_draw_pool: 'Each new hull takes one name of your pool at random. When a hull of this season already has the name, the new hull adds the next Roman numeral.',
  dg_faction: 'FACTION',
  dg_faction_sub: 'YOUR LETTER',
  dg_ii_note: 'THE SECOND HULL OF THE NAME THIS SEASON',
  dg_name: 'NAME',
  dg_name_faction: 'FACTION POOL',
  dg_name_pool: 'YOUR POOL',
  dg_ordinal: 'ORDINAL',
  dg_ordinal_sub: 'WHEN TAKEN',
  dg_role: 'ROLE',
  dg_role_sub: 'SN COMBAT · SV SUPPORT',
  dg_second: 'II',
  dg_support: 'SV',
  dg_sv_note: 'A SUPPORT HULL',
  dossier_empty: 'NO CAPTAIN STANDS ON THIS ROSTER YET.',
  dossier_label: 'DOSSIER',
  dossier_line: (p: { age: string | number; phase: string | number; seasons: number }) => plural(p.seasons, {
    one: `${p.phase} · AGE ${p.age} · ${p.seasons} SEASON`,
    other: `${p.phase} · AGE ${p.age} · ${p.seasons} SEASONS`,
  }),
  dossier_talents: (p: { list: string | number }) => `TALENTS ${p.list}`,
  dossier_value: (p: { v: string | number; cap: string | number }) => `${p.v} / ${p.cap}`,
  event_empty: 'NO CAPTAIN IS ON THE EVENT ROSTER YET',
  event_empty_held: 'YOUR EVENT CAPTAINS COME HERE WHEN AN EVENT SEASON CLOSES.',
  event_empty_unheld: 'THE EVENT ROSTER COMES WITH PREMIUM.',
  event_lede: 'A second roster for Event mode, kept apart from the core one.',
  face_label: (p: { n: string | number }) => `FACE ${p.n}`,
  fleet_add: 'ADD A NAME',
  fleet_count: (p: { n: string | number; max: string | number }) => `${p.n} OF ${p.max} NAMES`,
  fleet_empty: 'THE POOL IS EMPTY',
  fleet_empty_why: 'YOUR HULLS TAKE THE NAMES OF YOUR FACTION.',
  fleet_full: (p: { max: string | number }) => `THE POOL HOLDS AT MOST ${p.max} NAMES.`,
  fleet_hint: (p: { min: string | number; max: string | number }) => `Everyone sees a hull name. A world uses the new list after your next join. A name has ${p.min} to ${p.max} letters, spaces, apostrophes and hyphens.`,
  fleet_label: 'FLEET NAME POOL',
  fleet_lede: 'Write the names that your hulls sail under. A world draws the name of each new hull from this list. The names are cosmetic only.',
  fleet_placeholder: (p: { n: string | number }) => `NAME ${p.n}`,
  fleet_remove: '✕',
  fleet_remove_label: (p: { n: string | number }) => `REMOVE NAME ${p.n}`,
  fleet_reset: 'CLEAR THE POOL',
  fleet_reset_armed: 'CLEAR?',
  fleet_reset_done: 'THE POOL IS EMPTY. YOUR HULLS TAKE THE NAMES OF YOUR FACTION AGAIN.',
  fleet_side_label: 'YOUR HULLS',
  fleet_side_livery: (p: { name: string | number }) => `LIVERY · ${p.name}`,
  fleet_stored: (p: { names: string | number }) => `YOUR STORED POOL STILL NAMES YOUR HULLS: ${p.names}`,
  gender_f: 'F',
  gender_f_title: 'Show female faces',
  gender_m: 'M',
  gender_m_title: 'Show male faces',
  label_backstory: 'BACKSTORY',
  label_name: 'NAME',
  label_portrait: 'PORTRAIT',
  label_voice: 'VOICE LINES',
  livery_decals: 'DECALS',
  livery_hint: 'A world uses the new livery after your next join.',
  livery_label: 'LIVERY',
  livery_lede: 'Pick one pattern or one decal. Every hull of your account wears it in every season world, and every player who sees the hull sees it. The hull keeps the colour of its faction.',
  livery_name_bow_band: 'BOW BAND',
  livery_name_centre_stripe: 'CENTRE STRIPE',
  livery_name_chevron: 'CHEVRON',
  livery_name_cockpit_bar: 'COCKPIT BAR',
  livery_name_cockpit_diamond: 'COCKPIT DIAMOND',
  livery_name_cockpit_ring: 'COCKPIT RING',
  livery_name_cockpit_square: 'COCKPIT SQUARE',
  livery_name_cockpit_triangle: 'COCKPIT TRIANGLE',
  livery_name_dazzle: 'DAZZLE',
  livery_name_deck_ring: 'DECK RING',
  livery_name_hatching: 'HATCHING',
  livery_name_inner_silhouette: 'INNER SILHOUETTE',
  livery_name_rivets: 'RIVETS',
  livery_name_stern_band: 'STERN BAND',
  livery_name_tally_one: 'TALLY ONE',
  livery_name_tally_three: 'TALLY THREE',
  livery_name_tally_two: 'TALLY TWO',
  livery_name_tips: 'TIPS',
  livery_name_twin_stripes: 'TWIN STRIPES',
  livery_name_wing_band: 'WING BAND',
  livery_none: 'NONE',
  livery_off: 'NO LIVERY',
  livery_patterns: 'PATTERNS',
  livery_picked: (p: { name: string | number }) => `PICKED: ${p.name}`,
  livery_reset: 'REMOVE THE LIVERY',
  livery_reset_armed: 'REMOVE?',
  livery_reset_done: 'YOUR HULLS WEAR NO LIVERY.',
  livery_stored: (p: { name: string | number }) => `YOUR SAVED LIVERY STILL MARKS YOUR HULLS: ${p.name}`,
  name_hint: 'Everyone sees the name. A world shows the new name after your next join.',
  names_side_label: 'HOW A HULL IS NAMED',
  phase_decline: 'DECLINE',
  phase_peak: 'PEAK',
  phase_rise: 'RISE',
  preview_label: 'PREVIEW',
  private_hint: 'Only you see the backstory and the voice lines. Your chronicle closes a line about this captain with one of the voice lines.',
  reroll: 'REROLL',
  reset: 'RESET TO DEFAULT',
  reset_armed: 'RESET?',
  reset_done: 'THE DEFAULT LOOKS ARE BACK',
  save: 'SAVE',
  saved: 'SAVED',
  saving: 'SAVING…',
  sec_rosters: 'ROSTERS',
  see_the_shop: 'SEE THE SHOP',
  strip_more: (p: { n: string | number }) => `+${p.n}`,
  sum_clanwar: (p: { n: string | number }) => `WAR ${p.n}`,
  sum_core: (p: { n: string | number }) => `CORE ${p.n}`,
  sum_event: (p: { n: string | number }) => `EVENT ${p.n}`,
  sum_names: (p: { n: number }) => plural(p.n, {
    one: `${p.n} NAME`,
    other: `${p.n} NAMES`,
  }),
  title: 'WARDROOM',
  title_sub: 'YOUR CAPTAINS CROSS EVERY SEASON',
  to_designer: '▸ CAPTAIN DESIGNER',
  toggle_clanwar: 'CLAN WAR',
  toggle_core: 'CORE',
  toggle_event: 'EVENT',
  toggle_label: 'ROSTER',
  too_long: (p: { limit: string | number }) => `USE AT MOST ${p.limit} CHARACTERS.`,
  too_short: (p: { limit: string | number }) => `USE AT LEAST ${p.limit} CHARACTERS.`,
  voice_count: (p: { n: string | number; max: string | number }) => `${p.n} OF ${p.max} LINES`,
  voice_placeholder: (p: { n: string | number }) => `LINE ${p.n}`,
};

const impersonation_en: S.Impersonation = {
  banner: (p: { name: string | number; operator: string | number }) => `Impersonating ${p.name} · ${p.operator}`,
  stop: 'STOP',
};

const inbox_en: S.Inbox = {
  achieved: (p: { n: number }) => plural(p.n, {
    one: `${p.n} achievement`,
    other: `${p.n} achievements`,
  }),
  achievement_body: (p: { grade: string | number; achievement: string | number }) => `You reached ${p.grade} in ${p.achievement}.`,
  achievements: 'ACHIEVEMENTS ›',
  back: '‹ INBOX',
  battle_copy: 'A commander of your clan fought in this window.',
  battle_damage: (p: { dealt: string | number; taken: string | number; gauge: string | number }) => `Damage ${p.dealt} dealt, ${p.taken} taken. Gauge now ${p.gauge}.`,
  battle_failed: (p: { site: string | number }) => `The attack on ${p.site} failed.`,
  battle_foe: (p: { foe: string | number; ours: string | number; theirs: string | number }) => `Against the ${p.foe}: ${p.ours} fleets to ${p.theirs}.`,
  battle_gauge_lost: (p: { site: string | number }) => `${p.site} held, but lost gauge.`,
  battle_held: (p: { site: string | number }) => `The defence held ${p.site}.`,
  battle_lost: (p: { site: string | number; foe: string | number }) => `${p.site} fell to the ${p.foe}.`,
  battle_taken: (p: { site: string | number }) => `The attack took ${p.site}.`,
  battle_won: (p: { site: string | number }) => `The attack won the window at ${p.site}.`,
  boarding_body: (p: { fleet: string | number; class: string | number }) => `Pirates of the NPC side board ${p.fleet} (${p.class}). A combat hull of your side close to it stops the boarding.`,
  bucket_names: ['Losses', 'War', 'Hold and water', 'Dives', 'Trade', 'The world'],
  bucket_tags: ['LOSS', 'WAR', 'HOLD', 'DIVE', 'TRADE', 'WORLD'],
  buyers: (p: { n: number }) => plural(p.n, {
    one: `${p.n} buyer`,
    other: `${p.n} buyers`,
  }),
  cache_finders: (p: { n: number }) => plural(p.n, {
    one: `${p.n} finder`,
    other: `${p.n} finders`,
  }),
  cache_finders_body: (p: { n: number }) => plural(p.n, {
    one: `${p.n} commander found this cache this season.`,
    other: `${p.n} commanders found this cache this season.`,
  }),
  cache_found_body: (p: { fleet: string | number; kind: string | number }) => `${p.fleet} searched the cell and found a cache: ${p.kind}.`,
  cache_found_core: 'It took one Data Core.',
  cache_found_event: (p: { label: string | number }) => `An operator placed this cache: ${p.label}.`,
  cache_found_player: 'A commander left this cache. The reward came from the game, not from the depositor. YOUR FINDS of the cache sheet holds the note.',
  cache_found_reward: (p: { alloy: string | number; biomass: string | number; volatiles: string | number; isotopes: string | number }) => `The hull took ${p.alloy} alloy, ${p.biomass} biomass, ${p.volatiles} volatiles and ${p.isotopes} isotopes aboard. They land at your hold.`,
  cache_taken_body: (p: { finder: string | number }) => `${p.finder} found your cache. The reward came from the game, and your fee stays spent.`,
  cap_label: (p: { n: number }) => plural(p.n, {
    one: `INBOX, ${p.n} unread`,
    other: `INBOX, ${p.n} unread`,
  }),
  captains: 'CAPTAINS ›',
  cause_seaquake: 'SEAQUAKE',
  cells_lost: (p: { n: number }) => plural(p.n, {
    one: `−${p.n} cell`,
    other: `−${p.n} cells`,
  }),
  clan_copy: 'CLAN',
  clan_page: 'CLAN PAGE ›',
  club_body: (p: { room: string | number; faction: string | number; net: string | number; window: string | number }) => `The casino was the ${p.room} of the ${p.faction} when the light turned. The house kept ¤${p.net} ${p.window}.`,
  club_day: 'DAY',
  club_fold_body: (p: { amount: string | number; n: number; net: string | number }) => plural(p.n, {
    one: `The casino paid you ${p.n} club share in one world day, ¤${p.amount} in all. The house kept ¤${p.net} in that window.`,
    other: `The casino paid you ${p.n} club shares in one world day, ¤${p.amount} in all. The house kept ¤${p.net} in those windows.`,
  }),
  club_in_day: 'in the day',
  club_in_night: 'in the night',
  club_night: 'NIGHT',
  club_share_body: (p: { amount: string | number; total: string | number; members: string | number }) => `Your share is ¤${p.amount}: the club share of ¤${p.total} split among the ${p.members} commanders of the club.`,
  club_shares: (p: { n: number }) => plural(p.n, {
    one: `${p.n} club share`,
    other: `${p.n} club shares`,
  }),
  club_split: (p: { total: string | number; members: string | number }) => `¤${p.total} ÷ ${p.members}`,
  club_window_body: (p: { from: string | number; to: string | number }) => `The window ran from ${p.from} to ${p.to}.`,
  credits: (p: { n: string | number }) => `¤${p.n}`,
  damage_cols: ['FLEET', 'CLASS', 'OWNER', 'DAMAGE'],
  damage_kinds: ['guns', 'gun splash', 'torpedo', 'torpedo splash', 'quake grind', 'shock wave', 'active ping', 'array broadcast', 'window resolution', 'the settlement', 'the anchor', 'deep run wear', 'pressure wear', 'sea mine', 'Cheval wire'],
  damage_title: 'WHAT SANK IT',
  dealt_cols: ['YOUR FLEETS', 'CLASS', 'DAMAGE'],
  depth_cells: ['SHELF', 'TRENCH', 'ABYSSAL'],
  dive_body: (p: { dive: string | number; captain: string | number; hours: string | number }) => `${p.dive}: ${p.captain} surfaced after ${p.hours}h.`,
  dive_hurt: (p: { captain: string | number; sickbay_until: string | number }) => `${p.captain} is wounded and in the Sickbay until ${p.sickbay_until}.`,
  dive_isotopes: (p: { isotopes: string | number }) => `The dive brought back ${p.isotopes} isotopes.`,
  dive_isotopes_core: (p: { isotopes: string | number }) => `The dive brought back ${p.isotopes} isotopes and a Data Core.`,
  dive_years: (p: { captain: string | number; n: number }) => plural(p.n, {
    one: `The dive aged ${p.captain} by ${p.n} year.`,
    other: `The dive aged ${p.captain} by ${p.n} years.`,
  }),
  empty: 'No messages. Each type of message stays for its own time, and an open message shows the date the INBOX deletes it.',
  empty_filter: 'No messages of this kind in this view.',
  empty_today: 'No messages today.',
  empty_unread: 'No unread messages.',
  expires: (p: { date: string | number }) => `The INBOX deletes this message on ${p.date}.`,
  fate_captured: 'CAPTURED',
  fate_wounded: 'WOUNDED',
  featured_body: (p: { site: string | number; window_start: string | number; window_end: string | number }) => `${p.site} is the featured object of tomorrow. Its window opens at ${p.window_start} and closes at ${p.window_end}.`,
  featured_rule: 'For that world day, the faction that holds it takes double its bonus, and a won window there pays double siege score.',
  fell_body: (p: { site: string | number; foe: string | number }) => `${p.site} fell to the ${p.foe}.`,
  filter_all: 'ALL',
  filter_all_title: 'show the messages of every bucket',
  filter_label: (p: { bucket: string | number; n: number }) => plural(p.n, {
    one: `${p.bucket}, ${p.n} message`,
    other: `${p.bucket}, ${p.n} messages`,
  }),
  filter_title: (p: { bucket: string | number }) => `show the messages of the bucket ${p.bucket}`,
  fire_body: (p: { faction: string | number; events: string | number; first: string | number; last: string | number }) => `The ${p.faction} fired near your hold: ${p.events} shots from ${p.first} to ${p.last}.`,
  fleets_cols: ['SIDE', 'FLEET', 'CLASS', 'OWNER', 'DEALT', 'TAKEN', 'WITHDREW'],
  fold_title: 'show the messages of this row',
  for_class: (p: { class: string | number }) => `for ${p.class}`,
  fragment_body: (p: { fleet: string | number }) => `Your last hit sank ${p.fleet}, a hull of the NPC side. It carried a chart fragment of its den.`,
  fragment_note: 'A chart fragment points to the pirate cache of its den.',
  fragments_body: (p: { n: number }) => plural(p.n, {
    one: `You hold ${p.n} chart fragment.`,
    other: `You hold ${p.n} chart fragments.`,
  }),
  fragments_held: (p: { n: number }) => plural(p.n, {
    one: `${p.n} held`,
    other: `${p.n} held`,
  }),
  freed_body: (p: { fleet: string | number; class: string | number }) => `A combat hull of your side stopped the boarding of ${p.fleet} (${p.class}). The hull is free.`,
  go_to: 'GO TO',
  go_to_title: (p: { place: string | number }) => `move the map to ${p.place}`,
  held_body: (p: { site: string | number; foe: string | number }) => `Your side held ${p.site} against the ${p.foe}.`,
  hits: (p: { n: number }) => plural(p.n, {
    one: `${p.n} hit`,
    other: `${p.n} hits`,
  }),
  hits_cols: ['FLEET', 'CLASS', 'OWNER', 'DAMAGE', 'HULL'],
  honour: (p: { n: string | number }) => `+${p.n}`,
  hull_pct: (p: { n: string | number }) => `${p.n}%`,
  hull_sunk: 'SUNK',
  hull_taken_body: (p: { fleet: string | number; class: string | number }) => `A pirate group took ${p.fleet} (${p.class}). The hull sails with the group to its den, where the pirates break it down for the cache of the den.`,
  hull_taken_note: 'Sink the hull before it reaches the den, and its wreck keeps its cargo.',
  isotopes: 'Isotopes',
  killed_body: (p: { fleet: string | number; class: string | number; owner: string | number; faction: string | number }) => `Your fleets sank ${p.fleet} (${p.class}) of ${p.owner}, ${p.faction}.`,
  killed_salvage: (p: { alloy: string | number; biomass: string | number; volatiles: string | number }) => `Salvage: ${p.alloy} alloy, ${p.biomass} biomass, ${p.volatiles} volatiles.`,
  killed_share: (p: { share: string | number; damage: string | number }) => `Your share of the damage: ${p.share}% (${p.damage}).`,
  landed: (p: { n: string | number }) => `${p.n} landed`,
  launcher_battery: 'a battery',
  launcher_hold: (p: { owner: string | number }) => `the hold of ${p.owner}`,
  launcher_tube: 'a hold tube',
  loading: 'The INBOX asks the server for the messages.',
  lost_by: (p: { fleet: string | number; class: string | number; killer: string | number; killer_owner: string | number }) => `${p.fleet} (${p.class}) was sunk by ${p.killer} of ${p.killer_owner}.`,
  lost_captured: (p: { captain: string | number; captor_faction: string | number; ransom: string | number }) => `Captain ${p.captain} was taken prisoner by the ${p.captor_faction}. Ransom ¤${p.ransom}.`,
  lost_cargo: (p: { cargo: string | number }) => `${p.cargo} units of cargo went down with the hull.`,
  lost_none: 'No captain was aboard.',
  lost_sunk: (p: { fleet: string | number; class: string | number }) => `${p.fleet} (${p.class}) was sunk.`,
  lost_wounded: (p: { captain: string | number; sickbay_until: string | number }) => `Captain ${p.captain} is wounded and in the Sickbay until ${p.sickbay_until}.`,
  mark_all: 'MARK ALL READ',
  mark_these: 'MARK THESE READ',
  mates: (p: { n: number }) => plural(p.n, {
    one: `${p.n} mate`,
    other: `${p.n} mates`,
  }),
  mates_cols: ['COMMANDER', 'FACTION'],
  mauled_body: (p: { foe: string | number; site: string | number }) => `The ${p.foe} mauled ${p.site}. The object stays yours.`,
  monster_body: (p: { fleet: string | number; class: string | number }) => `A monster of the NPC side moves to ${p.fleet} (${p.class}). It moves to noise: a quiet fleet draws it less.`,
  monster_commanders: (p: { n: number }) => plural(p.n, {
    one: `${p.n} commander`,
    other: `${p.n} commanders`,
  }),
  monster_sunk_body: (p: { fleet: string | number; class: string | number }) => `${p.fleet} (${p.class}), a monster of the NPC side, sank. Your fleets fired on it.`,
  monster_sunk_core: 'The stores took one Data Core.',
  monster_sunk_last: 'Your fleet made the last hit.',
  monster_sunk_practice: (p: { points: string | number }) => `Your captains counted ${p.points} practice points from the kill.`,
  more: (p: { n: string | number }) => `+${p.n}`,
  moved_body: (p: { to_cell: string | number }) => `The seaquake moved your hold. It now stands at ${p.to_cell}.`,
  npc_contacts: (p: { n: number }) => plural(p.n, {
    one: `${p.n} contact`,
    other: `${p.n} contacts`,
  }),
  object_damage_body: (p: { dealt: string | number; taken: string | number }) => `Your side dealt ${p.dealt} damage and took ${p.taken}.`,
  object_heal_body: 'The gauge does not heal until the next window closes.',
  object_lost_body: (p: { gain: string | number }) => `Your side lost what it gave: ${p.gain}.`,
  object_next_body: (p: { at: string | number }) => `The next window opens at ${p.at}.`,
  only_battle: 'BATTLE REPORTS ONLY',
  only_range: 'THE MESSAGES OF THE RANGE ONLY',
  open_ambush: (p: { aspect: string | number; damage: string | number }) => `Opened from ${p.aspect}, unheard: ${p.damage}.`,
  open_beam: 'the beam',
  open_bow: 'the bow',
  open_heard: (p: { aspect: string | number; damage: string | number }) => `Opened from ${p.aspect}: ${p.damage}.`,
  open_page: 'OPEN ›',
  open_stern: 'the stern',
  outcome_failed: 'FAILED',
  outcome_gauge_lost: 'GAUGE LOST',
  outcome_held: 'HELD',
  outcome_lost: 'LOST',
  outcome_taken: 'TAKEN',
  outcome_won: 'WINDOW WON',
  pay_ransom: (p: { ransom: string | number }) => `PAY RANSOM ¤${p.ransom}`,
  pickup_squad: 'Pickup squad',
  pirate_body: (p: { fleet: string | number; class: string | number }) => `A pirate group of the NPC side hunts ${p.fleet} (${p.class}).`,
  place_hold: (p: { commander: string | number }) => `${p.commander}'s hold`,
  pledge: 'PLEDGE A FLEET',
  points: (p: { n: string | number }) => `${p.n} pts`,
  print: 'print',
  prints: (p: { n: number }) => plural(p.n, {
    one: `${p.n} print`,
    other: `${p.n} prints`,
  }),
  range: (p: { first: string | number; last: string | number }) => `${p.first}–${p.last}`,
  rank: (p: { rank: string | number; of: string | number }) => `#${p.rank} of ${p.of}`,
  read: '✓ READ',
  recovered_body: (p: { fleet: string | number; class: string | number }) => `${p.fleet} recovered part of the cargo of a sunk ${p.class}.`,
  redraft_body: (p: { slot: string | number; design: string | number; module: string | number }) => `The redraft of slot ${p.slot} of ${p.design} rolled ${p.module} again.`,
  redraft_discarded: 'DISCARDED',
  redraft_discarded_body: 'The new roll is not higher, so the redraft is discarded. The master did not change.',
  redraft_improved: 'IMPROVED',
  redraft_improved_body: 'The new roll is higher, so the master took it. The Mk number and the name did not change.',
  redraft_module: (p: { module: string | number; tier: string | number }) => `${p.module} ${p.tier}`,
  redraft_roll_body: (p: { old: string | number; old_grade: string | number; new: string | number; new_grade: string | number }) => `The master held ×${p.old} (${p.old_grade}). The redraft rolled ×${p.new} (${p.new_grade}).`,
  redraft_rolls: (p: { old: string | number; new: string | number }) => `×${p.old} → ×${p.new}`,
  redraft_tiers: ['I', 'II', 'III'],
  replace: (p: { price: string | number }) => `⟲ REPLACE ${p.price}`,
  replace_queued: '✓ replacement queued',
  replace_sent: '⟲ SENT',
  replace_title: 'queue the same hull again, at the end of the queue, at the full price',
  replay: '▶ REPLAY',
  replay_title: 'play the film of this fight',
  report: 'REPORT ›',
  report_title: 'open your season table on the RANKS page of the hub',
  room_body: (p: { fleet: string | number; class: string | number; for_class: string | number }) => `${p.fleet} (${p.class}) was broken for parts to make room for a ${p.for_class}.`,
  sale_isotopes_body: (p: { buyer: string | number; qty: string | number; price: string | number; unit: string | number }) => `${p.buyer} bought ${p.qty} isotopes for ¤${p.price}, ¤${p.unit} each.`,
  sale_print_body: (p: { buyer: string | number; print: string | number; price: string | number }) => `${p.buyer} bought the print ${p.print} for ¤${p.price}.`,
  score: (p: { ours: string | number; theirs: string | number }) => `${p.ours}:${p.theirs}`,
  sea_lost: (p: { n: string | number }) => `${p.n} lost`,
  sea_lost_cleared: (p: { by: string | number; count: string | number }) => `A Countermine of ${p.by} cleared ${p.count} sea objects of yours.`,
  sea_lost_destroyed: (p: { by: string | number; count: string | number }) => `${p.by} sank ${p.count} sea objects of yours.`,
  sea_lost_expired: (p: { count: string | number }) => `${p.count} sea objects of yours left the map at the end of their life.`,
  sea_lost_kind: (p: { kind: string | number }) => `The last object: ${p.kind}.`,
  sea_lost_rock: (p: { count: string | number }) => `${p.count} sea mines of yours drifted onto rock and went off.`,
  sea_mine_damage: (p: { damage: string | number }) => `The strike dealt ${p.damage} damage to the hull.`,
  sea_mine_hulls: (p: { count: string | number; damage: string | number }) => `In this time your sea mines struck ${p.count} hulls and dealt ${p.damage} damage.`,
  sea_mine_sank: 'The hull sank.',
  sea_mine_struck_body: (p: { fleet: string | number; class: string | number; owner: string | number; kind: string | number }) => `${p.fleet} (${p.class}) set off a sea mine of ${p.owner}: ${p.kind}.`,
  sea_mine_tripped_body: (p: { fleet: string | number; class: string | number; owner: string | number; kind: string | number }) => `Your sea mine went off on ${p.fleet} (${p.class}) of ${p.owner}: ${p.kind}.`,
  sea_reason_cleared: 'CLEARED',
  sea_reason_destroyed: 'DESTROYED',
  sea_reason_expired: 'EXPIRED',
  sea_reason_rock: 'ROCK',
  season: (p: { season: string | number }) => `Season ${p.season}`,
  season_body: (p: { season: string | number; rank: string | number; of: string | number; points: string | number }) => `Season ${p.season} closed. You ranked ${p.rank} of ${p.of} commanders with ${p.points} points.`,
  season_figures: ['CELLS', 'SINKINGS', 'SIEGES WON', 'DIVES', 'PRISONERS FREED'],
  season_honour: (p: { honour: string | number; title: string | number }) => `You earned ${p.honour} Honour and the title ${p.title}.`,
  shots: (p: { n: number }) => plural(p.n, {
    one: `${p.n} shot`,
    other: `${p.n} shots`,
  }),
  show: 'SHOW',
  show_all: 'ALL MESSAGES',
  show_title: 'move the map to this cell',
  side_attack: 'ATTACK',
  side_defence: 'DEFENCE',
  siege_body: (p: { foe: string | number; site: string | number; window_start: string | number; window_end: string | number }) => `The ${p.foe} attacks ${p.site}. The window opens at ${p.window_start} and closes at ${p.window_end}.`,
  span_hm: (p: { h: string | number; m: string | number }) => `${p.h}h ${p.m}m`,
  span_m: (p: { m: string | number }) => `${p.m}m`,
  spilled: (p: { n: string | number }) => `−${p.n}`,
  spilled_body: (p: { units: string | number; spilled: string | number }) => `A fleet landed ${p.units} units. Storage was full, so ${p.spilled} units spilled.`,
  squad_body: 'This season you shared a squad with these commanders. A pickup squad does not stay together into the next season. An officer of a clan can invite each of them on the CLAN page of the hub.',
  sr_fold: (p: { n: number }) => plural(p.n, {
    one: `${p.n} message`,
    other: `${p.n} messages`,
  }),
  sr_row: (p: { kind: string | number; subject: string | number; stamp: string | number }) => `${p.kind}, ${p.subject}, ${p.stamp}`,
  sr_row_unread: (p: { kind: string | number; subject: string | number; stamp: string | number }) => `${p.kind}, ${p.subject}, unread, ${p.stamp}`,
  storage_full: 'Storage full',
  struck_cols: ['FLEET', 'CLASS', 'DAMAGE', 'HULL'],
  sunk: (p: { n: string | number }) => `${p.n} sunk`,
  taken_body: (p: { captain: string | number; owner: string | number; ransom: string | number }) => `Your Brig holds Captain ${p.captain} of ${p.owner}. The ransom is ¤${p.ransom}.`,
  title: 'INBOX',
  torpedo_hit_body: (p: { torpedo: string | number; launcher: string | number; count: string | number; faction: string | number }) => `${p.torpedo} from ${p.launcher} struck ${p.count} hulls of the ${p.faction}.`,
  torpedo_sank: (p: { sunk: string | number }) => `${p.sunk} sank.`,
  torpedo_struck_body: (p: { torpedo: string | number; launcher: string | number; owner: string | number; count: string | number }) => `${p.torpedo} from ${p.launcher} of ${p.owner} struck ${p.count} of your hulls.`,
  type_achievement: 'ACHIEVED',
  type_battle_report: 'BATTLE',
  type_boarding_started: 'BOARDING',
  type_boarding_stopped: 'FREED',
  type_cache_found: 'CACHE',
  type_cache_taken: 'YOUR CACHE',
  type_captain_taken: 'PRISONER',
  type_cargo_spilled: 'SPILLED',
  type_club_paid: 'CLUB SHARE',
  type_expedition: 'DIVE',
  type_featured_next: 'FEATURED',
  type_fleet_killed: 'ENEMY SUNK',
  type_fleet_lost: 'FLEET LOST',
  type_fragment_found: 'FRAGMENT',
  type_hold_moved: 'HOLD MOVED',
  type_hold_under_fire: 'FIRE NEAR',
  type_hull_taken: 'TAKEN',
  type_monster_heard: 'MONSTER',
  type_monster_sunk: 'NPC SUNK',
  type_object_fallen: 'FELL',
  type_object_held: 'HELD',
  type_object_mauled: 'MAULED',
  type_pickup_squad: 'SQUAD',
  type_pirate_contact: 'PIRATES',
  type_redraft_done: 'REDRAFT',
  type_room_made: 'ROOM MADE',
  type_sale: 'SALE',
  type_sea_mine_struck: 'SEA MINE',
  type_sea_mine_tripped: 'WENT OFF',
  type_sea_object_lost: 'SEA OBJECT',
  type_season_closed: 'SEASON',
  type_siege_defend: 'SIEGE',
  type_territory_lost: 'WATER LOST',
  type_torpedo_hit: 'TORPEDO',
  type_torpedo_struck: 'STRUCK',
  type_wreck_recovered: 'RECOVERED',
  unread_mark: 'unread',
  view_all: 'ALL',
  view_all_title: 'show every message',
  view_today: 'TODAY',
  view_today_title: 'show the messages of today',
  view_unread: 'UNREAD',
  view_unread_count: (p: { n: string | number }) => `UNREAD ${p.n}`,
  view_unread_title: 'show the unread messages',
  water_body: (p: { faction: string | number; cells: string | number }) => `The ${p.faction} took ${p.cells} cells of your water.`,
  window_ended: 'ENDED',
  window_in: (p: { span: string | number }) => `in ${p.span}`,
  window_open: 'OPEN',
  yes: 'YES',
  your_hold: 'Your hold',
};

const inboxNeeds_en: S.InboxNeeds = {
  fold_title: 'fold NEEDS YOU into its head line',
  group_label: 'messages that need you',
  head: (p: { count: string | number }) => `NEEDS YOU · ${p.count}`,
  no_pin: 'no place on the map',
  pin_label: (p: { num: string | number }) => `pin ${p.num} on the map`,
  today: 'TODAY',
  unfold_title: 'open NEEDS YOU',
  yesterday: 'YESTERDAY',
};

const keymap_en: S.Keymap = {
  does_admin: 'the dev admin panel, Quake-style (admin seats only)',
  does_anchor: 'anchor / weigh anchor',
  does_base_tubes: 'arm the base Torpedo Battery (again disarms)',
  does_card_deploy: 'DEPLOY on the card of a fleet in the pens',
  does_card_repair: 'REPAIR on the card of a fleet in the pens',
  does_card_steer_port: 'hold to turn the selected fleet to port: the heading goes left while the key is down',
  does_card_steer_starboard: 'hold to turn the selected fleet to starboard: the heading goes right while the key is down',
  does_card_telegraph_down: 'the engine telegraph of the selected fleet one step down, to STOP',
  does_card_telegraph_up: 'the engine telegraph of the selected fleet one step up, to FULL',
  does_casino_bet: 'blackjack: place the bet · hold\'em: bet or raise',
  does_casino_call: 'hold\'em: call the bet',
  does_casino_clear: 'roulette: take every bet back (two presses)',
  does_casino_double: 'blackjack: double the stake and take one card',
  does_casino_fold: 'hold\'em: fold the hand',
  does_casino_hit: 'blackjack: take one more card',
  does_casino_rebet: 'roulette: place the bets of the last spin again',
  does_casino_spin: 'the slot machine: spin',
  does_casino_stand: 'blackjack: take no more cards; off the table, the next round of the selected hull',
  does_casino_take_back: 'roulette: take the last bet back',
  does_defend: 'hold here',
  does_depth_look: 'the depth tints: feathered or in steps',
  does_escape: 'back out — pick mode, aim, panel, selection, season summary; with nothing open, it opens OPTIONS',
  does_escort: 'escort — pick a friendly fleet',
  does_fire: 'aim the tubes (fire torpedo) / drop a noisemaker (Vedette) / lay (Sapper)',
  does_fluff: 'the ambience layers (creatures, drift, bubbles)',
  does_gather: 'gather — pick a deposit to cut',
  does_group_assign: 'put the selected fleet on a control group',
  does_group_recall: 'recall a control group; again centres the map on the fleet',
  does_heat: 'pick a map heat map; §14 lists the modes in key order',
  does_help: 'this reference (esc closes)',
  does_hex_borders: 'the hex grid outlines',
  does_hex_fills: 'the hex grid, filled by faction',
  does_hold_fire: 'guns tight / guns free — a gun kept tight shoots only at a focus',
  does_hold_round: 'the next round of the hold\'s round pick, while the hold aim is armed or the hold is selected',
  does_home: 'centre the map on your hold',
  does_hunt: 'hunt — pick an attack-move point',
  does_inbox: 'the INBOX (again closes)',
  does_kraken: 'summon the kraken (client-side ambience)',
  does_lane: 'via lane — take the lane course that the card offers after a move',
  does_marker: 'put a map marker for the squad or the faction; on your own marker, remove it',
  does_menu_focus: 'on the map: put the focus on the tab of the open menu; esc gives the keys back to the map',
  does_menu_next: 'on the map: the next of BUILD · DRAFT · FLEET · CAPTAIN · ECONOMY · WAR; in a menu: the next control',
  does_menu_prev: 'on the map: the previous menu, or the last; in a menu: the previous control',
  does_move: 'move — pick a point, and keep course past any contact',
  does_music: 'the music player (esc closes)',
  does_next_fleet: 'select the next own fleet and centre the map on it',
  does_next_round: 'the next round of the round pick (Lancer) / the next kind of the lay pick (Sapper); while a blackjack hand is open, stand',
  does_pan: 'pan the map · zoom toward the cursor',
  does_pan_name: 'drag / wheel',
  does_patrol: 'patrol — pick the far end of the lane',
  does_photo: 'photo mode: hide the chrome and save a picture of the map',
  does_plot_done: 'while the plot line stands: DONE — send the legs as the course',
  does_quick: 'hold for the quick wheel at the pointer; release over a line, or press its key, to send it',
  does_return: 'return home',
  does_row_ends: 'in the open menu: move the focus to the first or the last row',
  does_row_step: 'in the open menu: move the focus to the row above or below',
  does_scan: 'scan (scouts) / share (Oracle) / signature order (warships) / collect (Sapper)',
  does_screenshake: 'the camera shake of a nearby hit',
  does_section_next: 'the next section of the open menu; a browser may keep this chord',
  does_section_prev: 'the previous section of the open menu',
  does_sections: 'sections within the open menu, left to right',
  does_sonar_visuals: 'the sonar layer (rings, pings, blips)',
  does_sov_borders: 'the territory outlines',
  does_sov_fills: 'the territory fills',
  does_terrain: 'the terrain layer',
  group_base: 'BASE',
  group_casino: 'CASINO — the table you sit at',
  group_debug: 'DEBUG',
  group_docked: 'DOCKED FLEET — the card of a fleet in the pens',
  group_groups: 'GROUPS — the fleet control groups',
  group_helm: 'HELM — the selected own fleet at sea',
  group_layers: 'LAYERS',
  group_map: 'MAP',
  group_menus: 'MENUS',
  group_orders: 'ORDERS — selected fleet',
  group_view: 'VIEW — map heatmaps',
};

const labkit_en: S.Labkit = {
  back_hub: 'HUB',
  back_section_title: 'back to the section',
  back_title: 'back to the hub',
  card_close_title: 'close the card',
  changed: (p: { count: number }) => plural(p.count, {
    one: `${p.count} CHANGED`,
    other: `${p.count} CHANGED`,
  }),
  fold_title: 'open or close this section',
  identity: 'identity',
  identity_dark: 'DARK',
  identity_hint: 'the labs only; a map reloads',
  identity_light: 'LIGHT',
  identity_title: 'DARK is the deep sea, LIGHT a sea chart on paper; a lab with a map reloads',
  identity_to: (p: { to: string | number }) => `${p.to} MODE`,
  layer_title: 'show or hide this layer',
  legend: 'legend',
  legend_hint: 'a row is its switch',
  legend_shown: (p: { on: string | number; all: string | number }) => `${p.on} of ${p.all} layers`,
  legend_title: 'open or close the legend',
  more: '⋯',
  more_title: 'more',
  note_less: 'LESS',
  note_more: 'MORE',
  note_more_title: 'show the whole note',
  off: 'off',
  on: 'on',
  reset: 'RESET',
  reset_one_title: 'put this value back to its default',
  reset_title: 'put every value of this section back to its default',
  sheet_title: 'raise or lower the sheet',
  zoom: (p: { pct: string | number }) => `${p.pct} %`,
  zoom_in_title: 'zoom in',
  zoom_out_title: 'zoom out',
};

const ladder_en: S.Ladder = {
  card_figures: (p: { rating: string | number; deviation: string | number }) => `RATING ${p.rating} · DEVIATION ${p.deviation}`,
  card_last: (p: { bound: string | number }) => `THE LAST TIER · ${p.bound} AND OVER`,
  card_more: 'PUBLIC QUEUE · ALL MAPS',
  card_rises: 'YOUR LADDER NUMBER RISES AS YOUR RATING SETTLES.',
  card_to_next: (p: { n: string | number; name: string | number; bound: string | number }) => `${p.n} TO ${p.name} · ${p.bound}`,
  card_unrated: 'NO RATED MATCH YET',
  card_unrated_why: 'A MATCH OF THE PUBLIC QUEUE STARTS THE CLIMB.',
  end_down: (p: { n: string | number }) => `DOWN ${p.n}`,
  end_fine: 'A PRIVATE GAME AND A DRILL DO NOT MOVE THE LADDER.',
  end_head: 'LADDER · PUBLIC QUEUE',
  end_level: 'NO CHANGE',
  end_move: (p: { from: string | number; to: string | number }) => `${p.from} → <b>${p.to}</b>`,
  end_private: 'A PRIVATE GAME DOES NOT MOVE THE LADDER.',
  end_tier: (p: { name: string | number; n: string | number; total: string | number }) => `${p.name} · TIER ${p.n} OF ${p.total}`,
  end_unrated: 'THIS MATCH DID NOT MOVE YOUR LADDER.',
  end_up: (p: { n: string | number }) => `UP ${p.n}`,
  guest_line: 'A GUEST HAS NO LADDER. AN ACCOUNT CLIMBS IT.',
  guest_register: 'REGISTER →',
  last_tier: 'THE LAST TIER',
  lobby_kick: 'PUBLIC QUEUE ONLY',
  lobby_open: 'THE LADDER →',
  lobby_title: 'LADDER',
  lobby_week: (p: { won: string | number; lost: string | number }) => `THIS WEEK <b>${p.won} WON · ${p.lost} LOST</b>`,
  next: (p: { name: string | number }) => `NEXT · ${p.name}`,
  outcome_draw: 'DRAW',
  outcome_lost: 'LOST',
  outcome_won: 'WON',
  page_all: 'ALL RANKS →',
  page_loading: 'READING YOUR LADDER …',
  page_own: 'YOUR LADDER',
  page_recent: 'LAST RATED MATCHES',
  page_recent_count: (p: { n: string | number }) => `LAST ${p.n}`,
  page_top: 'TOP OF THE LADDER',
  page_you: 'YOU',
  ranks_count: (p: { n: number }) => plural(p.n, {
    one: `${p.n} COMMANDER`,
    other: `${p.n} COMMANDERS`,
  }),
  ranks_empty: 'NOBODY IS ON THE LADDER YET',
  ranks_empty_why: (p: { days: string | number }) => `A COMMANDER JOINS THE LIST WITH A RATED MATCH OF THE LAST ${p.days} DAYS.`,
  ranks_more: 'BY TIER',
  ranks_note: 'The list prints the place and the tier. Your own ladder number stands in the LADDER section of the arcade.',
  ranks_own: 'YOUR LADDER →',
  ranks_pill: 'ARCADE LADDER',
  ranks_unplaced: '—',
  ranks_you: (p: { name: string | number }) => `${p.name} · YOU`,
  row_best: 'BEST TIER',
  row_matches: 'MATCHES ON THE LADDER',
  row_place: 'PLACE ON THE LIST',
  row_won_lost: 'WON · LOST',
  sum_guest: 'an account climbs it',
  tier_names: ['SHALLOWS', 'SUNLIT', 'TWILIGHT', 'MIDNIGHT', 'BLACKWATER', 'CRUSH'],
  tier_of: (p: { n: string | number; total: string | number }) => `TIER ${p.n} OF ${p.total}`,
  won_lost: (p: { won: string | number; lost: string | number }) => `${p.won} · ${p.lost}`,
  won_lost_drawn: (p: { won: string | number; lost: string | number; drawn: string | number }) => `${p.won} · ${p.lost} · ${p.drawn} DRAWN`,
};

const landing_en: S.Landing = {
  brand: 'AQUAPHOBIA',
  btn_busy: (p: { label: string | number }) => `${p.label} …`,
  btn_continue: 'CONTINUE',
  btn_forgot: 'FORGOT PASSWORD?',
  btn_sign_out: 'SIGN OUT',
  busy_forgot: 'SENDING THE LINK',
  busy_opening_seat: 'OPENING A SEAT',
  busy_signing_in: 'SIGNING IN',
  busy_signing_out: 'SIGNING OUT',
  commanders_at_sea: (p: { count: string | number }) => `${p.count} COMMANDERS AT SEA`,
  console_arcade_blurb: 'A short match on a small sea, alone or in a team. Each map states its win. Your first PLAY NOW opens a drill that teaches the controls.',
  console_arcade_kicker_open: 'FAST · ONE SITTING',
  console_arcade_kicker_shut: 'NOT OPEN YET',
  console_conquest_blurb: (p: { days: string | number }) => `Take ground with your squad and your faction on a living map. A season is ${p.days} days. Your captains and Honour carry over.`,
  console_conquest_kicker: 'THE FULL GAME · A SEASON LONG',
  cta_continue: '▶ CONTINUE',
  cta_opens_soon: 'OPENS SOON',
  cta_play_now: '▶ PLAY NOW',
  cta_take_a_seat: '▶ TAKE A SEAT',
  err_forgot_no_email: 'type your mail address first',
  err_password_mismatch: 'that account exists, and the password does not match it',
  fine_print: 'AQUAPHOBIA IS OPERATED FROM GERMANY. THE IMPRINT NAMES THE OPERATOR AND IS REACHABLE FROM EVERY PAGE IN ONE PRESS.',
  foot_links: ['ABOUT THIS PROJECT', 'PRESS KIT', 'CONTACT', 'IMPRINT', 'PRIVACY NOTICE', 'TERMS OF SERVICE'],
  foot_links_short: ['ABOUT THIS PROJECT', 'PRESS KIT', 'CONTACT', 'IMPRINT', 'PRIVACY', 'TERMS'],
  forgot_link_hint: (p: { button: string | number }) => `type your mail address and press ${p.button} for a new reset link`,
  forgot_sent: 'if an account holds that address, a mail with a reset link is on its way',
  guest_chip: (p: { name: string | number; honour: string | number }) => `GUEST · ${p.name} · ${p.honour} HONOUR`,
  hint_first_time: 'First time? <b>This creates the account.</b> No second form, and no mail to confirm before you play.',
  hint_guest_play: 'You can also just press a console and play as a guest. The seat follows you when you sign in later.',
  hint_guest_seat: 'This browser holds a guest seat. <b>Sign in once and it becomes an account</b>, and the captains stop living in a cookie.',
  maintenance: 'MAINTENANCE · THE GAME IS DOWN WHILE THE RELEASE IS INSTALLED',
  oauth_apple: 'APPLE',
  oauth_google: 'GOOGLE',
  oauth_or: 'OR',
  placeholder_email: 'EMAIL',
  placeholder_password: 'PASSWORD',
  rail_played_before: 'YOU PLAYED HERE BEFORE',
  rail_sign_in: 'SIGN IN OR CREATE AN ACCOUNT',
  read_account: 'ACCOUNT',
  read_account_not_needed: 'NOT NEEDED',
  read_categories_open: 'CATEGORIES',
  read_day_costs: 'A DAY COSTS',
  read_day_costs_value: 'MINUTES',
  read_empires: 'EMPIRES',
  read_in_the_water: 'IN THE WATER',
  read_matches_running: 'LIVE MATCHES',
  read_season_ends: 'SEASON ENDS IN',
  read_worlds_open: 'WORLDS OPEN',
  tagline: 'TERRITORIAL CONTROL · DEEP WATER',
};

const live_en: S.Live = {
  advisor: (p: { line: string | number }) => `Advisor: ${p.line}`,
  more: (p: { n: number }) => plural(p.n, {
    one: `and ${p.n} more notice`,
    other: `and ${p.n} more notices`,
  }),
  siege: (p: { site: string | number; at: string | number }) => `Siege warning: an enemy pledged an attack on ${p.site}. The window battle starts at ${p.at}.`,
};

const main_en: S.Main = {
  aim_base_round: (p: { round: string | number }) => `${p.round} round from the home base`,
  aim_dumb_hint: 'lead the contact — the round runs out of fuel where you aim',
  aim_out_of_reach: (p: { over: string | number }) => `${p.over} px out of reach`,
  aim_reach: (p: { reach: string | number; range: string | number }) => `${p.reach} of ${p.range} px`,
  aim_seeker_hint: 'click a contact to lock, or water to run a bearing',
  aim_title: 'Firing solution',
  base_round_default: 'heavy',
  base_tubes_ready: (p: { free: number }) => plural(p.free, {
    one: `${p.free} tube ready`,
    other: `${p.free} tubes ready`,
  }),
  base_tubes_reloading: (p: { sec: string | number }) => `every tube is reloading — ${p.sec}s`,
  commit_window_shut: (p: { place: string | number; hour: string | number }) => `${p.place} takes a pledge in its window only — it opens at ${p.hour}:00`,
  deposit_respawn: 'it will silt back up within hours',
  first_find: (p: { kind: string | number }) => `FIRST FIND · ${p.kind}`,
  fleet_condition: (p: { hull: string | number; shields: string | number }) => `hull ${p.hull} · shields ${p.shields}`,
  heatmap_off: 'HEATMAP OFF',
  heatmap_on: (p: { label: string | number }) => `HEATMAP: ${p.label}`,
  protocol_mismatch: (p: { server: string | number; client: string | number }) => `server is v${p.server}, this client is v${p.client}`,
  ridge_line: 'rock — impassable',
  ridge_title: 'Ridge',
  site_point_defense_ready: 'point defense ready',
  site_your_hold: 'your hold',
  stats_offline: (p: { retries: number }) => plural(p.retries, {
    one: `offline · ${p.retries} attempt`,
    other: `offline · ${p.retries} attempts`,
  }),
  stats_render: (p: { fps: string | number; scale: string | number; world: string | number; map: string | number; backend: string | number }) => `${p.fps} fps · ${p.scale}x gl · ${p.world}x world / ${p.map}x map · ${p.backend}`,
  stats_wire: (p: { tick: string | number; contacts: string | number; rtt: string | number; kbs: string | number }) => `tick ${p.tick} · ${p.contacts} contacts · ${p.rtt} ms · ${p.kbs} KB/s`,
  water_base_cell: 'bases cannot be taken',
  water_beam: (p: { faction: string | number; gauge: string | number }) => `${p.faction} beam — ${p.gauge}% taken`,
  water_current: (p: { n: string | number; brg: string | number }) => `current: ${p.n} px/min toward ${p.brg}°`,
  water_current_none: 'current: none',
  water_depth: (p: { band: string | number; m: string | number }) => `depth: ${p.band}, ${p.m} m`,
  water_marks: (p: { n: number }) => plural(p.n, {
    one: `${p.n} object in this cell ›`,
    other: `${p.n} objects in this cell ›`,
  }),
  water_object_tile: 'this tile belongs to the object — take the object',
  water_open_sea_title: 'Open sea',
  water_sovereignty: (p: { faction: string | number }) => `${p.faction} sovereignty`,
  water_spent: 'spent — the sea is taking this back',
  water_territory_title: 'Territory',
  water_trench: 'trench — half speed, half noise',
  water_unclaimed: 'unclaimed water',
  water_unsurveyed: 'unsurveyed water — a hull that passes surveys it',
};

const maintenance_en: S.Maintenance = {
  line_back_at: (p: { time: string | number }) => `The game comes back at ${p.time}.`,
  line_reloading: 'The game is back. Loading it now…',
  line_running_long: 'The work takes longer than planned. The page reloads by itself when the game is back.',
  note_default: 'The worlds are down while the release is installed.',
  title: 'MAINTENANCE',
};

const markers_en: S.Markers = {
  audience_faction: 'FACTION',
  audience_hint: 'who sees the marker: tap to switch',
  audience_squad: 'SQUAD',
  kind_attack: 'ATTACK',
  kind_danger: 'DANGER',
  kind_defend: 'HOLD',
  kind_gather: 'GATHER',
  mark: 'MARK',
  menu_label: 'put a map marker',
  pencil_attack: 'attack',
  pencil_danger: 'danger!',
  pencil_defend: 'hold',
  pencil_gather: 'gather',
  remove: 'REMOVE',
};

const matchCard_en: S.MatchCard = {
  bot: 'BOT',
  captains: (p: { n: number }) => plural(p.n, {
    one: `${p.n} captain`,
    other: `${p.n} captains`,
  }),
  duration: (p: { clock: string | number }) => `${p.clock} played`,
  first_picture: 'FIRST PICTURE IN',
  kept_until: (p: { date: string | number }) => `The link works until ${p.date}.`,
  live: (p: { sec: string | number }) => `LIVE · ${p.sec} SECONDS BEHIND`,
  share: 'SHARE',
  sound: 'PRESS ANYWHERE TO TURN ON THE SOUND',
  title_live: 'LIVE MATCH',
  title_replay: 'ARCADE REPLAY',
  waiting: 'WAITING FOR THE STREAM',
  watch: 'WATCH',
};

const nettest_en: S.Nettest = {
  back: 'BACK TO THE GAME',
  check_arcade_ws: 'The game host: arcade socket',
  check_catalog: 'The game host: arcade catalog',
  check_env: 'This device',
  check_game_ws: 'The game host: game socket',
  check_idle: (p: { sec: string | number }) => `The game page after ${p.sec} s with no traffic`,
  check_latency: (p: { count: string | number }) => `The game page: latency of ${p.count} requests`,
  check_maint: 'The game page: maintenance file',
  check_me: 'The game page: account',
  copied: 'COPIED',
  copy: 'COPY',
  copy_failed: 'COPY did not work. Select the text and copy it by hand.',
  env_app: 'Home Screen app',
  env_conn: (p: { type: string | number }) => `connection ${p.type}`,
  env_offline: 'offline',
  env_online: 'online',
  env_tab: 'browser tab',
  failed: (p: { reason: string | number }) => `the request failed: ${p.reason}`,
  idle_held: (p: { ms: string | number }) => `the link held: ${p.ms} ms`,
  idle_left: (p: { left: string | number }) => `waiting: ${p.left} s with no request to the game page`,
  idle_lost: 'no answer after the wait, and the retry failed too',
  idle_recovered: (p: { ms: string | number }) => `no answer after the wait; the retry answered in ${p.ms} ms`,
  idle_skip: 'skipped: the game page failed before the wait',
  latency: (p: { min: string | number; median: string | number; max: string | number }) => `min ${p.min} · median ${p.median} · max ${p.max} ms`,
  latency_lost: (p: { lost: string | number; count: string | number }) => `${p.lost} of ${p.count} requests failed`,
  lede: 'This page tests the path from this device to the game. It takes about one minute. Keep the page open and do not lock the screen.',
  maint_none: 'no maintenance',
  maint_on: 'the maintenance gate stands',
  me_in: (p: { name: string | number }) => `signed in as ${p.name}`,
  me_out: 'not signed in',
  ms: (p: { ms: string | number }) => `${p.ms} ms`,
  ms_proto: (p: { ms: string | number; proto: string | number }) => `${p.ms} ms · ${p.proto}`,
  no_host: 'skipped: this address names no game host',
  report_text: (p: { verdict: string | number }) => `Network check: ${p.verdict}`,
  rerun: 'RUN AGAIN',
  result: 'THE RESULT',
  send: 'SEND TO THE TEAM',
  send_failed: (p: { reason: string | number }) => `The result was not sent: ${p.reason}. Use COPY.`,
  send_wait: (p: { wait: string | number }) => `This device sent a report a short time ago. SEND works again in ${p.wait}.`,
  sending: 'SENDING',
  sent: (p: { ref: string | number }) => `Sent. Give the reference ${p.ref} to the team.`,
  signed_out: 'Sign in to the game to send this result. You can COPY it and send it by mail.',
  state_fail: 'FAIL',
  state_ok: 'OK',
  state_run: 'TESTING',
  state_skip: 'SKIP',
  state_slow: 'SLOW',
  state_wait: 'WAIT',
  status: (p: { status: string | number }) => `unexpected answer: HTTP ${p.status}`,
  timeout: (p: { ms: string | number }) => `no answer in ${p.ms} ms`,
  title: 'NETWORK CHECK',
  verdict_host: (p: { ports: string | number }) => `The game page answers, but the game host does not. A firewall or a filter probably blocks the ports ${p.ports}.`,
  verdict_idle: 'The network dropped an idle connection. A router probably closed the idle UDP mapping of an HTTP/3 connection. Try mobile data, or restart the router, and send this result to the team.',
  verdict_maint: 'The game is in maintenance now. Run the check again after the window.',
  verdict_offline: 'This device says that it is offline. Connect it to a network, then run the check again.',
  verdict_ok: 'Every check passed. The network between this device and the game works.',
  verdict_running: 'The checks run.',
  verdict_site: 'The game page does not answer. The network, or a filter on it, blocks the site.',
  verdict_slow: 'Every check passed, but some answers were slow.',
  ws_closed: (p: { ms: string | number; code: string | number }) => `opened in ${p.ms} ms; the server closed it with code ${p.code}`,
  ws_failed: (p: { code: string | number }) => `did not open (code ${p.code})`,
  ws_open: (p: { ms: string | number }) => `opened in ${p.ms} ms`,
  ws_timeout: (p: { ms: string | number }) => `did not open in ${p.ms} ms`,
};

const notices_en: S.Notices = {
  glyph_error: '⚠',
  glyph_link: '⌁',
  glyph_maintenance: '⚙',
  glyph_note: '✓',
  glyph_quake: '≋',
  glyph_seaview: '∿',
  glyph_truce: '⚑',
  go_tell: 'GO TO ›',
  lane_more: (p: { n: number }) => plural(p.n, {
    one: `+${p.n}`,
    other: `+${p.n}`,
  }),
  ribbon_more: (p: { n: number }) => plural(p.n, {
    one: `+${p.n} MORE`,
    other: `+${p.n} MORE`,
  }),
  timer_card_label: 'NEW SEASON',
  timer_card_short: 'NEW SEASON',
  timer_card_tail: 'new season',
  timer_floor_shift: 'FLOOR SHIFT',
  timer_link_label: 'CONNECTION LOST',
  timer_link_short: 'LINK',
  timer_link_tail: 'until the retry',
  timer_maintenance_label: 'MAINTENANCE',
  timer_maintenance_sentence: (p: { left: string | number }) => `MAINTENANCE · the worlds close in ${p.left}`,
  timer_maintenance_short: 'MAINT',
  timer_quake_label: 'SEAQUAKE',
  timer_quake_tail: (p: { stage: string | number }) => `seaquake stage ${p.stage}`,
  timer_seaview_label: 'SEA VIEW',
  timer_seaview_sentence: (p: { left: string | number }) => `SEA VIEW · starts in ${p.left} · any input stops it`,
  timer_seaview_short: 'SEA',
  timer_seaview_tail: 'until the sea view',
  timer_settlement: 'SETTLEMENT',
  timer_truce_label: 'FOUNDING TRUCE',
  timer_truce_short: 'TRUCE',
  timer_truce_tail: 'until weapons free',
  timer_war_economy: 'WAR ECONOMY',
};

const options_en: S.Options = {
  acc_hub: 'IN THE HUB',
  acc_hub_aside: 'a press leaves the world',
  account_none: 'This page has no signed-in account, so it shows no account rows.',
  alerts_none: 'Push alerts need a signed-in account. This page runs without one.',
  arcade: 'ARCADE',
  arcade_title: 'open the arcade — the seat waits',
  casino_desk_docked: 'DOCKED',
  casino_desk_undocked: 'UNDOCKED',
  changed_title: 'changed from the default',
  chart_historical: 'HISTORICAL',
  chart_modern: 'MODERN',
  chart_off: 'OFF',
  chat_desk_docked: 'DOCKED',
  chat_desk_large: 'LARGE',
  chat_desk_small: 'SMALL',
  chat_how: 'BLOCK under a chat line adds an account, in the clan chat and in the game. This list only lifts a block.',
  chat_none: 'The block list needs a signed-in account. This page runs without one.',
  close_title: 'close',
  dev_current: (p: { build: string | number }) => `build ${p.build} is current`,
  esc: 'ESC',
  guest_lede: 'This is a guest seat. Link a sign-in method and the seat becomes an account. It keeps the captains and the Honour it has now.',
  head_line: (p: { world: string | number; day: string | number }) => `${p.world} · day ${p.day}`,
  hub_foot: 'The hub leaves the world. Your seat waits.',
  identity_confirm: 'The page reloads in the new identity. Your seat waits.',
  identity_dark: 'DARK',
  identity_light: 'LIGHT',
  kind_guest: 'GUEST',
  kind_registered: 'REGISTERED',
  lang_confirm: 'The page reloads in the new language. Your seat waits.',
  lang_go: 'RELOAD NOW',
  lang_no: 'CANCEL',
  leave_days: (p: { n: string | number }) => `${p.n} DAYS`,
  leave_hub: 'LEAVE TO THE HUB',
  leave_hub_title: 'leave the world for the hub — the seat waits',
  leave_long: 'Pick how long you are away. While the leave holds and no client sits at your seat, standing orders keep your Core empire, with no wait. A login stops them until you leave the game again. The standing orders switch must be on.',
  leave_off: 'OFF',
  leave_until: (p: { at: string | number }) => `On leave until ${p.at}. The leave ends by itself.`,
  legend_account: 'every device you sign in on',
  legend_changed: 'changed from the default',
  legend_device: 'this browser only',
  legend_empire: 'your empire in this world',
  legend_nomark: 'no mark',
  link_delete: 'delete the account',
  link_delete_what: 'two presses, with the name typed',
  link_hours: 'stated hours',
  link_hours_what: 'the hours the squad finder reads',
  link_password: 'password',
  link_password_what: 'change it; every other browser signs out',
  link_signin: 'sign-in methods',
  link_signin_what: 'link EMAIL, GOOGLE or APPLE to the account',
  link_themes: 'themes',
  link_themes_what: 'the UI theme, the playlist, the SFX theme and the four looks: the MODDING tab',
  logout: 'LOG OUT',
  logout_armed: 'LOG OUT?',
  logout_armed_what: 'your empire keeps playing and the seat waits for you — but a guest account cannot come back',
  logout_what: 'end the session on this device',
  me_pickup: 'PICKUP',
  mute_title: (p: { name: string | number }) => `mute the ${p.name}; the level stays`,
  no_audio: 'No sound is available yet, so nothing plays.',
  quick: 'QUICK',
  quick_advisor: 'ADVISOR',
  quick_effects: 'EFFECTS',
  quick_music: 'MUSIC',
  quick_shake: 'SCREEN SHAKE',
  register: 'REGISTER',
  register_title: 'open the hub SETTINGS to link a sign-in method',
  row_advisor: 'advisor',
  row_advisor_what: 'one next good job, above the queue',
  row_casino_desk: 'desktop casino',
  row_casino_desk_what: 'UNDOCKED opens the casino wide over the map; DOCKED stands it in the dock column. A telephone keeps its sheet',
  row_chart: 'chart',
  row_chart_what: 'the sea-chart furniture: off, the historical reading or the modern one · also in VIEW',
  row_chat_count: 'unread chat count',
  row_chat_count_what: 'the figure of unread lines on VIEW, on the CHAT tile and on the chat line; the channel tabs keep theirs',
  row_chat_desk: 'desktop chat',
  row_chat_desk_what: 'SMALL and LARGE float the chat box at the bottom left of the map; DOCKED stands the chat at the foot of the dock column. A telephone keeps its chat band',
  row_chat_filter: 'chat filter',
  row_chat_filter_what: 'masks strong profanity and slurs in each chat line with •, on this device alone',
  row_chat_time: 'chat time stamps',
  row_chat_time_what: (p: { zone: string | number }) => `[HH:MM] in front of each chat line: the time it was sent, a replayed clan line too, on the clock of this device in the time zone ${p.zone}`,
  row_devstats: 'dev stats',
  row_devstats_what: 'the tick, the link and the frame figures at the top left of the map',
  row_fluff: 'ambient fluff',
  row_fluff_what: 'sea life, snow, wakes, silt',
  row_identity: 'identity',
  row_identity_what: 'DARK is the deep sea; LIGHT is a sea chart on paper, with light panels. A change reloads the page; the seat waits.',
  row_inbox_count: 'unread INBOX count',
  row_inbox_count_what: 'the figure of unread items on INBOX; the items stay unread',
  row_keys: 'keyboard shortcuts',
  row_keys_btn: 'KEYS',
  row_keys_what: 'list every key and the control it works',
  row_lang: 'language',
  row_lang_what: 'The game starts in English. A change reloads the page; the seat waits.',
  row_leave: 'on leave',
  row_leave_what: 'standing orders keep your Core empire at once while no client sits at it',
  row_mark_arcade: 'mark scale · arcade',
  row_mark_arcade_what: 'the size of the fleets and the torpedoes of an arcade match; the map and every range keep their size',
  row_mark_core: 'mark scale · core',
  row_mark_core_what: 'the size of the fleets and the torpedoes of the season map; the map and every range keep their size',
  row_mirror: 'mirrored layout',
  row_mirror_what: 'ON puts the chat, VIEW, the minimap and the cards on the right, next to the build menu, and the legend on the left. A telephone keeps its layout',
  row_music: 'music',
  row_music_what: 'the background score',
  row_nettest: 'network check',
  row_nettest_btn: 'CHECK',
  row_nettest_what: 'test the path from this device to the game',
  row_photo: 'photo mode',
  row_photo_btn: 'PHOTO',
  row_photo_what: 'hide the chrome and save a picture of the map',
  row_player: 'music player',
  row_player_btn: 'OPEN',
  row_player_what: 'pick a track, pause and skip',
  row_render: 'render scale',
  row_render_what: 'the share of the screen\'s pixels the map draws; a lower step runs a large screen faster, and the panels stay sharp',
  row_report: 'report a problem',
  row_report_btn: 'REPORT',
  row_report_what: 'send a note and the facts of this moment',
  row_scale: 'UI scale',
  row_scale_what: 'the size of the text and the panels; the map keeps its size',
  row_seaidle: 'idle sea view',
  row_seaidle_min: 'after',
  row_seaidle_min_what: 'the idle time before the sea view starts',
  row_seaidle_what: 'with no input for the idle time, the map blends into the sea view and its ACTION tour. Any key comes back to the map; SPACE keeps the free sea view',
  row_sealife: 'sea life',
  row_sealife_what: 'the sea view draws the fish, the plankton glow and the growth of the seabed. Off, it draws the hulls, the fights and the things of the world alone',
  row_seapower: 'power saver',
  row_seapower_what: 'the sea view draws fewer frames and fewer details, so the device uses less battery and stays cooler. The hulls, the fights and the things of the world stay',
  row_seaveil: 'survey veil',
  row_seaveil_what: 'the sea view lays a dark veil over the water that the survey of your faction does not hold. The map keeps its own survey hatch',
  row_sfx: 'effects',
  row_sfx_what: 'torpedoes, sieges, the yard and the ledger',
  row_shake: 'screen shake',
  row_shake_what: 'the seaquake shudders the view',
  row_sheets: 'sheet heights',
  row_sheets_what: 'TWO opens a menu at the full height or puts it away; THREE adds the half height and the grip',
  row_sonar: 'sonar visuals',
  row_sonar_what: 'coverage rings, pings, contact blips',
  row_standing: 'standing orders',
  row_standing_what: 'the autopilot keeps your empire while you are away',
  row_tab_dots: 'tab dots',
  row_tab_dots_what: 'a dot on a game tab says that something under it waits for you',
  row_tabs: 'tab labels',
  row_tabs_what: 'how the six menu tabs show their name on a telephone. GLYPH + WORD puts the short word under the glyph where it fits',
  row_takeover: 'sound takeover',
  row_takeover_what: 'off, another app keeps its sound; on, the game takes the sound and is heard in silent mode',
  row_theme: 'UI theme',
  row_theme_what: 'the colours of the panels and the menus; make a custom theme in the hub MODDING tab',
  scale_step: (p: { percent: string | number }) => `${p.percent}%`,
  scope_device: 'DEVICE',
  scope_device_title: 'this browser only',
  scope_empire: 'EMPIRE',
  scope_empire_title: 'your empire in this world',
  seaidle_min_fig: (p: { min: string | number }) => `${p.min} MIN`,
  seaidle_min_label: 'idle time in minutes',
  sec_account: 'ACCOUNT',
  sec_account_what: 'your account, the hub rows and the log out',
  sec_alerts: 'ALERTS',
  sec_alerts_what: 'push and buzz on this device',
  sec_audio: 'AUDIO',
  sec_audio_what: 'music, effects and the player',
  sec_help: 'HELP',
  sec_help_what: 'keys, photo mode and problem reports',
  sec_iface: 'INTERFACE',
  sec_iface_what: 'the colours and the size of the chrome, and the language',
  sec_map: 'MAP',
  sec_map_what: 'what the sea shows',
  sec_play: 'PLAY',
  sec_play_what: 'aids, and your empire while you are away',
  sec_seaview: 'SEA VIEW',
  sec_seaview_what: 'the sea view that starts while you are idle',
  sec_social: 'SOCIAL',
  sec_social_what: 'the unread counts, and who you hear',
  sections: 'SECTIONS',
  session: 'SESSION',
  sheets_three: 'THREE',
  sheets_two: 'TWO',
  standing_checking: 'CHECKING',
  standing_long: (p: { hours: string | number }) => `While you hold a seat in an open Event or Clan War, the autopilot keeps your Core empire: it fills the build queue, sends Dredgers to safe fields and defends. It starts no attack, and it leaves alone a fleet you gave an order to. It also keeps the empire after ${p.hours} hours with no client, and at once while you are on leave. Your next login stops that.`,
  standing_mark: 'WEEKEND',
  sum_alerts: 'push · buzz · quiet hours',
  sum_audio: (p: { music: string | number; sfx: string | number }) => `music ${p.music} · effects ${p.sfx}`,
  sum_audio_none: 'no sound yet',
  sum_blocked: (p: { count: number }) => plural(p.count, {
    one: `${p.count} blocked`,
    other: `${p.count} blocked`,
  }),
  sum_chart_historical: 'historical',
  sum_chart_modern: 'modern',
  sum_chart_off: 'off',
  sum_chat_count_off: 'chat count off',
  sum_chat_time_on: (p: { counts: string | number }) => `${p.counts} · time stamps`,
  sum_counts_off: 'counts off',
  sum_counts_on: 'counts on',
  sum_help: 'keys · photo · report',
  sum_iface: (p: { theme: string | number; scale: string | number; lang: string | number }) => `${p.theme} · ${p.scale}% · ${p.lang}`,
  sum_inbox_count_off: 'INBOX count off',
  sum_map: (p: { chart: string | number; sonar: string | number }) => `chart ${p.chart} · sonar ${p.sonar}`,
  sum_no_account: 'needs an account',
  sum_off: 'off',
  sum_on: 'on',
  sum_play: (p: { advisor: string | number }) => `advisor ${p.advisor}`,
  sum_play_standing: (p: { advisor: string | number; standing: string | number }) => `advisor ${p.advisor} · standing orders ${p.standing}`,
  sum_seaview_off: 'idle start off',
  sum_seaview_on: (p: { min: string | number }) => `idle start after ${p.min} min`,
  sum_social: (p: { counts: string | number; blocked: string | number }) => `${p.counts} · ${p.blocked}`,
  tabs_glyph: 'GLYPH',
  tabs_word: 'GLYPH + WORD',
  theme_auto: 'AUTO',
  theme_custom: (p: { code: string | number }) => `CUSTOM · ${p.code}`,
  theme_custom_none: 'CUSTOM',
  theme_next: 'next UI theme',
  theme_prev: 'previous UI theme',
  title: 'OPTIONS',
  unmute_title: (p: { name: string | number }) => `turn the ${p.name} on`,
  vol_label: (p: { name: string | number }) => `${p.name} volume`,
  vol_note: '◖) mutes a sound and keeps its level for the next press.',
  where_account: 'The account rows change no part of the game screen.',
  where_alerts: 'Push and buzz act outside the game page: push on the lock screen of this device, buzz on a telephone alone.',
  where_audio: 'Sound has no place on the screen. Music and effects play in the hub and in every world on this device.',
  where_desk: 'DESKTOP',
  where_iface: 'The UI scale and the language change all the chrome and not the sea. The sheet heights change the sheet of a telephone alone. The mirrored layout moves the chat, VIEW, the minimap and the cards of a desktop next to the dock.',
  where_map: 'These rows change the sea itself: the chart, the sonar marks, the fluff and the shake. The compass rose follows the chart reading.',
  where_phone: 'TELEPHONE',
  where_play: 'The advisor speaks on the peek line of the dock. The standing orders act while you are away, and their mark stands with your name.',
  where_seaview: 'While you are idle, the sea view covers the whole screen. A countdown stands in the readout line first.',
  where_social: 'The chat count stands on the VIEW button and the INBOX count on INBOX. A blocked commander leaves your chat.',
  where_title: 'WHERE IT SHOWS',
  who_title: 'open the ACCOUNT page',
  word_na: 'N/A',
  word_na_title: 'not available here: the line above says why',
  word_off: 'OFF',
  word_on: 'ON',
};

export const tables = {
  effects: effects_en,
  fast: fast_en,
  format: format_en,
  glossary: glossary_en,
  guestWarn: guestWarn_en,
  howPlays: howPlays_en,
  hub: hub_en,
  hubAlerts: hubAlerts_en,
  hubBlocks: hubBlocks_en,
  hubChatRelay: hubChatRelay_en,
  hubClan: hubClan_en,
  hubCup: hubCup_en,
  hubCustom: hubCustom_en,
  hubDailyPlan: hubDailyPlan_en,
  hubDiscord: hubDiscord_en,
  hubHours: hubHours_en,
  hubMods: hubMods_en,
  hubNews: hubNews_en,
  hubPanel: hubPanel_en,
  hubPickup: hubPickup_en,
  hubPlay: hubPlay_en,
  hubRanks: hubRanks_en,
  hubRecord: hubRecord_en,
  hubReport: hubReport_en,
  hubSettings: hubSettings_en,
  hubShop: hubShop_en,
  hubState: hubState_en,
  hubSupport: hubSupport_en,
  hubWardroom: hubWardroom_en,
  impersonation: impersonation_en,
  inbox: inbox_en,
  inboxNeeds: inboxNeeds_en,
  keymap: keymap_en,
  labkit: labkit_en,
  ladder: ladder_en,
  landing: landing_en,
  live: live_en,
  main: main_en,
  maintenance: maintenance_en,
  markers: markers_en,
  matchCard: matchCard_en,
  nettest: nettest_en,
  notices: notices_en,
  options: options_en,
} satisfies Partial<S.StringTables>;
